/* Sahasenin Tournament Wizard
 * View bağımlılığını kaldırır: turnuva oluşturma/düzenleme ekranı tamamen JS ile render edilir.
 * Gereksinimler: jQuery, Bootstrap sınıfları. Opsiyonel: Swal, createModal, s2Each, dateInputLoad.
 */
(function (window, $) {
    'use strict';

    if (!$) {
        console.error('TournamentBuilder requires jQuery.');
        return;
    }

    const API = '/Tournament';
    const DEFAULT_IMG = 'https://sahasenin.com/imageNull.webp';
    const AVATAR_IMG = 'https://sahasenin.com/avatar.webp';
    const NS = '.TournamentBuilder';

    const state = {
        data: null,
        activeStep: 'base',
        loading: false,
        dirty: false,
        host: null,
        stepSnapshot: null,
        snapshotStep: null,
        stepFingerprint: null,
        trackingPaused: false,
        awardFormOpen: false,
        awardFormDefinitionId: 0,
        awardEditRelationId: 0,
        awardEditDefinitionId: 0,
        awardEditAwardId: 0,
        documentEditRowKey: '',
        dragging: null,
        pointerDragging: null,
        historyToken: null
    };

    const steps = [
        { key: 'base', title: 'Genel', icon: 'fa-trophy' },
        { key: 'fixture', title: 'Fikstür', icon: 'fa-diagram-project' },
        { key: 'rules', title: 'Kurallar', icon: 'fa-scale-balanced' },
        { key: 'statistics', title: 'İstatistik', icon: 'fa-chart-simple' },
        { key: 'bests', title: 'Enler', icon: 'fa-ranking-star' },
        { key: 'documents', title: 'Sözleşme', icon: 'fa-file-signature' },
        { key: 'news', title: 'Blog', icon: 'fa-newspaper' },
        { key: 'media', title: 'Medya', icon: 'fa-images' },
        { key: 'awards', title: 'Ödül', icon: 'fa-award' },
        { key: 'services', title: 'Hizmet', icon: 'fa-tags' },
        { key: 'teams', title: 'Takım', icon: 'fa-people-group' },
        { key: 'publish', title: 'Yayın', icon: 'fa-bullhorn' }
    ];

    function lowerFirst(key) {
        if (!key || key[0] === '_' || key[0] === key[0].toLowerCase()) return key;
        return key[0].toLowerCase() + key.slice(1);
    }

    function normalizeKeys(value) {
        if ($.isArray(value)) return $.map(value, normalizeKeys);
        if (value && typeof value === 'object') {
            const result = {};
            Object.keys(value).forEach(function (key) {
                result[lowerFirst(key)] = normalizeKeys(value[key]);
            });
            return result;
        }
        return value;
    }

    function h(value) {
        return $('<div/>').text(value == null ? '' : String(value)).html();
    }

    function attr(value) {
        return h(value).replace(/"/g, '&quot;');
    }

    function safeHtml(value) {
        const raw = value == null ? '' : String(value);
        const $html = $('<div/>').html(raw);
        $html.find('script, iframe, object, embed, link, meta').remove();
        $html.find('*').each(function () {
            $.each(this.attributes || [], function (_, item) {
                const name = item.name || '';
                const val = item.value || '';
                if (/^on/i.test(name) || /^javascript:/i.test(val.trim())) {
                    $(item.ownerElement).removeAttr(name);
                }
            });
        });
        return $html.html() || '';
    }

    function n(value, fallback) {
        const parsed = parseInt(value, 10);
        return Number.isFinite(parsed) ? parsed : (fallback || 0);
    }

    function boolValue(value) {
        return value === true || value === 'true' || value === 'True' || value === 1 || value === '1';
    }

    function dateInputValue(value) {
        if (!value) return '';
        const raw = String(value);
        if (/^\d{4}-\d{2}-\d{2}/.test(raw)) return raw.substring(0, 10);
        const d = SahaseninTime.parse(raw);
        return d ? SahaseninTime.dateKey(d) : '';
    }

    function normalizeClockList(value) {
        const list = String(value || '')
            .split(/[;,]/)
            .map(function (x) { return $.trim(x); })
            .filter(function (x) { return /^\d{1,2}:\d{2}$/.test(x); })
            .map(function (x) {
                const parts = x.split(':');
                return `${String(Math.max(0, Math.min(23, n(parts[0])))).padStart(2, '0')}:${String(Math.max(0, Math.min(59, n(parts[1])))).padStart(2, '0')}`;
            });
        const seen = {};
        return list.filter(function (x) {
            if (seen[x]) return false;
            seen[x] = true;
            return true;
        });
    }

    function sortByOrderThenName(a, b) {
        const ao = n(a.sortOrder);
        const bo = n(b.sortOrder);
        if (ao !== bo) return (ao || 999999) - (bo || 999999);
        return String(a.name || '').localeCompare(String(b.name || ''), 'tr');
    }

    function compactFixtureSlotLabel(slotLabel, slotIndex, side) {
        const raw = $.trim(slotLabel == null ? '' : String(slotLabel));
        const index = n(slotIndex);
        const lower = raw.toLocaleLowerCase('tr-TR');

        if (raw && (lower.indexOf('bekleyen') >= 0 || lower.indexOf('kazanan') >= 0)) {
            return raw;
        }

        let number = index;
        if (number <= 0 && raw) {
            const matches = raw.match(/\d+/g);
            if (matches && matches.length) {
                number = n(matches[matches.length - 1]);
            }
        }

        if (number > 0) return `Takım ${String(number).padStart(2, '0')}`;
        if (raw) return raw.replace(/\bslot\b/ig, 'Takım');
        return side === 'away' ? 'Rakip Takım' : 'Ev Sahibi Takım';
    }

    function sameFixtureText(a, b) {
        return $.trim(String(a || '')).toLocaleLowerCase('tr-TR') === $.trim(String(b || '')).toLocaleLowerCase('tr-TR');
    }

    function normalizeFixtureGameType(value) {
        const gameType = n(value, 1);
        return gameType === 4 ? 2 : gameType;
    }

    function filterTournamentGameTypeOptions(options) {
        return (options || []).filter(function (option) {
            const text = String(option.text || '').toLocaleLowerCase('tr-TR');
            return n(option.value) !== 4 && text.indexOf('bağımsız') < 0 && text.indexOf('bagimsiz') < 0;
        });
    }

    function isGroupFixtureMode(gameType) {
        gameType = normalizeFixtureGameType(gameType);
        return gameType === 2 || gameType === 3;
    }

    function getFixtureGroupCount() {
        const t = (state.data && state.data.tournament) || {};
        return isGroupFixtureMode(t.tournamentGameTypeEnum) ? Math.max(0, n(t.groupCount)) : 0;
    }

    function shouldShowTeamGroupSelection() {
        return getFixtureGroupCount() > 1;
    }

    function request(options) {
        const ajaxOptions = $.extend({ cache: false }, options || {});
        return $.ajax(ajaxOptions).then(function (response) {
            return normalizeKeys(response);
        }).catch(function (xhr) {
            throw xhr;
        });
    }

    function getError(xhr) {
        if (!xhr) return 'Bilinmeyen bir hata oluştu.';
        if (xhr.responseJSON && xhr.responseJSON.message) return xhr.responseJSON.message;
        if (xhr.responseText) return xhr.responseText;
        if (xhr.statusText) return xhr.statusText;
        return 'Bilinmeyen bir hata oluştu.';
    }

    function notifySuccess(message) {
        // Başarı bildirimi istenmiyor. Sadece hata/uyarı akışı görünür kalır.
        return;
    }

    function notifyError(error) {
        const message = typeof error === 'string' ? error : getError(error);
        if (window.Swal) {
            Swal.fire('Uyarı', message, 'warning');
            return;
        }
        alert(message);
    }

    function confirmDialog(message, title) {
        if (window.Swal) {
            return Swal.fire({
                title: title || 'Emin misiniz?',
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Evet',
                cancelButtonText: 'Hayır'
            }).then(function (r) { return !!r.isConfirmed; });
        }
        return $.Deferred().resolve(window.confirm(message)).promise();
    }


    function cloneData(value) {
        if (value == null) return value;
        return JSON.parse(JSON.stringify(value));
    }

    function stableStringify(value) {
        const seen = new WeakSet();
        function normalize(input) {
            if (input == null) return input;
            if (typeof input !== 'object') return input;
            if (seen.has(input)) return null;
            seen.add(input);
            if ($.isArray(input)) return input.map(normalize);
            const result = {};
            Object.keys(input).sort().forEach(function (key) {
                if (typeof input[key] !== 'function') result[key] = normalize(input[key]);
            });
            return result;
        }
        return JSON.stringify(normalize(value));
    }

    function formSnapshot($form) {
        const data = {};
        if (!$form || !$form.length) return data;

        $.each($form.serializeArray(), function (_, item) {
            const name = item.name || '';
            if (!name) return;

            const value = item.value == null ? '' : String(item.value);
            if (data[name] === undefined) {
                data[name] = value;
            } else if ($.isArray(data[name])) {
                data[name].push(value);
            } else {
                data[name] = [data[name], value];
            }
        });

        $form.find('select[multiple][name]').each(function () {
            const name = this.name;
            data[name] = $.map($(this).val() || [], function (value) { return String(value); });
        });

        $form.find('input[type="checkbox"][name]').each(function () {
            data[this.name] = $(this).is(':checked') ? 'true' : 'false';
        });

        if (typeof editorInstances !== 'undefined') {
            editorInstances.forEach(function (editorData) {
                if (!editorData.name) return;
                if ($form.find(`[name="${editorData.name}"]`).length) {
                    data[editorData.name] = editorData.editor.getData();
                }
            });
        }

        Object.keys(data).forEach(function (key) {
            if (!$.isArray(data[key])) return;
            data[key] = data[key].map(function (value) { return String(value); }).sort(function (a, b) {
                const na = Number(a);
                const nb = Number(b);
                if (Number.isFinite(na) && Number.isFinite(nb)) return na - nb;
                return a.localeCompare(b);
            });
        });

        return data;
    }

    function awardSnapshot() {
        return collectAwardRelationsFromDom();
    }

    function serviceSnapshot() {
        return $('.tw-service-card.active').map(function () { return n($(this).data('service-id')); }).get();
    }

    function statisticVisibilitySnapshot() {
        return $('.tw-stat-definition-toggle:checked').map(function () {
            return n($(this).data('definition-id'));
        }).get().sort(function (a, b) { return a - b; });
    }

    function fixtureExtrasSnapshot() {
        return {
            groups: collectFixtureGroups(),
            groupTeams: collectFixtureGroupTeams()
        };
    }

    function currentStepFingerprint() {
        if (state.activeStep === 'base') return { step: 'base', form: formSnapshot($('#TournamentBaseForm')) };
        if (state.activeStep === 'fixture') return { step: 'fixture', form: formSnapshot($('#TournamentFixtureForm')), extra: fixtureExtrasSnapshot() };
        if (state.activeStep === 'rules') return { step: 'rules', form: formSnapshot($('#TournamentRulesForm')), groups: collectFixtureGroups() };
        if (state.activeStep === 'statistics' || state.activeStep === 'bests') return { step: state.activeStep, visible: statisticVisibilitySnapshot() };
        if (state.activeStep === 'services') return { step: 'services', selected: serviceSnapshot() };
        if (state.activeStep === 'awards') return { step: 'awards', awards: awardSnapshot() };
        if (state.activeStep === 'documents') return { step: 'documents', documents: documentSnapshot() };
        if (state.activeStep === 'news') return { step: 'news', posts: (state.data.posts || []).map(function (x) { return n(x.postId); }).sort(function (a, b) { return a - b; }) };
        if (state.activeStep === 'media') return { step: 'media', galleries: $('.tw-gallery-sortable-item').map(function () { return n($(this).data('gallery-id')); }).get() };
        if (state.activeStep === 'teams') return {
            step: 'teams',
            teams: (state.data.teamRelations || []).map(function (x) {
                return { teamId: n(x.teamId), accepted: boolValue(x.accepted) };
            }).sort(function (a, b) { return a.teamId - b.teamId; }),
            groupTeams: collectFixtureGroupTeams()
        };
        if (state.activeStep === 'publish') return { step: 'publish', tournament: state.data && state.data.tournament ? { draft: boolValue(state.data.tournament.draft) } : {} };
        return { step: state.activeStep };
    }

    function captureStepSnapshot(force) {
        if (!state.data) return;
        if (!force && state.dirty) {
            updateDirtyUi();
            return;
        }
        state.stepSnapshot = cloneData(state.data);
        state.snapshotStep = state.activeStep;
        state.stepFingerprint = stableStringify(currentStepFingerprint());
        updateDirtyUi();
    }

    function isCurrentStepReallyDirty() {
        if (!state.data || !state.stepFingerprint || state.snapshotStep !== state.activeStep) return false;
        return stableStringify(currentStepFingerprint()) !== state.stepFingerprint;
    }

    function getCurrentDirtyState() {
        if (state.loading || state.trackingPaused || !state.data) return !!state.dirty && isCurrentStepReallyDirty();
        return isCurrentStepReallyDirty();
    }

    function updateDirtyUi() {
        const dirty = getCurrentDirtyState();
        const disableSave = !dirty || !!state.loading;

        state.dirty = dirty;

        $('.tw-main').toggleClass('is-dirty', dirty);

        $('.tw-dirty-indicator').each(function () {
            $(this)
                .toggleClass('d-none', !dirty)
                .attr('aria-hidden', dirty ? 'false' : 'true');
        });

        $('.tw-discard-changes')
            .toggleClass('d-none', !dirty)
            .prop('disabled', !dirty || !!state.loading);

        $('.tw-save-action, .tw-header-save')
            .prop('disabled', disableSave)
            .toggleClass('disabled', disableSave);
    }

    function markDirty() {
        if (state.loading || state.trackingPaused || !state.data) return;

        if (!state.stepFingerprint || state.snapshotStep !== state.activeStep) {
            captureStepSnapshot(true);
            updateDirtyUi();
            return;
        }

        updateDirtyUi();
    }


    function markDirtyBeforeStateRender() {
        if (state.loading || !state.data) return;
        state.dirty = true;
    }

    function markClean() {
        state.dirty = false;
        state.stepSnapshot = null;
        state.snapshotStep = null;
        state.stepFingerprint = null;
        captureStepSnapshot(true);
        updateDirtyUi();
    }

    function restoreStepSnapshot(shouldRender) {
        if (state.stepSnapshot) state.data = cloneData(state.stepSnapshot);
        state.dirty = false;
        state.awardFormOpen = false;
        state.awardFormDefinitionId = 0;
        state.awardEditRelationId = 0;
        state.awardEditDefinitionId = 0;
        state.awardEditAwardId = 0;
        state.stepFingerprint = null;
        if (shouldRender !== false) render();
        else updateDirtyUi();
    }

    function discardCurrentStepChanges() {
        updateDirtyUi();
        if (!state.dirty) return;
        restoreStepSnapshot(true);
    }

    function setRemoteState(response, fallbackState) {
        state.data = response && response.state ? response.state : (response || fallbackState || state.data);
        state.awardFormOpen = false;
        state.awardFormDefinitionId = 0;
        state.awardEditRelationId = 0;
        state.awardEditDefinitionId = 0;
        state.awardEditAwardId = 0;
        markClean();
    }

    function stepActionsHtml(saveClass, saveText, extraHtml) {
        return `
            <div class="tw-actions-inline tw-step-actions">
                <span class="tw-dirty-indicator fs-07 d-none"><i class="fa-solid fa-circle-exclamation me-1"></i>Kaydedilmedi</span>
                ${extraHtml || ''}
                <button type="button" class="btn btn-light fs-07 border-ff tw-discard-changes d-none" disabled><i class="fa-solid fa-rotate-left me-1"></i>Geri Al</button>
                <button type="button" class="btn btn-primary fs-07 tw-save-action ${attr(saveClass || 'tw-primary-save')}"><i class="fa-solid fa-floppy-disk me-1"></i>${h(saveText || 'Kaydet')}</button>
            </div>`;
    }

    function setLoading(isLoading, text) {
        state.loading = isLoading;
        $('.tw-loading-text').text(text || 'Yükleniyor...');
        $('.tw-main').toggleClass('is-loading', !!isLoading);
        $('.tw-loader').toggleClass('d-none', !isLoading);
        updateDirtyUi();
    }

    function optionsHtml(options, value, emptyText) {
        const selectedValue = String(value == null ? 0 : value);
        let html = emptyText ? `<option value="0">${h(emptyText)}</option>` : '';
        $.each(options || [], function (_, option) {
            const val = String(option.value);
            html += `<option value="${attr(val)}" ${val === selectedValue ? 'selected' : ''}>${h(option.text)}</option>`;
        });
        return html;
    }

    function optionsMultiHtml(options, values) {
        const selected = new Set($.map(values || [], function (x) { return String(x); }));
        let html = '';
        $.each(options || [], function (_, option) {
            const val = String(option.value);
            html += `<option value="${attr(val)}" ${selected.has(val) ? 'selected' : ''}>${h(option.text)}</option>`;
        });
        return html;
    }

    function normalizeMultiIds(values, fallback) {
        const result = [];
        $.each(values || [], function (_, value) {
            const id = n(value);
            if (id > 0 && result.indexOf(id) < 0) result.push(id);
        });
        const fallbackId = n(fallback);
        if (!result.length && fallbackId > 0) result.push(fallbackId);
        return result;
    }

    function boolOptions(value) {
        const selected = boolValue(value);
        return `
            <option value="true" ${selected ? 'selected' : ''}>Aktif</option>
            <option value="false" ${!selected ? 'selected' : ''}>Pasif</option>`;
    }

    function cityOptions(value) {
        const selectedValue = String(value || 0);
        let html = '<option value="0">Şehir seç</option>';
        $.each((state.data && state.data.cities) || [], function (_, city) {
            const val = String(city.cityId || 0);
            html += `<option value="${attr(val)}" data-lat="${attr(city.latitude || 0)}" data-lng="${attr(city.longitude || 0)}" ${val === selectedValue ? 'selected' : ''}>${h(city.name)}</option>`;
        });
        return html;
    }

    function switchHtml(name, checked, text, extra) {
        const id = attr(name);
        const isChecked = boolValue(checked);
        return `
            <label class="tw-switch-wrap" for="${id}" title="${attr(text || '')}">
                <input class="form-check-input tw-switch-input" type="checkbox" id="${id}" name="${id}" ${isChecked ? 'checked' : ''} ${extra || ''}>
                <span class="tw-switch-status fs-07">${isChecked ? 'Açık' : 'Kapalı'}</span>
            </label>`;
    }

    function moneyStepper(name, value, step, extra) {
        const disabled = /disabled/i.test(extra || '');
        return `
            <div class="tw-number-stepper ${disabled ? 'is-disabled' : ''}" data-target="${attr(name)}" data-step="${attr(step || 100)}">
                <button type="button" class="tw-stepper-btn fs-08 tw-dec" aria-label="Azalt" ${disabled ? 'disabled' : ''}><i class="fa-solid fa-minus"></i></button>
                <input type="number" min="0" step="${attr(step || 100)}" id="${attr(name)}" name="${attr(name)}" value="${attr(value || 0)}" class="form-control fw-bold border-none tw-control fs-07 text-center" ${extra || ''}>
                <button type="button" class="tw-stepper-btn fs-08 tw-inc" aria-label="Artır" ${disabled ? 'disabled' : ''}><i class="fa-solid fa-plus"></i></button>
            </div>`;
    }


    function numberStepper(name, value, step, extra) {
        return moneyStepper(name, value, step || 1, extra || '');
    }

    function normalizeTimeInputValue(value, fallback) {
        const list = normalizeClockList(value || '');
        if (list.length) return list[0];
        const fb = normalizeClockList(fallback || '');
        return fb.length ? fb[0] : '19:00';
    }

    function getFixtureMatchesPerDayValue() {
        const t = (state.data && state.data.tournament) || {};
        const count = n($('#FixtureMatchesPerDay').val(), n(t.fixtureMatchesPerDay, 0));
        if (count > 0) return Math.min(24, count);
        const times = normalizeClockList($('#FixtureMatchStartTimes').val() || t.fixtureMatchStartTimes || '19:00,21:00');
        return Math.max(1, Math.min(24, times.length || 1));
    }

    function getFixtureMatchesPerWeekValue() {
        const t = (state.data && state.data.tournament) || {};
        const count = n($('#FixtureMatchesPerWeek').val(), n(t.fixtureMatchesPerWeek, 0));
        if (count > 0) return Math.min(200, count);

        const matchesPerDay = getFixtureMatchesPerDayValue();
        return Math.max(matchesPerDay, Math.min(200, matchesPerDay * 7));
    }

    function renderFixtureTimeInputs(value, count) {
        const times = normalizeClockList(value || '');
        const safeCount = Math.max(1, Math.min(24, n(count, times.length || 1)));

        let html = `
        <input type="hidden"
               id="FixtureMatchStartTimes"
               name="FixtureMatchStartTimes"
               value="${attr(times.join(','))}">
    `;

        html += '<div class="tw-time-list" data-time-list="fixture-start-times">';

        for (let i = 0; i < safeCount; i++) {
            const index = i + 1;
            const paddedIndex = String(index).padStart(2, '0');
            const fallbackHour = Math.min(23, 19 + (i * 2));
            const fallback = `${String(fallbackHour).padStart(2, '0')}:00`;
            const inputValue = times[i] || fallback;

            html += `
            <div class="tw-time-item" data-time-item="${attr(index)}">
                <span class="tw-time-index fs-06">${paddedIndex}</span>

                <input type="time"
                       id="FixtureMatchStartTime_${attr(index)}"
                       name="FixtureMatchStartTime_${attr(index)}"
                       class="form-control border-none tw-control fs-07 tw-fixture-time-input"
                       value="${attr(inputValue)}"
                       data-index="${attr(index)}"
                       data-target="#FixtureMatchStartTimes"
                       required>
            </div>`;
        }

        html += '</div>';

        return html;
    }

    function syncFixtureTimeInputs() {
        const values = $('.tw-fixture-time-input')
            .sort(function (a, b) {
                return n($(a).data('index')) - n($(b).data('index'));
            })
            .map(function () {
                return normalizeTimeInputValue($(this).val());
            })
            .get()
            .filter(function (x) {
                return !!x;
            });

        $('#FixtureMatchStartTimes').val(normalizeClockList(values.join(',')).join(','));
    }

    function rebuildFixtureTimeInputsByMatchCount() {
        const $hidden = $('#FixtureMatchStartTimes');
        const $list = $('[data-time-list="fixture-start-times"]');

        if (!$hidden.length || !$list.length) return;

        syncFixtureTimeInputs();

        const count = getFixtureMatchesPerDayValue();
        const current = normalizeClockList($hidden.val());
        const oldCount = $list.find('.tw-fixture-time-input').length;

        if (oldCount === count) return;

        const $html = $(renderFixtureTimeInputs(current.join(','), count));

        const $newHidden = $html.filter('#FixtureMatchStartTimes');
        const $newList = $html.filter('[data-time-list="fixture-start-times"]');

        $hidden.replaceWith($newHidden);
        $list.replaceWith($newList);

        syncFixtureTimeInputs();
    }

    function imagePairHtml(t) {
        return `
            <div class="col-12 tw-field-col p-2">
                <div class="row m-0 g-2">
                    ${imageCardHtml('Profil Resmi', 'Img', t.img || DEFAULT_IMG, 'fa-image', 'tournament-wizard-images', 'Tournament')} 
                </div>
            </div>`;
    }

    function imageCardHtml(title, inputName, imageUrl, icon, group, entityName, colClass) {
        return `
            <div class="${attr(colClass || 'col-12 p-2')}">
                <input type="hidden" id="${attr(inputName)}" name="${attr(inputName)}" value="${attr(imageUrl || DEFAULT_IMG)}">
                <button type="button" class="tw-image-card tw-image-action fs-07" data-input="${attr(inputName)}" data-title="${attr(title)}" data-url="${attr(imageUrl || DEFAULT_IMG)}" data-group="${attr(group || 'tournament-wizard-images')}" data-entity="${attr(entityName || 'Tournament')}">
                    <img src="${attr(imageUrl || DEFAULT_IMG)}" alt="${attr(title)}">
                    <span class="fs-07"><i class="fa-solid ${attr(icon || 'fa-image')} me-1"></i>${h(title)}</span>
                </button>
            </div>`;
    }

    function teamOptions(value, emptyText) {
        const selectedValue = String(value || 0);
        let html = `<option value="0">${h(emptyText || 'Seçiniz')}</option>`;
        $.each((state.data && state.data.teamRelations) || [], function (_, relation) {
            const val = String(relation.teamId || 0);
            html += `<option value="${attr(val)}" ${val === selectedValue ? 'selected' : ''}>${h(relation.teamName)}</option>`;
        });
        return html;
    }

    function memberTeamOptions(value, emptyText) {
        const selectedValue = String(value || 0);
        let html = `<option value="0">${h(emptyText || 'Takım seç')}</option>`;
        $.each((state.data && state.data.memberTeams) || [], function (_, team) {
            const val = String(team.teamId || 0);
            html += `<option value="${attr(val)}" ${val === selectedValue ? 'selected' : ''}>${h(team.name)}</option>`;
        });
        return html;
    }

    function renderField(label, innerHtml, icon, col, help) {
        var hasIcon = icon !== false;

        if (icon === '')
            hasIcon = false;

        const isCkEditor = $('<div>').html(innerHtml || '').find('textarea').length > 0;

        return `
            <div class="${col || 'col-6'} tw-field-col p-2">
                <label class="tw-field-label fs-07">${h(label)}</label>
                <div class="tw-field-card ${hasIcon ? '' : 'no-icon'}" style="${isCkEditor ? 'height: unset !important;' : ''}">
                    ${hasIcon ? `<div class="tw-field-icon"><i class="fa-solid ${icon || 'fa-circle-dot'} fs-08"></i></div>` : ''}
                    <div class="tw-field-input">${innerHtml}</div>
                </div>
                ${help ? `<div class="tw-field-help fs-06">${h(help)}</div>` : ''}
            </div>`;
    }

    function renderFieldBold(label, innerHtml, icon, col, help) {
        const hasIcon = icon !== false;
        const isCkEditor = $('<div>').html(innerHtml || '').find('textarea').length > 0;

        return `
            <div class="${col || 'col-6'} tw-field-col p-2">
                <label class="tw-field-label fs-07">${h(label)}</label>
                <div class="tw-field-card ${hasIcon ? '' : 'no-icon'}" style="${isCkEditor ? 'height: unset !important;' : ''}">
                    ${hasIcon ? `<div class="tw-field-icon"><i class="fa-solid ${icon || 'fa-circle-dot'} fs-08"></i></div>` : ''}
                    <div class="tw-field-input">${innerHtml}</div>
                </div>
                ${help ? `<div class="tw-field-help fw-bold fs-06">${h(help)}</div>` : ''}
            </div>`;
    }

    function input(name, value, type, extra) {
        return `<input type="${type || 'text'}" id="${attr(name)}" name="${attr(name)}" value="${attr(value == null ? '' : value)}" class="form-control border-none tw-control fs-07" ${extra || ''}>`;
    }

    function select(name, html, extra) {
        return `<select id="${attr(name)}" name="${attr(name)}" class="parentS2 tw-control fs-07" ${extra || ''}>${html}</select>`;
    }

    function getRoot() {
        let $root = $('#TournamentBuilderRoot');
        if ($root.length) return $root;

        const html = `
            <div class="tw-overlay" id="TournamentBuilderOverlay">
                <section class="tw-main" id="TournamentBuilderRoot"></section>
            </div>`;
        $('body').append(html).addClass('tw-body-lock');
        if (!state.historyToken && typeof window.registerModalHistory === 'function') {
            state.historyToken = window.registerModalHistory(function () {
                close(true, true);
            });
        }
        return $('#TournamentBuilderRoot');
    }

    function close(force, fromHistory) {
        updateDirtyUi();
        if (!force && state.dirty) {
            confirmDialog('Kaydedilmeyen değişiklikler geri alınacak. Kapatmak istiyor musunuz?', 'Kaydedilmeyen değişiklik var')
                .then(function (ok) { if (ok) close(true); });
            return;
        }

        if (state.historyToken && typeof window.releaseModalHistory === 'function') {
            window.releaseModalHistory(state.historyToken, fromHistory === true);
            state.historyToken = null;
        }

        $('#TournamentBuilderOverlay').remove();
        $('body').removeClass('tw-body-lock');
        state.data = null;
        state.host = null;
        state.dirty = false;
        state.stepSnapshot = null;
        state.snapshotStep = null;
        state.awardFormOpen = false;
        state.awardFormDefinitionId = 0;
        state.documentEditRowKey = '';
        $(document).off(NS);
        $(window).off(NS);
        window.dispatchEvent(new CustomEvent('sahasenin:tournament-closed'));
    }

    function headerHtml() {
        const t = state.data.tournament || {};
        const status = boolValue(t.draft) ? 'Taslak' : 'Yayında';
        return `
            <header class="tw-header">
                <div class="tw-title-wrap">
                    <button type="button" class="tw-icon-btn fs-08 tw-close" title="Kapat"><i class="fa-solid fa-xmark"></i></button>
                    <div>
                        <div class="tw-kicker fs-06">Turnuva Oluşturma ve Düzenleme</div>
                        <h2 class="tw-title fs-09">${h(t.name || 'Yeni Turnuva')}</h2>
                    </div>
                </div>
                <span class="tw-pill fs-06 ${boolValue(t.draft) ? 'is-draft' : 'is-live'}">${status}</span>
            </header>`;
    }

    function stepperHtml() {
        return `
            <nav class="tw-stepper">
                ${steps.map(function (step) {
            const active = state.activeStep === step.key;
            return `
                        <button type="button" class="tw-step fs-07 ${active ? 'active' : ''}" data-step="${attr(step.key)}" title="${attr(step.title)}">
                            <i class="fa-solid ${step.icon} fs-08"></i>
                            <span class="tw-step-label fs-07">${active ? h(step.title) : ''}</span>
                        </button>`;
        }).join('')}
            </nav>`;
    }

    function render() {
        const $root = getRoot();
        $root.html(`
            ${headerHtml()}
            ${stepperHtml()}
            <div class="tw-content p-0">
                <div class="tw-loader d-none"><div class="spinner-border sahasenin-modern-spinner"></div><span class="tw-loading-text w-100 text-center px-2">Yükleniyor...</span></div>
                <div class="tw-step-content">${renderStep()}</div>
            </div>`);

        bindEvents();
        afterRender();
    }

    function renderStep() {
        switch (state.activeStep) {
            case 'services': return renderServicesStep();
            case 'teams': return renderTeamsStep();
            case 'fixture': return renderFixtureStep();
            case 'rules': return renderRulesStep();
            case 'statistics': return renderStatisticPreferencesStep(false);
            case 'bests': return renderStatisticPreferencesStep(true);
            case 'documents': return renderDocumentsStep();
            case 'news': return renderNewsStep();
            case 'media': return renderMediaStep();
            case 'awards': return renderAwardsStep();
            case 'publish': return renderPublishStep();
            default: return renderBaseStep();
        }
    }

    function renderBaseStep() {
        const d = state.data || {};
        const t = d.tournament || {};
        const enums = d.enums || {};

        return `
            <form id="TournamentBaseForm" class=" tw-form" data-entity-name="Tournament">
                <input type="hidden" id="TournamentId" name="TournamentId" value="${attr(t.tournamentId)}">
                <input type="hidden" id="MemberId" name="MemberId" value="${attr(t.memberId)}">
                <input type="hidden" id="Draft" name="Draft" value="${boolValue(t.draft) ? 'true' : 'false'}">
                <input type="hidden" id="isOfficial" name="isOfficial" value="${boolValue(t.isOfficial) ? 'true' : 'false'}">
                <input type="hidden" id="Deleted" name="Deleted" value="false">
                <input type="hidden" id="MetaName" name="MetaName" value="${attr(t.metaName || '-')}">
                <input type="hidden" id="Include" name="Include" value="">
                <input type="hidden" id="TempId" name="TempId" value="${attr(t.tournamentId)}">
                <input type="hidden" id="ClassName" name="ClassName" value="-">
                <input type="hidden" id="ClassIcon" name="ClassIcon" value="-">
                <input type="hidden" id="Latitude" name="Latitude" value="${attr(t.latitude || 0)}">
                <input type="hidden" id="Longitude" name="Longitude" value="${attr(t.longitude || 0)}"> 
                <input type="hidden" id="Description" name="Description" value="${attr(t.Description || '')}">
                <input type="hidden" id="ProfileCardImg" name="ProfileCardImg" value="${attr(t.ProfileCardImg || '')}">

                <div class="tw-section-head m-2">
                    <div>
                        <h3 class="fs-08">Genel Bilgiler</h3>
                        <p class="fs-07">Turnuvanın görünür bilgilerini, şehir ve katılım ayarlarını buradan yönet.</p>
                    </div>
                    ${stepActionsHtml('tw-save-base', Number(t.tournamentId || 0) > 0 ? 'Kaydet' : 'Taslağı Kaydet')}
                </div>

                <div class="row m-0">
                    ${imagePairHtml(t)}
                    ${renderField('Adı', input('Name', t.name, 'text', 'required'), 'fa-trophy', 'col-6')}
                    ${renderField('Şehir', select('CityId', cityOptions(t.cityId), 'required'), 'fa-city', 'col-6')}
                    ${renderField('Cinsiyet', select('GenderTypeEnum', optionsHtml(enums.gender, t.genderTypeEnum || t.tournamentGenderId || t.genderEnum, 'Seçiniz')), 'fa-venus-mars', 'col-6')}
                    ${renderField('Maç Günleri', select('TournamentMatchDayIds', optionsMultiHtml(enums.matchDays, normalizeMultiIds(t.tournamentMatchDayIds, t.tournamentMatchDayId || t.matchDaysEnum)), 'multiple data-placeholder="Seçiniz"'), 'fa-calendar-days', 'col-12 tw-multi-field')}
                    ${renderField('Maç Saatleri', select('TournamentMatchTimeRangeId', optionsHtml(enums.matchTimeRange, t.tournamentMatchTimeRangeId || t.matchTimeRangeEnum, 'Seçiniz')), 'fa-clock', 'col-6')}
                    ${renderField('Yaş', select('TournamentAgeRangeId', optionsHtml(enums.ageRange, t.tournamentAgeRangeId || t.ageRangeEnum, 'Seçiniz')), 'fa-user-group', 'col-6')}
                    ${renderField('Takım Kategorisi', select('TournamentTeamCategoryIds', optionsMultiHtml(enums.teamCategory, normalizeMultiIds(t.tournamentTeamCategoryIds, t.tournamentTeamCategoryId || t.teamCategoryEnum)), 'multiple data-placeholder="Seçiniz"'), 'fa-people-group', 'col-12 tw-multi-field')}
                    ${renderField('Oyun Formatı', select('TeamPlayerCountTypeEnum', optionsHtml(enums.teamPlayerCountTypes, t.teamPlayerCountTypeEnum || t.tournamentGameFormatId || t.gameFormatEnum, 'Seçiniz')), 'fa-futbol', 'col-6')}
                    ${renderField('Oyun Kuralları', select('TournamentGameRuleId', optionsHtml(enums.gameRule, t.tournamentGameRuleId || t.gameRuleEnum, 'Seçiniz')), 'fa-scale-balanced', 'col-6')}
                    ${renderField('Maç Süresi', select('TournamentMatchDurationId', optionsHtml(enums.matchDuration, t.tournamentMatchDurationId || t.matchDurationMinutes, 'Seçiniz')), 'fa-stopwatch', 'col-6')}
                    ${renderField('Turnuva Geçmişi', select('TournamentPreviousEditionId', optionsHtml(enums.previousEditions, t.tournamentPreviousEditionId || t.previousEditionsEnum, 'Seçiniz')), 'fa-clock-rotate-left', 'col-6')}

                    ${renderField('Katılım Ücreti', moneyStepper('PriceForPerTeam', t.priceForPerTeam, 100), false, 'col-6')}
                    ${renderField('Maç Başı Ücret', moneyStepper('PriceForPerMatch', t.priceForPerMatch, 100), false, 'col-6')}

                    ${renderField('Halka Açık', switchHtml('isPublic', t.isPublic, 'Halka açık'), 'fa-users', 'col-6')} 
                    ${renderField('Katılma İsteği', switchHtml('JoinRequestPermission', t.joinRequestPermission, 'İstek alınabilir'), 'fa-code-pull-request', 'col-6')}
                    ${renderField('Online Ödeme', switchHtml('JustOnlinePay', t.justOnlinePay, 'Sadece online'), 'fa-credit-card', 'col-6')}
                    ${renderFieldBold('Yorum İzni', switchHtml('CommentPermission', t.commentPermission, 'Turnuva dışındakiler yorum yapabilsin mi?'), 'fa-comment', 'col-6', 'Turnuva dışındakiler yorum yapabilsin mi?')}
                    ${renderField('Galeri İzni', switchHtml('GalleryPermission', t.galleryPermission, 'Resim eklenebilir'), 'fa-images', 'col-6')}

                    ${renderField('Kısa Açıklama', `<textarea id="MiniDescription" name="MiniDescription" class="form-control border-none tw-control fs-07 ckEditor" rows="3">${h(t.miniDescription || '')}</textarea>`, 'fa-align-left', 'col-12')}
                </div>
            </form>`;
    }

    function renderServicesStep() {
        const selectedOrder = (state.data.selectedServiceIds || []).map(Number);
        const selected = new Set(selectedOrder);
        const services = (state.data.services || []).slice().sort(function (a, b) {
            const ai = selectedOrder.indexOf(n(a.id));
            const bi = selectedOrder.indexOf(n(b.id));
            if (ai >= 0 && bi >= 0) return ai - bi;
            if (ai >= 0) return -1;
            if (bi >= 0) return 1;
            return String(a.name || '').localeCompare(String(b.name || ''), 'tr');
        });
        const selectedCount = selected.size;
        return `
            <div class="tw-section-head m-2">
                <div>
                    <h3 class="fs-08">Hizmetler</h3>
                    <p class="fs-07">Seçili hizmetleri sürükle-bırak ile sıralayabilirsin. Seçili hizmet sayısı: <strong class="fs-08 tw-service-count">${selectedCount}</strong></p>
                </div>
                ${stepActionsHtml('tw-save-services', 'Kaydet')}
            </div>
            <div class="tw-service-selection-warning m-2 ${selectedCount > 0 ? 'd-none' : ''}">
                <i class="fa-solid fa-circle-info"></i><span class="fs-07">Henüz hizmet seçilmedi. Hizmet seçimi zorunlu değil, ama turnuvayı daha anlaşılır gösterir.</span>
            </div>
            <div class="row m-0 tw-service-grid" data-sort-container="service">
                ${services.length ? services.map(function (service) {
            const active = selected.has(Number(service.id));
            return `
                        <div class="col-6 col-md-4 col-xl-3 p-2 tw-service-sortable-item tw-draggable ${active ? 'is-selected' : ''}" draggable="true" data-sort-type="service" data-service-id="${attr(service.id)}">
                            <button type="button" class="tw-service-card ${active ? 'active' : ''}" data-service-id="${attr(service.id)}">
                                <span class="tw-drag-handle fs-06"><i class="fa-solid fa-grip-vertical"></i></span>
                                <img src="${attr(service.img || DEFAULT_IMG)}" alt="${attr(service.name)}">
                                <span class="tw-service-check"><i class="fa-solid fa-circle-check"></i></span>
                                <strong class="fs-08">${h(service.name)}</strong>
                                <div class="tw-card-description fs-07">${safeHtml(service.description)}</div>
                            </button>
                        </div>`;
        }).join('') : emptyCard('Tanımlı hizmet bulunamadı.')}
            </div>`;
    }

    function renderStatisticPreferencesStep(useBests) {
        const t = (state.data && state.data.tournament) || {};
        const definitions = ((state.data && (useBests ? state.data.bestDefinitions : state.data.statisticDefinitions)) || []).slice();
        const title = useBests ? 'Enler' : 'İstatistikler';
        const icon = useBests ? 'fa-ranking-star' : 'fa-chart-simple';
        const visibleCount = definitions.filter(function (x) { return boolValue(x.isVisible); }).length;
        const grouped = {};

        definitions.forEach(function (definition) {
            const key = definition.targetTypeName || 'Diğer';
            grouped[key] = grouped[key] || [];
            grouped[key].push(definition);
        });

        return `
            <div class="tw-section-head m-2">
                <div>
                    <h3 class="fs-08">${h(title)}</h3>
                    <p class="fs-07">Panelde turnuva profili için açılan tanımlardan hangilerinin bu turnuvada gösterileceğini seç. Yeni tanımlar varsayılan olarak açıktır.</p>
                </div>
                ${stepActionsHtml('tw-save-stat-preferences', 'Kaydet', `<span class="tw-stat-visible-count fs-07">${visibleCount}/${definitions.length} açık</span>`)}
            </div>

            ${Number(t.tournamentId || 0) <= 0 ? `<div class="tw-warning-box m-2"><strong class="fs-08">Önce taslağı kaydet</strong><span class="fs-07">Turnuvaya özel seçimler taslak oluştuktan sonra kaydedilebilir.</span></div>` : ''}

            <div class="tw-stat-preference-groups m-2">
                ${definitions.length ? Object.keys(grouped).map(function (groupName) {
                    return `
                        <section class="tw-panel tw-stat-preference-group">
                            <div class="tw-panel-head">
                                <strong class="fs-08"><i class="fa-solid ${icon} me-1"></i>${h(groupName)}</strong>
                                <span class="fs-07">${grouped[groupName].length} tanım</span>
                            </div>
                            <div class="tw-stat-preference-grid">
                                ${grouped[groupName].map(function (definition) {
                                    return `
                                        <label class="tw-stat-preference-card ${boolValue(definition.isVisible) ? 'is-visible' : ''}">
                                            <span class="tw-stat-preference-icon"><i class="fa-solid ${attr(definition.icon || icon)}"></i></span>
                                            <span class="tw-stat-preference-copy">
                                                <strong class="fs-08">${h(definition.name)}</strong>
                                                <small class="fs-07">${h(definition.description || (useBests ? 'Turnuva enleri alanında gösterilir.' : 'Turnuva istatistikleri alanında gösterilir.'))}</small>
                                            </span>
                                            <span class="form-check form-switch m-0">
                                                <input class="form-check-input tw-stat-definition-toggle" type="checkbox"
                                                       data-definition-id="${attr(definition.statisticDefinitionId)}"
                                                       ${boolValue(definition.isVisible) ? 'checked' : ''}
                                                       ${Number(t.tournamentId || 0) <= 0 ? 'disabled' : ''}>
                                            </span>
                                        </label>`;
                                }).join('')}
                            </div>
                        </section>`;
                }).join('') : emptyCard(`Panelde turnuva profiline açık ${useBests ? 'Enler' : 'istatistik'} tanımı bulunamadı.`)}
            </div>`;
    }

    function updateStatisticPreferenceUi() {
        const $toggles = $('.tw-stat-definition-toggle');
        const visibleCount = $toggles.filter(':checked').length;
        $toggles.each(function () {
            $(this).closest('.tw-stat-preference-card').toggleClass('is-visible', this.checked);
        });
        $('.tw-stat-visible-count').text(visibleCount + '/' + $toggles.length + ' açık');
    }

    function updateTournamentDocumentVisibilityUi() {
        const $toggles = $('.tw-document-visibility-toggle');
        const visibleCount = $toggles.filter(':checked').length;
        $toggles.each(function () {
            const $card = $(this).closest('.tw-document-switch-card');
            $card.toggleClass('is-visible', this.checked);
            $card.find('.tw-document-title span').text(this.checked
                ? 'Turnuva profilinde gösteriliyor'
                : 'Turnuva profilinde gizli');
        });
        $('.tw-document-visible-count').text(visibleCount + '/' + $toggles.length + ' açık');
    }

    function saveStatisticPreferences(useBests) {
        const tournamentId = state.data && state.data.tournament ? n(state.data.tournament.tournamentId) : 0;
        if (tournamentId <= 0) {
            notifyError('İstatistik tercihlerini kaydetmek için önce turnuva taslağını kaydetmelisin.');
            return $.Deferred().resolve().promise();
        }

        const visibleDefinitionIds = statisticVisibilitySnapshot();
        setLoading(true, useBests ? 'Enler tercihleri kaydediliyor...' : 'İstatistik tercihleri kaydediliyor...');
        return request({
            url: API + '/SaveStatisticPreferences',
            method: 'POST',
            data: JSON.stringify({ tournamentId: tournamentId, useBests: !!useBests, visibleDefinitionIds: visibleDefinitionIds }),
            contentType: 'application/json; charset=utf-8'
        }).then(function (response) {
            setRemoteState(response);
            state.activeStep = useBests ? 'bests' : 'statistics';
            setLoading(false);
            render();
            notifySuccess(useBests ? 'Enler tercihleri kaydedildi.' : 'İstatistik tercihleri kaydedildi.');
        }).catch(function (xhr) { setLoading(false); notifyError(xhr); });
    }

    function awardStatisticDefinitionOptions(value) {
        const selectedValue = String(value || 0);
        let html = '<option value="0">Turnuva eni seç</option>';
        $.each((state.data && state.data.awardStatisticDefinitions) || [], function (_, item) {
            const val = String(item.statisticDefinitionId || 0);
            html += `<option value="${attr(val)}" ${val === selectedValue ? 'selected' : ''}>${h(item.name)}</option>`;
        });
        return html;
    }

    function awardTypeOptions(value) {
        const selectedValue = String(value || 0);
        let html = '<option value="0">Ödül seç</option>';
        $.each((state.data && state.data.awardTypes) || [], function (_, item) {
            const val = String(item.tournamentAwardTypeId || 0);
            html += `<option value="${attr(val)}" data-money="${boolValue(item.isMoneyAward) ? 'true' : 'false'}" ${val === selectedValue ? 'selected' : ''}>${h(item.name)}${boolValue(item.isMoneyAward) ? ' • Para' : ''}</option>`;
        });
        return html;
    }

    function findAwardType(id) {
        const list = (state.data && state.data.awardTypes) || [];
        return list.find(function (x) { return Number(x.tournamentAwardTypeId) === Number(id); }) || null;
    }

    function findAwardStatisticDefinition(id) {
        const list = (state.data && state.data.awardStatisticDefinitions) || [];
        return list.find(function (x) { return Number(x.statisticDefinitionId) === Number(id); }) || null;
    }


    function findAwardRelationForEdit() {
        const relationId = n(state.awardEditRelationId);
        const definitionId = n(state.awardEditDefinitionId);
        const awardId = n(state.awardEditAwardId);
        return (state.data.awardRelations || []).find(function (x) {
            if (relationId > 0) return n(x.tournamentAwardRelationId) === relationId;
            return definitionId > 0 && awardId > 0 && n(x.statisticDefinitionId) === definitionId && n(x.tournamentAwardTypeId) === awardId;
        }) || null;
    }

    function resetAwardEditState() {
        state.awardFormOpen = false;
        state.awardFormDefinitionId = 0;
        state.awardEditRelationId = 0;
        state.awardEditDefinitionId = 0;
        state.awardEditAwardId = 0;
    }

    function renderAwardsStep() {
        const t = state.data.tournament || {};
        const saved = state.data.awardRelations || [];
        const definitions = state.data.awardStatisticDefinitions || [];
        const grouped = {};

        $.each(saved, function (_, relation) {
            const key = relation.statisticDefinitionId || 0;
            grouped[key] = grouped[key] || [];
            grouped[key].push(relation);
        });

        const groupKeys = Object.keys(grouped).sort(function (a, b) {
            const aa = grouped[a][0] || {};
            const bb = grouped[b][0] || {};
            const ao = n(aa.recipientSortOrder);
            const bo = n(bb.recipientSortOrder);
            if (ao !== bo) return (ao || 999999) - (bo || 999999);
            return String(aa.statisticDefinitionName || '').localeCompare(String(bb.statisticDefinitionName || ''), 'tr');
        });

        const editingAward = findAwardRelationForEdit();
        const editing = !!editingAward;
        const formDefinitionId = editing ? n(editingAward.statisticDefinitionId) : n(state.awardFormDefinitionId);
        const fixedDefinition = formDefinitionId > 0 ? findAwardStatisticDefinition(formDefinitionId) : null;
        const selectedText = fixedDefinition ? fixedDefinition.name : 'Turnuva eni seçilerek eklenecek';
        const awardTypeValue = editing ? n(editingAward.tournamentAwardTypeId) : 0;
        const awardQuantityValue = editing ? n(editingAward.quantity) : 0;
        const formTitle = editing ? 'Ödül Düzenle' : 'Yeni Ödül Ekle';
        const formButtonText = editing ? 'Güncelle' : 'Ekle';
        const addButton = `<button type="button" class="btn btn-success fs-07 tw-open-award-form"><i class="fa-solid fa-plus me-1"></i>Yeni ödül ekle</button>`;

        return `
            <div class="tw-section-head m-2">
                <div>
                    <h3 class="fs-08">Ödüller</h3>
                    <p class="fs-07">Ödül başlıklarını ve başlık altındaki ödülleri sürükle-bırak ile sıralayabilirsin.</p>
                </div>
                ${stepActionsHtml('tw-save-awards', 'Kaydet', addButton)}
            </div>

            ${Number(t.tournamentId || 0) <= 0 ? `<div class="tw-empty mb-2"><i class="fa-solid fa-lock"></i><span class="fs-07">Ödül eklemek için önce turnuva taslağını kaydet.</span></div>` : ''}

            <div class="tw-panel mb-2 tw-award-form-panel ${state.awardFormOpen ? '' : 'd-none'}">
                <div class="tw-panel-head">
                    <strong class="fs-08"><i class="fa-solid fa-award me-1"></i>${h(formTitle)}</strong>
                    <div class="tw-actions-inline">
                        <span class="fs-07 ms-2">${h(selectedText)}</span>
                        <button type="button" class="tw-icon-btn fs-08 tw-close-award-form" title="Kapat"><i class="fa-solid fa-xmark"></i></button>
                    </div>
                </div>
                <div class="row m-0 align-items-end">
                    <input type="hidden" id="AwardEditRelationId" value="${attr(editing ? n(editingAward.tournamentAwardRelationId) : 0)}">
                    <input type="hidden" id="awardEditDefinitionId" value="${attr(editing ? n(editingAward.statisticDefinitionId) : 0)}">
                    <input type="hidden" id="AwardEditAwardId" value="${attr(editing ? n(editingAward.tournamentAwardTypeId) : 0)}">
                    ${fixedDefinition
                ? `<input type="hidden" id="AwardStatisticDefinitionId" value="${attr(fixedDefinition.statisticDefinitionId)}">`
                : renderField('Turnuva Eni', select('AwardStatisticDefinitionId', awardStatisticDefinitionOptions(editing ? formDefinitionId : 0), Number(t.tournamentId || 0) <= 0 ? 'disabled' : 'required'), 'fa-ranking-star', 'col-6')}
                    ${renderField('Ödül Tipi', select('AwardTypeId', awardTypeOptions(awardTypeValue), Number(t.tournamentId || 0) <= 0 ? 'disabled' : 'required'), 'fa-award', 'col-6')}
                    ${renderField('Miktar', moneyStepper('AwardQuantity', awardQuantityValue, 1, Number(t.tournamentId || 0) <= 0 ? 'disabled' : 'required min="1"'), false, 'col-6')}
                    <div class="col-12 p-2">
                        <button type="button" class="btn btn-primary fs-07 w-100 tw-add-award" ${Number(t.tournamentId || 0) <= 0 ? 'disabled' : ''}><i class="fa-solid fa-floppy-disk me-1"></i>${h(formButtonText)}</button>
                    </div>
                </div>
            </div>

            <div id="TournamentAwardList" class="tw-award-list" data-sort-container="award-group">
                ${groupKeys.length ? groupKeys.map(function (definitionId) {
                    const definition = definitions.find(function (x) { return Number(x.statisticDefinitionId) === Number(definitionId); }) || findAwardStatisticDefinition(definitionId) || {};
                    const list = (grouped[definitionId] || []).slice().sort(function (a, b) {
                        const ao = n(a.sortOrder); const bo = n(b.sortOrder);
                        if (ao !== bo) return (ao || 999999) - (bo || 999999);
                        return String(a.awardTypeName || '').localeCompare(String(b.awardTypeName || ''), 'tr');
                    });
                    return `
                        <div class="tw-panel mb-2 tw-award-group tw-draggable" draggable="true" data-sort-type="award-group" data-definition-id="${attr(definitionId)}">
                            <div class="tw-panel-head tw-award-group-head">
                                <div>
                                    <span class="tw-drag-handle fs-06 me-2"><i class="fa-solid fa-grip-vertical"></i></span>
                                    <strong class="fs-08"><i class="fa-solid ${attr(definition.icon || 'fa-ranking-star')} me-1"></i>${h(definition.name || (list[0] && list[0].statisticDefinitionName) || 'Turnuva Eni')}</strong>
                                    <span class="fs-07 ms-2">${list.length} ödül</span>
                                </div>
                                <button type="button" class="tw-icon-btn fs-08 tw-open-award-form-definition" data-definition-id="${attr(definitionId)}" title="Bu ene ödül ekle"><i class="fa-solid fa-plus"></i></button>
                            </div>
                            <div class="tw-award-items" data-sort-container="award-row">
                                ${list.map(awardRelationRow).join('')}
                            </div>
                        </div>`;
                }).join('') : emptyCard('Henüz ödül ilişkisi eklenmedi.')}
            </div>`;
    }

    function awardRelationRow(relation) {
        return `
            <div class="tw-award-row tw-draggable" draggable="true" data-sort-type="award-row"
                 data-relation-id="${attr(relation.tournamentAwardRelationId || 0)}"
                 data-definition-id="${attr(relation.statisticDefinitionId || 0)}"
                 data-award-id="${attr(relation.tournamentAwardTypeId || 0)}"
                 data-quantity="${attr(relation.quantity || 0)}">
                <span class="tw-drag-handle fs-06"><i class="fa-solid fa-grip-vertical"></i></span>
                <div class="tw-award-icon"><i class="fa-solid ${attr(relation.awardTypeIcon || 'fa-award')}"></i></div>
                <div class="tw-award-main">
                    <strong class="fs-08">${h(relation.awardTypeName || 'Ödül')}</strong>
                    <small class="fs-07">${boolValue(relation.isMoneyAward) ? h((relation.quantity || 0) + ' TL') : h('Miktar: ' + (relation.quantity || 0))}</small>
                </div>
                <div class="tw-award-actions">
                    <button type="button" class="tw-icon-btn fs-08 tw-edit-award" title="Düzenle"><i class="fa-solid fa-pen"></i></button>
                    <button type="button" class="tw-icon-btn fs-08 tw-remove-award" title="Kaldır"><i class="fa-solid fa-trash"></i></button>
                </div>
            </div>`;
    }

    function renderTypeStep() {
        return emptyCard('Bu bölüm kaldırıldı.');
    }

    function renderTeamsStep() {
        const t = state.data.tournament || {};
        const relations = state.data.teamRelations || [];
        const acceptedRelations = relations.filter(function (x) { return boolValue(x.accepted); });
        const pendingRelations = relations.filter(function (x) { return !boolValue(x.accepted); });
        const currentCount = relations.length;
        const acceptedCount = acceptedRelations.length;
        const targetCount = n(t.teamCount, 0);
        const slotCount = Math.max(targetCount, currentCount, 1);
        const missingCount = Math.max(0, targetCount - acceptedCount);
        const showGroups = shouldShowTeamGroupSelection();

        if (showGroups) {
            return renderGroupedTeamsStep(t, acceptedRelations, pendingRelations, acceptedCount, targetCount, missingCount);
        }

        const slots = [];
        for (let i = 0; i < slotCount; i++) {
            slots.push(relations[i] ? teamRelationHtml(relations[i], i + 1) : emptyTeamSlotHtml(i + 1));
        }

        return `
            <div class="tw-section-head m-2">
                <div>
                    <h3 class="fs-08">Takımlar</h3>
                    <p class="fs-07">${acceptedCount}/${targetCount || '?'} onaylı takım fikstüre dahil edilir. Onay bekleyen takımlar fikstürde kullanılmaz.</p>
                </div>
                ${stepActionsHtml('tw-save-teams', 'Kaydet', `<button type="button" class="btn btn-success fs-07 tw-open-add-team"><i class="fa-solid fa-user-plus me-1"></i>Davet Et</button>`)}
            </div>

            <div class="tw-progress-line"><span class="fs-06" style="width:${targetCount > 0 ? Math.min(100, (acceptedCount / targetCount) * 100) : 0}%"></span></div>
            ${missingCount > 0 ? `<div class="tw-warning-box m-2"><strong class="fs-08"><i class="fa-solid fa-triangle-exclamation me-1"></i>${missingCount} takım eksik</strong><span class="fs-07">Fikstürde sadece onaylanmış takımlar kullanılır.</span></div>` : ''}

            <div class="row m-0">
                <div class="col-12 p-2">
                    <div class="tw-panel">
                        <div class="tw-panel-head"><strong class="fs-08">Turnuvadaki Takımlar</strong><span class="fs-07 ms-2">${slotCount} slot</span></div>
                        <div class="tw-team-slots">
                            ${slots.join('')}
                        </div>
                    </div>
                </div>
            </div>`;
    }


    function renderGroupedTeamsStep(t, acceptedRelations, pendingRelations, acceptedCount, targetCount, missingCount) {
        const groups = getFixtureGroups(getFixtureGroupCount());
        const groupCount = Math.max(1, groups.length);
        const assignmentMap = getTeamGroupAssignmentMap();
        const byGroup = {};
        const groupSlotTargets = {};
        groups.forEach(function (group, index) {
            byGroup[group.groupIndex] = [];
            const base = Math.floor(Math.max(0, targetCount) / groupCount);
            const extra = index < (Math.max(0, targetCount) % groupCount) ? 1 : 0;
            groupSlotTargets[group.groupIndex] = Math.max(1, base + extra);
        });

        acceptedRelations.forEach(function (relation, index) {
            const saved = assignmentMap[n(relation.teamId)] || {};
            const groupIndex = saved.groupIndex || defaultTeamGroupIndex(relation.teamId);
            if (!byGroup[groupIndex]) byGroup[groupIndex] = [];
            byGroup[groupIndex].push($.extend({}, relation, {
                fixtureGroupRelationId: saved.relationId || 0,
                fixtureGroupSortOrder: saved.sortOrder || index + 1,
                fixtureGroupIndex: groupIndex
            }));
        });

        Object.keys(byGroup).forEach(function (key) {
            byGroup[key].sort(function (a, b) {
                const ao = n(a.fixtureGroupSortOrder); const bo = n(b.fixtureGroupSortOrder);
                if (ao !== bo) return (ao || 999999) - (bo || 999999);
                return String(a.teamName || '').localeCompare(String(b.teamName || ''), 'tr');
            });
        });

        return `
            <div class="tw-section-head m-2">
                <div>
                    <h3 class="fs-08">Takımlar</h3>
                    <p class="fs-07">${acceptedCount}/${targetCount || '?'} onaylı takım gruplara ayrıldı. Takımları gruplar arasında sürükleyebilir ve grup içi sırayı değiştirebilirsin.</p>
                </div>
                ${stepActionsHtml('tw-save-teams', 'Kaydet', `<button type="button" class="btn btn-success fs-07 tw-open-add-team"><i class="fa-solid fa-user-plus me-1"></i>Davet Et</button>`)}
            </div>
            <div class="tw-progress-line"><span class="fs-06" style="width:${targetCount > 0 ? Math.min(100, (acceptedCount / targetCount) * 100) : 0}%"></span></div>
            ${missingCount > 0 ? `<div class="tw-warning-box m-2"><strong class="fs-08"><i class="fa-solid fa-triangle-exclamation me-1"></i>${missingCount} takım eksik</strong><span class="fs-07">Fikstürde boş slotlar görünür, sadece onaylanmış takımlar maçlara bağlanır.</span></div>` : ''}
            <div class="row m-0 tw-team-group-board">
                ${groups.map(function (group) {
            const list = byGroup[group.groupIndex] || [];
            const slotTarget = Math.max(groupSlotTargets[group.groupIndex] || 1, list.length);
            const emptySlots = [];
            for (let i = list.length; i < slotTarget; i++) emptySlots.push(emptyTeamGroupSlotHtml(i + 1));
            return `
                    <div class="col-6 col-lg-4 col-xxl-3 p-2 tw-team-group-col">
                        <div class="tw-panel tw-team-group-panel" data-group-index="${attr(group.groupIndex)}" data-group-id="${attr(group.tournamentFixtureGroupId || 0)}">
                            <div class="tw-panel-head tw-team-group-head">
                                <strong class="fs-08"><i class="fa-solid fa-layer-group me-1"></i>${h(group.name)}</strong>
                                <span class="fs-06">${list.length}/${slotTarget} slot</span>
                            </div>
                            <div class="tw-team-group-dropzone" data-sort-container="team" data-group-index="${attr(group.groupIndex)}" data-slot-target="${attr(slotTarget)}">
                                ${list.map(function (relation, index) { return teamGroupItemHtml(relation, index + 1); }).join('')}
                                ${emptySlots.join('')}
                            </div>
                        </div>
                    </div>`;
        }).join('')}
            </div>
            ${pendingRelations.length ? `<div class="tw-panel m-2"><div class="tw-panel-head"><strong class="fs-08">Onay Bekleyenler</strong></div><div class="tw-team-slots">${pendingRelations.map(function (relation, i) { return teamRelationHtml(relation, i + 1); }).join('')}</div></div>` : ''}`;
    }

    function emptyTeamGroupSlotHtml(index) {
        return `
            <button type="button" class="tw-team-group-item tw-team-group-slot is-empty tw-open-add-team" title="Bu slota takım davet et">
                <span class="tw-team-slot-index fs-06">${String(index || 0).padStart(2, '0')}</span>
                <span class="tw-empty-team-icon"><i class="fa-solid fa-plus"></i></span>
                <strong class="fs-07 text-start">Boş Slot</strong>
            </button>`;
    }

    function teamGroupItemHtml(relation, index) {
        return `
            <div class="tw-team-group-item tw-draggable" draggable="true" data-sort-type="team" data-team-id="${attr(relation.teamId)}" data-relation-id="${attr(relation.fixtureGroupRelationId || 0)}" data-group-index="${attr(relation.fixtureGroupIndex || 0)}">
                <span class="tw-drag-handle fs-06"><i class="fa-solid fa-grip-vertical"></i></span>
                <span class="tw-team-slot-index fs-06">${String(index || 0).padStart(2, '0')}</span>
                <img src="${attr(relation.teamImg || AVATAR_IMG)}" alt="${attr(relation.teamName)}">
                <strong class="fs-06">${h(relation.teamName)}</strong>
                <button type="button" class="btn btn-light border-ff tw-remove-team ms-auto" data-team="${attr(relation.teamId)}" title="Kaldır"><i class="fa-solid fa-trash text-red"></i></button>
            </div>`;
    }

    function teamRelationHtml(relation, index) {
        const accepted = boolValue(relation.accepted);
        const statusHtml = accepted
            ? `<span class="tw-team-status is-accepted fs-07 me-1"><i class="fa-solid fa-circle-check"></i> Onaylandı</span>`
            : `<span class="tw-team-status is-pending fs-07 me-1"><i class="fa-solid fa-clock-rotate-left"></i> İstek gönderildi</span>`;

        return `
            <div class="tw-team-slot is-filled ${accepted ? 'is-accepted' : 'is-pending'}" data-relation-id="${attr(relation.relationId)}">
                <div class="tw-team-slot-index fs-06">#${h(index || '')}</div>
                <div class="tw-team-media w-100 justify-content-center d-flex">
                    <img src="${attr(relation.teamImg || AVATAR_IMG)}" alt="${attr(relation.teamName)}">
                </div>
                <div class="tw-team-main w-100 p-0">
                    <strong class="w-100 text-center fs-06">${h(relation.teamName)}</strong>
                    <div class="tw-team-meta d-flex justify-content-center align-items-center">
                        ${statusHtml} 
                        <button type="button" class="btn btn-light border-ff tw-remove-team" data-team="${attr(relation.teamId)}" title="Kaldır"><i class="fa-solid fa-trash text-red"></i></button>
                    </div>
                    ${renderTeamGroupSelect(relation)}
                </div> 
            </div>`;
    }

    function getTeamGroupAssignmentMap() {
        const map = {};
        $.each((state.data && state.data.fixtureGroupTeamRelations) || [], function (_, item) {
            const teamId = n(item.teamId);
            const groupIndex = n(item.groupIndex);
            if (teamId > 0 && groupIndex > 0) map[teamId] = {
                relationId: n(item.tournamentFixtureGroupTeamRelationId),
                groupIndex: groupIndex,
                sortOrder: n(item.sortOrder)
            };
        });
        return map;
    }

    function defaultTeamGroupIndex(teamId) {
        const groupCount = Math.max(1, getFixtureGroupCount());
        const acceptedTeams = ((state.data && state.data.teamRelations) || []).filter(function (x) {
            return boolValue(x.accepted) && n(x.teamId) > 0;
        });
        const index = acceptedTeams.findIndex(function (x) { return n(x.teamId) === n(teamId); });
        return index >= 0 ? (index % groupCount) + 1 : 1;
    }

    function renderTeamGroupSelect(relation) {
        const groupCount = getFixtureGroupCount();
        if (groupCount <= 1) return '';

        if (!boolValue(relation.accepted)) {
            return `<span class="tw-team-fixture-note w-100 text-center opacity-50 fs-06"><i class="fa-solid fa-circle-info me-1"></i>Fikstüre dahil edilmedi.</span>`;
        }

        const groups = getFixtureGroups(groupCount);
        const assignmentMap = getTeamGroupAssignmentMap();
        const saved = assignmentMap[n(relation.teamId)] || {};
        const selectedGroup = saved.groupIndex || defaultTeamGroupIndex(relation.teamId);

        return ` <div class="w-100 text-center">
                <select class="tw-control fs-06 border-none fw-bold tw-fixture-group-team-select" data-team-id="${attr(relation.teamId)}" data-relation-id="${attr(saved.relationId || 0)}">
                    ${groups.map(function (group) {
            return `<option value="${attr(group.groupIndex)}" ${n(group.groupIndex) === selectedGroup ? 'selected' : ''}>${h(group.name)}</option>`;
        }).join('')}
                </select></div> `;
    }

    function emptyTeamSlotHtml(index) {
        return `
            <button type="button" class="tw-team-slot is-empty tw-open-add-team" title="Bu slota takım davet et">
                <div class="tw-team-slot-index fs-06">#${h(index || '')}</div>
                <div class="w-100 d-flex justify-content-center">
                    <span class="tw-empty-team-icon"><i class="fa-solid fa-plus"></i></span>
                </div>
                <strong class="fs-07 w-100 text-center">Boş Takım Slotu</strong>
                <small class="fs-06 w-100 text-center">Takım davet etmek için tıkla</small>
            </button>`;
    }

    function joinRequestHtml(request) {
        return `
            <div class="tw-request-row">
                <img src="${attr(request.teamImg || AVATAR_IMG)}" alt="${attr(request.teamName)}">
                <div><strong class="fs-08">${h(request.teamName)}</strong><small class="fs-07">Katılma isteği</small></div>
                <div class="tw-request-actions">
                    <button type="button" class="btn btn-sm btn-success tw-accept-request" data-id="${attr(request.id)}"><i class="fa-solid fa-check"></i></button>
                    <button type="button" class="btn btn-sm btn-light border tw-reject-request" data-id="${attr(request.id)}"><i class="fa-solid fa-xmark"></i></button>
                </div>
            </div>`;
    }


    function findPost(postId) {
        postId = n(postId);
        return (state.data.posts || []).find(function (x) { return n(x.postId) === postId; }) || null;
    }

    function findGalleryItem(galleryId) {
        galleryId = n(galleryId);
        return (state.data.galleries || []).find(function (x) { return n(x.tournamentGalleryId) === galleryId; }) || null;
    }

    function findPostTagIds(postId) {
        postId = n(postId);
        return (state.data.postTagRelations || [])
            .filter(function (x) { return n(x.postId) === postId; })
            .map(function (x) { return n(x.postTagId); })
            .filter(function (x) { return x > 0; });
    }

    function normalizeTournamentDocuments() {
        if (!state.data) return [];
        state.data.tournamentDocuments = state.data.tournamentDocuments || [];

        $.each(state.data.tournamentDocuments, function (index, documentItem) {
            if (!documentItem) return;
            if (!documentItem._rowKey) {
                documentItem._rowKey = n(documentItem.tournamentDocumentId) > 0
                    ? `doc_${n(documentItem.tournamentDocumentId)}`
                    : `tmp_${Date.now()}_${index}`;
            }
        });

        return state.data.tournamentDocuments;
    }

    function documentRowKey(documentItem, index) {
        if (!documentItem) return `tmp_${Date.now()}_${index || 0}`;
        if (!documentItem._rowKey) {
            documentItem._rowKey = n(documentItem.tournamentDocumentId) > 0
                ? `doc_${n(documentItem.tournamentDocumentId)}`
                : `tmp_${Date.now()}_${index || 0}`;
        }
        return documentItem._rowKey;
    }

    function safeDocumentFieldKey(rowKey) {
        return String(rowKey || '').replace(/[^a-zA-Z0-9_-]/g, '_');
    }

    function getCKEditorDataByName(name, fallback) {
        const activeEditor = editorInstances.find(function (editorData) {
            return editorData && editorData.name === name && editorData.element && document.body.contains(editorData.element);
        });

        if (activeEditor && activeEditor.editor && typeof activeEditor.editor.getData === 'function') {
            return activeEditor.editor.getData();
        }

        const editorData = editorInstances.find(function (item) { return item && item.name === name; });
        if (editorData && editorData.editor && typeof editorData.editor.getData === 'function') {
            return editorData.editor.getData();
        }

        return fallback == null ? '' : String(fallback);
    }

    function findTournamentDocumentByRowKey(rowKey, documentId) {
        const key = String(rowKey || '');
        const id = n(documentId);
        return (state.data && state.data.tournamentDocuments ? state.data.tournamentDocuments : []).find(function (documentItem, index) {
            const itemKey = documentRowKey(documentItem, index);
            if (key && String(itemKey) === key) return true;
            return id > 0 && n(documentItem.tournamentDocumentId) === id;
        }) || {};
    }

    function documentPreviewText(description) {
        const text = $('<div/>')
            .html(safeHtml(description || ''))
            .text()
            .replace(/\s+/g, ' ')
            .trim();

        return text || 'Sözleşme metni henüz girilmedi.';
    }

    function collectTournamentDocumentsFromDom() {
        const tournamentId = state.data && state.data.tournament ? n(state.data.tournament.tournamentId) : 0;
        return normalizeTournamentDocuments().map(function (documentItem, index) {
            const documentId = n(documentItem.tournamentDocumentId);
            const $toggle = $(`.tw-document-visibility-toggle[data-document-id="${documentId}"]`);
            return {
                tournamentDocumentId: documentId,
                tournamentId: tournamentId,
                name: documentItem.name || '',
                description: documentItem.description || '',
                order: n(documentItem.order) > 0 ? n(documentItem.order) : index + 1,
                isVisible: $toggle.length ? $toggle.prop('checked') : boolValue(documentItem.isVisible),
                _rowKey: documentRowKey(documentItem, index)
            };
        });
    }

    function documentSnapshot() {
        return collectTournamentDocumentsFromDom().map(function (documentItem, index) {
            return {
                tournamentDocumentId: n(documentItem.tournamentDocumentId),
                name: $.trim(documentItem.name || ''),
                description: documentItem.description || '',
                order: n(documentItem.order) > 0 ? n(documentItem.order) : index + 1,
                isVisible: boolValue(documentItem.isVisible)
            };
        });
    }

    function syncTournamentDocumentsFromDomToState() {
        if (!state.data || !$('#TournamentDocumentsForm').length) return;
        state.data.tournamentDocuments = collectTournamentDocumentsFromDom();
    }

    function documentCardHtml(documentItem, index) {
        const title = $.trim(documentItem.name || '') || `Sözleşme ${index + 1}`;
        const preview = documentPreviewText(documentItem.description);
        const isVisible = boolValue(documentItem.isVisible);

        return `
            <label class="tw-panel tw-document-card tw-document-switch-card ${isVisible ? 'is-visible' : ''}" data-document-id="${attr(documentItem.tournamentDocumentId || 0)}">
                <div class="tw-document-card-head">
                    <div class="tw-document-left">
                        <span class="tw-document-index fs-06">${h(String(index + 1).padStart(2, '0'))}</span>
                        <div class="tw-document-title">
                            <strong class="fs-08"><i class="fa-solid fa-file-signature me-1"></i>${h(title)}</strong>
                            <span class="fs-06">${isVisible ? 'Turnuva profilinde gösteriliyor' : 'Turnuva profilinde gizli'}</span>
                        </div>
                    </div>
                    <span class="form-check form-switch m-0">
                        <input class="form-check-input tw-document-visibility-toggle" type="checkbox"
                               data-document-id="${attr(documentItem.tournamentDocumentId || 0)}"
                               ${isVisible ? 'checked' : ''}>
                    </span>
                </div>
                <p class="tw-document-preview fs-07">${h(preview)}</p>
            </label>`;
    }

    function renderDocumentsStep() {
        const t = (state.data && state.data.tournament) || {};
        const tournamentId = n(t.tournamentId);
        const documents = normalizeTournamentDocuments();
        const visibleCount = documents.filter(function (x) { return boolValue(x.isVisible); }).length;

        return `
            <form id="TournamentDocumentsForm" class="tw-form" data-entity-name="TournamentDocument">
                <div class="tw-section-head m-2">
                    <div>
                        <h3 class="fs-08">Sözleşmeler</h3>
                        <p class="fs-07">Varsayılan sözleşmeler turnuvaya sabit olarak kopyalanır. Profilde göstermek istemediklerini kapatabilirsin.</p>
                    </div>
                    ${stepActionsHtml('tw-save-documents', 'Kaydet', `<span class="tw-document-visible-count fs-07">${visibleCount}/${documents.length} açık</span>`)}
                </div>

                ${tournamentId <= 0 ? `<div class="tw-empty m-2"><i class="fa-solid fa-lock"></i><span class="fs-07">Sözleşme düzenlemek için önce turnuva taslağını kaydet.</span></div>` : ''}

                <div id="TournamentDocumentsList" class="tw-document-list m-2 ${tournamentId <= 0 ? 'd-none' : ''}">
                    ${documents.length ? documents.map(documentCardHtml).join('') : `<div class="tw-empty"><i class="fa-solid fa-file-circle-plus"></i><span class="fs-07">Turnuvaya kopyalanmış varsayılan sözleşme bulunamadı.</span></div>`}
                </div>
            </form>`;
    }

    function renderNewsStep() {
        const posts = state.data.posts || [];
        return `
            <div class="tw-section-head m-2">
                <div>
                    <h3 class="fs-08">Blog</h3>
                    <p class="fs-07">Turnuvaya özel blog oluştur, kategori ve etiketlerini yönet.</p>
                </div>
                ${stepActionsHtml('tw-save-news', 'Tamam', `<button type="button" class="btn btn-success fs-07 tw-open-post-modal"><i class="fa-solid fa-plus me-1"></i>Blog Ekle</button>`)}
            </div>
            <div class="row m-0 tw-post-grid">
                ${posts.length ? posts.map(renderPostCard).join('') : `<div class="col-12 p-2">${emptyCard('Bu turnuva için henüz blog eklenmedi.')}</div>`}
            </div>`;
    }

    function renderPostCard(post) {
        const tags = (post.tagNames || []).filter(Boolean);
        return `
            <div class="col-12 col-md-6 col-xl-4 p-2">
                <article class="tw-post-card">
                    <button type="button" class="tw-post-cover tw-open-post-modal" data-id="${attr(post.postId)}">
                        <img src="${attr(post.img || DEFAULT_IMG)}" alt="${attr(post.name || 'Blog')}">
                        ${post.video ? `<span class="tw-media-type"><i class="fa-solid fa-play me-1"></i>Video</span>` : ''}
                    </button>
                    <div class="tw-post-body">
                        <div class="tw-post-meta fs-06"><span>${h(post.categoryName || 'Kategori yok')}</span><span>#${h(post.order || 0)}</span></div>
                        <h4 class="fs-08">${h(post.name || 'Başlıksız blog')}</h4>
                        <div class="tw-post-desc fs-07">${safeHtml(post.description || '-')}</div>
                        <div class="tw-tag-cloud">${tags.length ? tags.map(function (tag) { return `<span>${h(tag)}</span>`; }).join('') : '<span>Etiket yok</span>'}</div>
                        <div class="tw-card-actions">
                            <button type="button" class="btn btn-light border fs-07 tw-open-post-modal" data-id="${attr(post.postId)}"><i class="fa-solid fa-pen me-1"></i>Düzenle</button>
                            <button type="button" class="btn btn-danger fs-07 tw-delete-post" data-id="${attr(post.postId)}"><i class="fa-solid fa-trash me-1"></i>Sil</button>
                        </div>
                    </div>
                </article>
            </div>`;
    }

    function renderMediaStep() {
        const galleries = (state.data.galleries || []).slice().sort(function (a, b) {
            const ao = n(a.sortOrder); const bo = n(b.sortOrder);
            if (ao !== bo) return (ao || 999999) - (bo || 999999);
            return n(a.tournamentGalleryId) - n(b.tournamentGalleryId);
        });
        const group = `tournament-gallery-${n((state.data.tournament || {}).tournamentId)}`;
        return `
            <div class="tw-section-head m-2">
                <div>
                    <h3 class="fs-08">Medya</h3>
                    <p class="fs-07">Fotoğrafları sürükle-bırak ile sıralayabilir, sıralamayı veritabanına kaydedebilirsin.</p>
                </div>
                ${stepActionsHtml('tw-save-media', 'Kaydet', `<button type="button" class="btn btn-success fs-07 tw-open-gallery-modal"><i class="fa-solid fa-upload me-1"></i>Fotoğraf Ekle</button>`)}
            </div>
            <div class="row m-0 tw-gallery-grid" data-sort-container="gallery">
                ${galleries.length ? galleries.map(function (item) { return renderGalleryCard(item, group); }).join('') : `<div class="col-12 p-2">${emptyCard('Bu turnuva için henüz medya eklenmedi.')}</div>`}
            </div>`;
    }

    function renderGalleryCard(item, group) {
        return `
            <div class="col-6 col-md-4 col-xl-3 p-2 tw-gallery-sortable-item tw-draggable" draggable="true" data-sort-type="gallery" data-gallery-id="${attr(item.tournamentGalleryId)}">
                <article class="tw-gallery-card">
                    <span class="tw-drag-handle fs-06"><i class="fa-solid fa-grip-vertical"></i></span>
                    <button type="button" class="tw-gallery-image openImage" data-url="${attr(item.img || DEFAULT_IMG)}" data-title="${attr(item.name || 'Turnuva görseli')}" data-group="${attr(group)}">
                        <img src="${attr(item.img || DEFAULT_IMG)}" alt="${attr(item.name || 'Turnuva görseli')}">
                    </button>
                    <div class="tw-gallery-info">
                        <strong class="fs-07">${h(item.name || 'Turnuva görseli')}</strong>
                        <small class="fs-06">${h(item.description || '')}</small>
                        <div class="tw-card-actions">
                            <button type="button" class="btn btn-light border fs-07 tw-open-gallery-modal" data-id="${attr(item.tournamentGalleryId)}"><i class="fa-solid fa-pen"></i></button>
                            <button type="button" class="btn btn-danger fs-07 tw-delete-gallery" data-id="${attr(item.tournamentGalleryId)}"><i class="fa-solid fa-trash"></i></button>
                        </div>
                    </div>
                </article>
            </div>`;
    }

    function postModalHtml(post) {
        post = post || {};
        const selectedTagIds = findPostTagIds(post.postId || 0);

        const hasVideo = !!(post.video && String(post.video).trim());
        const postImg = hasVideo ? DEFAULT_IMG : (post.img || DEFAULT_IMG);
        const postVideo = post.video || '';

        return `
        <form id="TournamentPostForm" class="tw-form" data-entity-name="Post" action="javascript:void(0);" method="post" onsubmit="return false;">
            <input type="hidden" name="PostId" value="${attr(post.postId || 0)}">
            <input type="hidden" name="TournamentId" value="${attr((state.data.tournament || {}).tournamentId || 0)}">
            <input type="hidden" id="PostImg" name="PostImg" value="${attr(postImg)}">
            <input type="hidden" id="PostVideo" name="PostVideo" value="${attr(postVideo)}">
            <input type="hidden" id="PostHomePagePermission" name="PostHomePagePermission" value="${boolValue(post.homePagePermission) ? 'true' : 'false'}">

            <input type="hidden" id="PostCategoryId" name="PostCategoryId" value="8">

            <div class="row m-0">
                <div class="col-12 p-2">
                    <div class="tw-post-media-grid">
                        <button type="button"
                                class="tw-post-media-card tw-post-image-upload ${hasVideo ? 'is-disabled' : ''}"
                                data-current-url="${attr(postImg)}">
                            <span class="tw-post-media-preview">
                                <img src="${attr(postImg || DEFAULT_IMG)}" alt="Blog Resmi">
                            </span>
                            <span class="tw-post-media-title">
                                <i class="fa-solid fa-image me-1"></i>Blog Resmi
                            </span>
                            <small>Resim seçilirse video kaldırılır.</small>
                        </button>

                        <button type="button"
                                class="tw-post-media-card tw-post-video-upload ${hasVideo ? 'has-video' : ''}"
                                data-current-url="${attr(postVideo)}">
                            <span class="tw-post-media-preview tw-post-video-preview">
                                ${hasVideo
                ? `<video src="${attr(postVideo)}" muted playsinline preload="metadata"></video>`
                : `<i class="fa-solid fa-video"></i>`
            }
                            </span>
                            <span class="tw-post-media-title">
                                <i class="fa-solid fa-video me-1"></i>Blog Videosu
                            </span>
                            <small>Video seçilirse resim kaldırılır.</small>
                        </button>
                    </div>
                </div>

                ${renderField('Başlık', input('PostName', post.name || '', 'text', 'required'), 'fa-heading', 'col-12')}
                ${renderField('Ana Etiket', select('PostTagId', optionsHtml(state.data.postTags || [], post.postTagId || 0, 'Ana etiket seç')), 'fa-tag', 'col-12 col-md-6')}
                 
                ${renderField('Açıklama', `<textarea id="PostDescription" name="PostDescription" class="form-control border-none tw-control fs-07 ckEditor" rows="7">${h(post.description || '')}</textarea>`, 'fa-comment', 'col-12').replace('tw-field-card', 'tw-field-card tw-ckeditor-field')}            </div>

            <div class="tw-modal-actions">
                <button type="button" class="btn btn-primary fs-07 tw-submit-post">
                    <i class="fa-solid fa-floppy-disk me-1"></i>Kaydet
                </button>
            </div>
        </form>`;
    }

    function getPostDescriptionValue() {
        const $textarea = $('#PostDescription');

        if (typeof editorInstances !== 'undefined' && editorInstances && editorInstances.length) {
            const editorData = editorInstances.find(function (item) {
                return item && item.name === 'PostDescription' && item.editor;
            });

            if (editorData && editorData.editor && typeof editorData.editor.getData === 'function') {
                return editorData.editor.getData();
            }
        }

        return $textarea.val() || '';
    }

    async function initPostDescriptionEditor($modal) {
        const textarea = $modal.find('#PostDescription')[0];
        if (!textarea) return;

        if (typeof window.createCkEditor === 'function') {
            window.createCkEditor(textarea);
            return;
        }

        if (typeof window.loadCkEditor === 'function') {
            window.loadCkEditor();
            return;
        }

        if (typeof window.CkEditorLoad === 'function') {
            window.CkEditorLoad();
            return;
        }

        try { await window.sahaseninFeatureAssets.ckEditor(); }
        catch (error) { console.error('Metin editörü yüklenemedi:', error); return; }
        if (!textarea.isConnected) return;

        if (typeof window.ClassicEditor !== 'undefined' && typeof window.ClassicEditor.create === 'function') {
            window.ClassicEditor.create(textarea).then(function (editor) {
                if (!textarea.isConnected) return editor.destroy();
                window.editorInstances = window.editorInstances || [];

                window.editorInstances = window.editorInstances.filter(function (item) {
                    return item && item.name !== 'PostDescription';
                });

                window.editorInstances.push({
                    name: 'PostDescription',
                    editor: editor
                });
            }).catch(function (error) {
                console.error(error);
            });
        }
    }

    function getPostUploader() {
        if (typeof window.uploadImage === 'function') {
            return window.uploadImage;
        }

        if (typeof uploadTournamentImage === 'function') {
            return uploadTournamentImage;
        }

        if (window.TournamentBuilder && typeof window.TournamentBuilder.uploadImage === 'function') {
            return window.TournamentBuilder.uploadImage;
        }

        return null;
    }

    function openHiddenPostFileInput(accept, onSelected) {
        const input = document.createElement('input');

        input.type = 'file';
        input.accept = accept || '';
        input.className = 'd-none';
        input.style.position = 'fixed';
        input.style.left = '-9999px';
        input.style.top = '-9999px';
        input.style.opacity = '0';

        input.addEventListener('change', function (event) {
            const file = event.target.files && event.target.files[0];

            try {
                document.body.removeChild(input);
            } catch (e) { }

            if (!file) return;

            if (typeof onSelected === 'function') {
                onSelected(file);
            }
        }, { once: true });

        document.body.appendChild(input);

        input.click();
    }

    function bindPostMediaUpload() {
        $(document)
            .off('click.tournamentPostImageUpload', '.tw-post-image-upload')
            .on('click.tournamentPostImageUpload', '.tw-post-image-upload', function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                const $btn = $(this);

                openHiddenPostFileInput('image/*', async function (imageFile) {
                    const uploader = getPostUploader();

                    if (!uploader) {
                        notifyError('Resim yükleme fonksiyonu bulunamadı.');
                        return;
                    }

                    try {
                        setLoading(true, 'Resim yükleniyor...');

                        const imageUrl = await uploader(imageFile, 'Post');

                        $('#PostImg').val(imageUrl || DEFAULT_IMG);
                        $('#PostVideo').val('');

                        $btn
                            .removeClass('is-disabled')
                            .attr('data-current-url', imageUrl || DEFAULT_IMG)
                            .find('img')
                            .attr('src', imageUrl || DEFAULT_IMG);

                        const $videoBtn = $('.tw-post-video-upload');

                        $videoBtn
                            .removeClass('has-video')
                            .attr('data-current-url', '')
                            .find('.tw-post-video-preview')
                            .html('<i class="fa-solid fa-video"></i>');

                        markDirty();
                        setLoading(false);
                    } catch (error) {
                        setLoading(false);
                        notifyError(error);
                    }
                });

                return false;
            });

        $(document)
            .off('click.tournamentPostVideoUpload', '.tw-post-video-upload')
            .on('click.tournamentPostVideoUpload', '.tw-post-video-upload', function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                const $btn = $(this);

                openHiddenPostFileInput('video/*', async function (videoFile) {
                    const uploader = getPostUploader();

                    if (!uploader) {
                        notifyError('Video yükleme fonksiyonu bulunamadı.');
                        return;
                    }

                    try {
                        setLoading(true, 'Video yükleniyor...');

                        const videoUrl = await uploader(videoFile, 'Post');

                        $('#PostVideo').val(videoUrl || '');
                        $('#PostImg').val(DEFAULT_IMG);

                        $btn
                            .addClass('has-video')
                            .attr('data-current-url', videoUrl || '')
                            .find('.tw-post-video-preview')
                            .html(`<video src="${attr(videoUrl || '')}" muted playsinline preload="metadata"></video>`);

                        const $imageBtn = $('.tw-post-image-upload');

                        $imageBtn
                            .addClass('is-disabled')
                            .attr('data-current-url', DEFAULT_IMG)
                            .find('img')
                            .attr('src', DEFAULT_IMG);

                        markDirty();
                        setLoading(false);
                    } catch (error) {
                        setLoading(false);
                        notifyError(error);
                    }
                });

                return false;
            });
    }

    function galleryModalHtml(item) {
        item = item || {};

        return `
        <form id="TournamentGalleryForm" class="tw-form" data-entity-name="TournamentGallery" action="javascript:void(0);" method="post" onsubmit="return false;">
            <input type="hidden" name="TournamentGalleryId" value="${attr(item.tournamentGalleryId || 0)}">
            <input type="hidden" name="TournamentId" value="${attr((state.data.tournament || {}).tournamentId || 0)}">
            <input type="hidden" name="GallerySortOrder" value="${attr(item.sortOrder || 0)}">

            <div class="row m-0">
                ${imageCardHtml('Galeri Fotoğrafı', 'GalleryImg', item.img || DEFAULT_IMG, 'fa-image', 'tournament-gallery-images', 'TournamentGallery', 'col-12 p-2')}
                ${renderField('Adı', input('GalleryName', item.name || '', 'text', 'required'), 'fa-heading', 'col-12')}
                ${renderField('Açıklama', `<textarea id="GalleryDescription" name="GalleryDescription" class="form-control border-none tw-control fs-07" rows="4">${h(item.description || '')}</textarea>`, 'fa-comment', 'col-12')}
            </div>

            <div class="tw-modal-actions">
                <button type="button" class="btn btn-primary fs-07 tw-submit-gallery">
                    <i class="fa-solid fa-floppy-disk me-1"></i>Kaydet
                </button>
            </div>
        </form>`;
    }

    function openPostModal(postId) {
        if (!ensureSavedTournament()) return;

        const post = findPost(postId);

        openModal(post ? 'Blog Düzenle' : 'Blog Ekle', postModalHtml(post), function ($modal) {
            if (typeof window.s2Each === 'function') window.s2Each();
            if (typeof window.parentS2each === 'function') window.parentS2each();

            bindPostMediaUpload();

            setTimeout(function () {
                loadCKeditor($('#TournamentPostForm'));
            }, 50);

            $(document)
                .off('submit.tournamentPost', '#TournamentPostForm')
                .on('submit.tournamentPost', '#TournamentPostForm', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    return false;
                });

            $(document)
                .off('click.tournamentPost', '.tw-submit-post')
                .on('click.tournamentPost', '.tw-submit-post', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    const $form = $('#TournamentPostForm');
                    if (!$form.length) return false;

                    savePost($form, $modal);

                    return false;
                });
        });
    }

    function openGalleryModal(galleryId) {
        if (!ensureSavedTournament()) return;

        const item = findGalleryItem(galleryId);

        openModal(item ? 'Fotoğraf Düzenle' : 'Fotoğraf Ekle', galleryModalHtml(item), function ($modal) {
            $(document)
                .off('submit.tournamentGallery', '#TournamentGalleryForm')
                .on('submit.tournamentGallery', '#TournamentGalleryForm', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    return false;
                });

            $(document)
                .off('click.tournamentGallery', '.tw-submit-gallery')
                .on('click.tournamentGallery', '.tw-submit-gallery', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    const $form = $('#TournamentGalleryForm');
                    if (!$form.length) return false;

                    saveGallery($form, $modal);

                    return false;
                });
        });
    }

    function ensureSavedTournament() {
        if (state.data && state.data.tournament && n(state.data.tournament.tournamentId) > 0) return true;
        notifyError('Bu işlem için önce turnuva taslağını kaydetmelisin.');
        return false;
    }


    function collectPostPayload($form) {
        const tagIds = $.map($form.find('#PostTagIds').val() || [], function (value) { return n(value); }).filter(function (value) { return value > 0; });
        const mainTagId = n($form.find('#PostTagId').val());
        if (mainTagId > 0 && tagIds.indexOf(mainTagId) < 0) tagIds.push(mainTagId);
        return {
            PostId: n($form.find('[name="PostId"]').val()),
            TournamentId: n($form.find('[name="TournamentId"]').val()),
            Img: $('#PostImg').val() || DEFAULT_IMG,
            Video: $form.find('#PostVideo').val() || '',
            Name: $form.find('#PostName').val() || '',
            PostCategoryId: n($form.find('#PostCategoryId').val()),
            PostTagId: mainTagId,
            Description: $form.find('#PostDescription').val() || '',
            Order: n($form.find('#PostOrder').val()),
            HomePagePermission: $form.find('#PostHomePagePermission').is(':checked'),
            PostTagIds: tagIds
        };
    }

    function collectGalleryPayload($form) {
        return {
            TournamentGalleryId: n($form.find('[name="TournamentGalleryId"]').val()),
            TournamentId: n($form.find('[name="TournamentId"]').val()),
            Img: $('#GalleryImg').val() || DEFAULT_IMG,
            Name: $form.find('#GalleryName').val() || '',
            Description: $form.find('#GalleryDescription').val() || '',
            SortOrder: n($form.find('[name="GallerySortOrder"]').val())
        };
    }

    function savePost($form, $modal) {
        const formData = new FormData();

        const img = $.trim($('#PostImg').val() || '');
        const video = $.trim($('#PostVideo').val() || '');

        formData.append('PostId', n($form.find('[name="PostId"]').val()));
        formData.append('TournamentId', n($form.find('[name="TournamentId"]').val()));
        formData.append('Img', video ? DEFAULT_IMG : (img || DEFAULT_IMG));
        formData.append('Video', video || '');
        formData.append('Name', $form.find('[name="PostName"]').val() || '');
        formData.append('PostCategoryId', n($form.find('[name="PostCategoryId"]').val()));
        formData.append('PostTagId', n($form.find('[name="PostTagId"]').val()));
        formData.append('Description', getPostDescriptionValue());
        formData.append('Order', n($form.find('[name="PostOrder"]').val()));
        formData.append('HomePagePermission', $('#PostHomePagePermission').val() === 'true');

        const tagIds = $form.find('[name="PostTagIds"]').val() || [];
        $.each(tagIds, function (_, tagId) {
            formData.append('PostTagIds', tagId);
        });

        setLoading(true, 'Blog kaydediliyor...');

        request({
            url: API + '/SavePost',
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false
        }).then(function (response) {
            setRemoteState(response);
            closeModal($modal);
            state.activeStep = 'news';
            render();
            setLoading(false);
        }).catch(function (xhr) {
            setLoading(false);
            notifyError(xhr);
        });
    }

    function saveGallery($form, $modal) {
        const payload = collectGalleryPayload($form);
        if (!payload.Name) { notifyError('Fotoğraf adı zorunludur.'); return; }
        setLoading(true, 'Fotoğraf kaydediliyor...');
        request({ url: API + '/SaveTournamentGallery', method: 'POST', contentType: 'application/json; charset=utf-8', data: JSON.stringify(payload) })
            .then(function (response) {
                setRemoteState(response);
                closeModal($modal);
                setLoading(false);
                state.activeStep = 'media';
                render();
            })
            .catch(function (xhr) { setLoading(false); notifyError(xhr); });
    }

    function deletePost() {
        const id = n($(this).data('id'));
        if (id <= 0) return;
        confirmDialog('Bu blog silinecek. Devam edilsin mi?', 'Blog silinsin mi?')
            .then(function (ok) {
                if (!ok) return;
                setLoading(true, 'Blog siliniyor...');
                request({ url: API + '/DeleteTournamentPost', method: 'POST', data: { id: id } })
                    .then(function (response) { setRemoteState(response); setLoading(false); state.activeStep = 'news'; render(); })
                    .catch(function (xhr) { setLoading(false); notifyError(xhr); });
            });
    }

    function deleteGallery() {
        const id = n($(this).data('id'));
        if (id <= 0) return;
        confirmDialog('Bu fotoğraf galeriden silinecek. Devam edilsin mi?', 'Fotoğraf silinsin mi?')
            .then(function (ok) {
                if (!ok) return;
                setLoading(true, 'Fotoğraf siliniyor...');
                request({ url: API + '/DeleteTournamentGallery', method: 'POST', data: { id: id } })
                    .then(function (response) { setRemoteState(response); setLoading(false); state.activeStep = 'media'; render(); })
                    .catch(function (xhr) { setLoading(false); notifyError(xhr); });
            });
    }

    function saveNewsStep() {
        markClean();
        return $.Deferred().resolve().promise();
    }

    function saveMediaStep() {
        const tournamentId = state.data && state.data.tournament ? n(state.data.tournament.tournamentId) : 0;
        const galleryIds = $('.tw-gallery-sortable-item').map(function () { return n($(this).data('gallery-id')); }).get().filter(function (x) { return x > 0; });
        if (tournamentId <= 0 || !galleryIds.length) {
            markClean();
            notifySuccess('Medya adımı tamamlandı.');
            return $.Deferred().resolve().promise();
        }
        setLoading(true, 'Medya sırası kaydediliyor...');
        return request({
            url: API + '/SaveGalleryOrder',
            method: 'POST',
            data: JSON.stringify({ tournamentId: tournamentId, galleryIds: galleryIds }),
            contentType: 'application/json; charset=utf-8'
        }).then(function (response) {
            setRemoteState(response);
            setLoading(false);
            render();
            notifySuccess('Medya sırası kaydedildi.');
        }).catch(function (xhr) { setLoading(false); notifyError(xhr); });
    }

    function hasGroupLicensedPlayerRules() {
        const t = (state.data && state.data.tournament) || {};
        return isGroupFixtureMode(t.tournamentGameTypeEnum) && Math.max(0, n(t.groupCount)) > 1;
    }

    function renderRulesStep() {
        const t = state.data.tournament || {};
        const groupLicenseMode = hasGroupLicensedPlayerRules();
        const allowInternalTransfer = boolValue(t.allowInternalTransfer);

        return `
            <div class="tw-section-head m-2">
                <div>
                    <h3 class="fs-08">Kurallar</h3>
                    <p class="fs-07">Transfer, oyuncu değişikliği ve lisanslı oyuncu sınırlarını buradan yönet.</p>
                </div>
                ${stepActionsHtml('tw-save-rules', 'Kaydet')}
            </div>

            <form id="TournamentRulesForm" class="tw-form mb-2" data-entity-name="Tournament">
                <div class="tw-rules-hero m-2">
                    <div class="tw-rules-hero-icon"><i class="fa-solid fa-scale-balanced"></i></div>
                    <div>
                        <strong class="fs-08">Turnuva kuralları</strong>
                        <span class="fs-07">0 değeri ilgili kuralda sınır uygulanmayacağı anlamına gelir.</span>
                    </div>
                </div>

                <div class="row m-0">
                    ${renderField('Transfer Bitiş Tarihi', input('TransferDeadline', dateInputValue(t.transferDeadline), 'date'), 'fa-calendar-xmark', 'col-6', 'Takımlar arası genel transfer işlemlerinin son tarihi.')}
                    ${renderField('Turnuva İçi Transfer', switchHtml('AllowInternalTransfer', allowInternalTransfer, 'Turnuva içi transfer yapılabilir'), 'fa-right-left', 'col-6', 'Kapalıysa turnuva içi transfer tarihleri pasif kalır.')}
                    ${renderField('Turnuva İçi Transfer Başlangıç', input('InternalTransferStartDate', dateInputValue(t.internalTransferStartDate), 'date', allowInternalTransfer ? '' : 'disabled'), 'fa-calendar-plus', `col-6 tw-internal-transfer-field ${allowInternalTransfer ? '' : 'is-disabled'}`)}
                    ${renderField('Turnuva İçi Transfer Bitiş', input('InternalTransferEndDate', dateInputValue(t.internalTransferEndDate), 'date', allowInternalTransfer ? '' : 'disabled'), 'fa-calendar-check', `col-6 tw-internal-transfer-field ${allowInternalTransfer ? '' : 'is-disabled'}`)}
                    ${renderField('Transfer Edilebilir Oyuncu', numberStepper('TransferPlayerLimit', t.transferPlayerLimit, 1, 'min="0" max="99"'), '', 'col-6', 'Her takımın turnuva boyunca transfer edebileceği oyuncu sayısı.')}
                    ${renderField('Maç İçi Oyuncu Değişikliği', numberStepper('MatchSubstitutionLimit', t.matchSubstitutionLimit, 1, 'min="0" max="99"'), '', 'col-6', 'Bir maç içinde yapılabilecek oyuncu değişikliği sayısı.')}
                    ${groupLicenseMode ? '' : renderField('Lisanslı Oyuncu Sayısı', numberStepper('LicensedPlayerLimit', t.licensedPlayerLimit, 1, 'min="0" max="99"'), '', 'col-6', 'Grup yoksa genel lisanslı oyuncu sınırı uygulanır.')}
                </div>

                ${groupLicenseMode ? renderGroupLicensedPlayerRules() : ''}
            </form>`;
    }

    function renderGroupLicensedPlayerRules() {
        const t = state.data.tournament || {};
        const groups = getFixtureGroups(Math.max(0, n(t.groupCount)));

        return `
            <div class="tw-panel m-2 tw-rules-group-panel">
                <div class="tw-panel-head">
                    <div>
                        <strong class="fs-08"><i class="fa-solid fa-id-badge me-1"></i>Grup Bazlı Lisanslı Oyuncu</strong>
                        <span class="fs-07 ms-2">Grup fikstüründe lisanslı oyuncu sınırı her grup için ayrı belirlenir.</span>
                    </div>
                </div>
                <div class="row m-0 tw-rules-group-grid">
                    ${groups.map(function (group) {
            const inputId = `GroupLicensedPlayerLimit_${group.groupIndex}`;
            return `
                            <div class="col-12 col-md-6 col-xl-4 p-2">
                                <div class="tw-rule-group-card">
                                    <div class="tw-rule-group-head">
                                        <span class="tw-rule-group-badge fs-06">${h(group.groupIndex)}. Grup</span>
                                        <strong class="fs-08">${h(group.name || defaultGroupName(group.groupIndex))}</strong>
                                    </div>
                                    <label class="tw-field-label fs-07" for="${attr(inputId)}">Lisanslı oyuncu sınırı</label>
                                    <input type="number"
                                           min="0"
                                           max="99"
                                           id="${attr(inputId)}"
                                           name="${attr(inputId)}"
                                           class="form-control fw-bold border-none tw-control fs-07 tw-rule-group-license-limit"
                                           value="${attr(group.licensedPlayerLimit || 0)}"
                                           data-group-index="${attr(group.groupIndex)}"
                                           data-group-id="${attr(group.tournamentFixtureGroupId || 0)}">
                                    <small class="fs-06 text-muted">0 = sınırsız</small>
                                </div>
                            </div>`;
        }).join('')}
                </div>
            </div>`;
    }

    function syncInternalTransferRuleFields() {
        const enabled = $('#AllowInternalTransfer').is(':checked');
        $('.tw-internal-transfer-field')
            .toggleClass('is-disabled', !enabled)
            .find('input')
            .prop('disabled', !enabled);
    }

    function renderFixtureStep() {
        const t = state.data.tournament || {};
        const enums = state.data.definitions || state.data.enums || {};
        const matches = state.data.dateRelations || [];
        const groupMatches = matches.filter(function (m) { return Number(m.fixtureTypeEnum) === 2; });
        const knockoutMatches = matches.filter(function (m) { return Number(m.fixtureTypeEnum) === 1; });
        const gameType = normalizeFixtureGameType(t.tournamentGameTypeEnum);
        const tournamentGameTypes = filterTournamentGameTypeOptions(enums.tournamentGameTypes);
        const showGroupFields = isGroupFixtureMode(gameType);
        const showAdvancingField = gameType === 3;

        return `
            <div class="tw-section-head m-2">
                <div>
                    <h3 class="fs-08">Fikstür</h3>
                    <p class="fs-07">Fikstür ayarlarını kaydettiğinde sistem fikstürü otomatik yeniden oluşturur. Rezerve edilmiş maç varsa yeniden oluşturma engellenir.</p>
                </div>
                ${stepActionsHtml('tw-save-fixture-settings', 'Kaydet')}
            </div>

            <form id="TournamentFixtureForm" class=" tw-form mb-2" data-entity-name="Tournament">
                <div class="row m-0">
                    ${renderField('Fikstür Modeli', select('TournamentGameTypeEnum', optionsHtml(tournamentGameTypes, gameType, 'Seçiniz'), 'required'), 'fa-code-branch', 'col-6', "Grup seçili ve grup sayısı 1'den fazlaysa takım dağılımı Takım sekmesinden yapılır.")}
                    ${renderField('Takım Sayısı', input('TeamCount', t.teamCount, 'number', 'min="2" required'), 'fa-list-ol', 'col-6')}
                    ${renderField('Rövanş', switchHtml('Rematch', t.rematch, 'Rövanşlı'), 'fa-repeat', 'col-6')}
                    ${renderField('Fikstür Başlama Tarihi', input('FixtureStartDate', dateInputValue(t.fixtureStartDate), 'date', 'required'), 'fa-calendar-day', 'col-6')}
                    ${renderField('Günlük Maç Sayısı', numberStepper('FixtureMatchesPerDay', getFixtureMatchesPerDayValue(), 1, 'min="1" max="24" required'), '', 'col-6', 'Günde kaç maç yapılacaksa aynı sayıda maç başlama saati girilmelidir.')}
                    ${renderField('Haftalık Maç Sayısı', numberStepper('FixtureMatchesPerWeek', getFixtureMatchesPerWeekValue(), 1, 'min="1" max="200" required'), '', 'col-6', 'Bir haftada planlanacak toplam maç sayısıdır. Fikstür tarihleri bu değere göre haftalara yayılır.')}
                    
                    <div class="col-6 tw-field-col p-2">
                        <label class="tw-field-label fs-07">Maç Başlama Saatleri</label> 
                        ${renderFixtureTimeInputs(t.fixtureMatchStartTimes || '19:00,21:00', getFixtureMatchesPerDayValue())}
                    </div>

                    ${renderField('Maçlar Arası Saat', input('FixtureMatchIntervalHours', t.fixtureMatchIntervalHours || 2, 'number', 'min="1" max="12"'), 'fa-hourglass-half', 'col-6', 'Saat listesi doluysa fikstür öncelikle bu saatleri kullanır.')}
                    ${renderField('Grup Sayısı', numberStepper('GroupCount', t.groupCount, 1, 'min="0"'), '', `col-6 tw-group-field ${showGroupFields ? '' : 'd-none'}`)}
                    ${renderField('Gruptan Çıkacak', input('TeamsAdvancingFromGroup', t.teamsAdvancingFromGroup, 'number', 'min="0"'), 'fa-arrow-up-right-dots', `col-6 tw-group-field tw-knockout-advance-field ${showAdvancingField ? '' : 'd-none'}`)}
                </div>
                ${renderFixtureGroupEditor(gameType)}
            </form>

            <div class="tw-fixture-command m-2">
                <div class="tw-fixture-command-icon"><i class="fa-solid fa-wand-magic-sparkles"></i></div>
                <div class="tw-fixture-command-main">
                    <strong class="fs-08">Akıllı fikstür motoru</strong>
                    <span class="fs-07">Model değişince tasarım ve maç akışı otomatik ayrışır: grup lig tablosu, eleme bracket akışı, grup + eleme hibrit görünüm.</span>
                </div>
                <button type="button" class="btn btn-light border-ff fs-07 tw-rebuild-fixture"><i class="fa-solid fa-rotate me-1"></i>Yeniden Oluştur</button>
            </div>

            <div class="tw-fixture-summary tw-fixture-summary-pro">
                <div><strong class="fs-08">${matches.length}</strong><span class="fs-06">Toplam maç</span></div>
                <div><strong class="fs-08">${groupMatches.length}</strong><span class="fs-06">Grup maçı</span></div>
                <div><strong class="fs-08">${knockoutMatches.length}</strong><span class="fs-06">Eleme maçı</span></div>
                <div><strong class="fs-08">${h(gameTypeLabel(gameType))}</strong><span class="fs-06">Fikstür modeli</span></div>
            </div>

            ${matches.length ? renderFixtureByType(gameType, groupMatches, knockoutMatches) : emptyCard('Fikstür henüz oluşturulmadı. Ayarları kaydettiğinde otomatik oluşturulacak.')}`;
    }

    function renderFixtureGroupEditor(gameType) {
        const t = state.data.tournament || {};
        gameType = normalizeFixtureGameType(gameType);
        const groupCount = isGroupFixtureMode(gameType) ? Math.max(0, n(t.groupCount)) : 0;
        if (groupCount <= 1) return '';

        const groups = getFixtureGroups(groupCount);
        return `
            <div class="tw-panel m-2 tw-fixture-group-editor">
                <div class="tw-panel-head">
                    <div>
                        <strong class="fs-08"><i class="fa-solid fa-layer-group me-1"></i>Fikstür Grupları</strong>
                        <span class="fs-07 ms-2">Grup adlarını buradan, takım dağılımını Takım sekmesinden yönet.</span>
                    </div>
                </div>
                <div class="row m-0 tw-fixture-group-name-grid">
                    ${groups.map(function (group) {
            return renderField(`${group.groupIndex}. Grup Adı`, `<input type="text" class="form-control border-none tw-control fs-07 tw-fixture-group-name" data-group-index="${attr(group.groupIndex)}" data-group-id="${attr(group.tournamentFixtureGroupId || 0)}" value="${attr(group.name)}">`, 'fa-heading', 'col-12 col-md-6 col-xl-4');
        }).join('')}
                </div>
            </div>`;
    }

    function getFixtureGroups(groupCount) {
        const existing = state.data.fixtureGroups || [];
        const map = {};
        $.each(existing, function (_, group) {
            const index = n(group.groupIndex);
            if (index > 0) map[index] = group;
        });

        const result = [];
        for (let i = 1; i <= groupCount; i++) {
            result.push({
                tournamentFixtureGroupId: map[i] ? n(map[i].tournamentFixtureGroupId) : 0,
                groupIndex: i,
                name: map[i] && map[i].name ? map[i].name : defaultGroupName(i),
                licensedPlayerLimit: map[i] ? n(map[i].licensedPlayerLimit) : 0
            });
        }
        return result;
    }

    function defaultGroupName(index) {
        const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const i = Math.max(1, n(index));
        const letter = alphabet[(i - 1) % alphabet.length];
        const cycle = Math.floor((i - 1) / alphabet.length);
        return cycle === 0 ? `Grup ${letter}` : `Grup ${letter}${cycle + 1}`;
    }

    function collectFixtureGroups() {
        const groupCount = getFixtureGroupCount();
        const byIndex = {};

        $.each(getFixtureGroups(groupCount), function (_, group) {
            if (n(group.groupIndex) <= 0) return;
            byIndex[n(group.groupIndex)] = {
                tournamentFixtureGroupId: n(group.tournamentFixtureGroupId),
                groupIndex: n(group.groupIndex),
                name: group.name || defaultGroupName(group.groupIndex),
                licensedPlayerLimit: n(group.licensedPlayerLimit)
            };
        });

        $('.tw-fixture-group-name').each(function () {
            const groupIndex = n($(this).data('group-index'));
            if (groupIndex <= 0) return;
            byIndex[groupIndex] = byIndex[groupIndex] || {
                tournamentFixtureGroupId: n($(this).data('group-id')),
                groupIndex: groupIndex,
                name: defaultGroupName(groupIndex),
                licensedPlayerLimit: 0
            };
            byIndex[groupIndex].tournamentFixtureGroupId = n($(this).data('group-id'));
            byIndex[groupIndex].name = $(this).val() || defaultGroupName(groupIndex);
        });

        $('.tw-rule-group-license-limit').each(function () {
            const groupIndex = n($(this).data('group-index'));
            if (groupIndex <= 0) return;
            byIndex[groupIndex] = byIndex[groupIndex] || {
                tournamentFixtureGroupId: n($(this).data('group-id')),
                groupIndex: groupIndex,
                name: defaultGroupName(groupIndex),
                licensedPlayerLimit: 0
            };
            byIndex[groupIndex].tournamentFixtureGroupId = n($(this).data('group-id'));
            byIndex[groupIndex].licensedPlayerLimit = Math.max(0, n($(this).val()));
        });

        return Object.keys(byIndex)
            .map(function (key) { return byIndex[key]; })
            .filter(function (x) { return x.groupIndex > 0; })
            .sort(function (a, b) { return a.groupIndex - b.groupIndex; });
    }

    function collectFixtureGroupTeams() {
        const seen = {};
        const result = [];

        $('.tw-team-group-dropzone').each(function () {
            const groupIndex = n($(this).data('group-index'));
            $(this).find('.tw-team-group-item').each(function (index) {
                const teamId = n($(this).data('team-id'));
                if (teamId <= 0 || groupIndex <= 0 || seen[teamId]) return;
                seen[teamId] = true;
                result.push({
                    tournamentFixtureGroupTeamRelationId: n($(this).data('relation-id')),
                    teamId: teamId,
                    groupIndex: groupIndex,
                    sortOrder: index + 1
                });
            });
        });

        $('.tw-fixture-group-team-select, .tw-independent-team-group').each(function () {
            const teamId = n($(this).data('team-id'));
            if (teamId <= 0 || seen[teamId]) return;
            seen[teamId] = true;
            result.push({
                tournamentFixtureGroupTeamRelationId: n($(this).data('relation-id')),
                teamId: teamId,
                groupIndex: n($(this).val()),
                sortOrder: result.length + 1
            });
        });

        return result.filter(function (x) { return x.teamId > 0 && x.groupIndex > 0; });
    }

    function renderFixtureByType(gameType, groupMatches, knockoutMatches) {
        gameType = normalizeFixtureGameType(gameType);
        if (gameType === 1) {
            return `<div class="tw-fixture-stage-shell is-knockout-only">
                <div class="tw-stage-head m-2"><div><strong class="fs-08"><i class="fa-solid fa-trophy me-1"></i>Eleme Ağacı</strong><span class="fs-07">Kazanan bir üst tura akar, boş slotlar net şekilde görünür.</span></div></div>
                ${renderBracket(knockoutMatches, 'tw-bracket-root')}
            </div>`;
        }
        if (gameType === 2) {
            return `<div class="tw-fixture-stage-shell is-group-only">
                <div class="tw-stage-head m-2"><div><strong class="fs-08"><i class="fa-solid fa-table-list me-1"></i>Grup Fikstürü</strong><span class="fs-07">Her grup kendi haftaları ve slotları ile takip edilir.</span></div></div>
                ${renderGroupMatches(groupMatches, getFixtureGroupCount() > 1)}
            </div>`;
        }
        return `
            <div class="tw-tab-scope tw-fixture-type-tabs tw-fixture-stage-shell is-hybrid">
                <div class="tw-stage-head m-2">
                    <div><strong class="fs-08"><i class="fa-solid fa-layer-group me-1"></i>Grup + Eleme Merkezi</strong><span class="fs-07">Önce gruplar, ardından çıkan takımlarla eleme ağacı.</span></div>
                    <div class="tw-mini-tabs tw-stage-tabs" role="tablist">
                        <button type="button" class="tw-mini-tab fs-07 active" data-target="groups"><i class="fa-solid fa-table-list me-1"></i>Gruplar</button>
                        <button type="button" class="tw-mini-tab fs-07" data-target="knockout"><i class="fa-solid fa-trophy me-1"></i>Eleme</button>
                    </div>
                </div>
                <div class="tw-mini-pane" data-pane="groups">${renderGroupMatches(groupMatches, true)}</div>
                <div class="tw-mini-pane d-none" data-pane="knockout">${renderBracket(knockoutMatches, 'tw-bracket-root')}</div>
            </div>`;
    }

    function gameTypeLabel(value) {
        const options = (((state.data.definitions || state.data.enums || {}).tournamentGameTypes) || []);
        const option = options.find(function (x) { return Number(x.value) === Number(value); });
        return option ? option.text : '-';
    }

    function relationSide(m, side) {
        const awayId = n(m._TeamId || m._teamId || 0);
        const awayName = m._TeamName || m._teamName || m.team2Name;
        const awayImg = m._TeamImg || m._teamImg || m.team2Img;
        const awaySlotIndex = n(m._TeamSlotIndex || m._teamSlotIndex || 0);
        const awaySlotLabel = m._TeamSlotLabel || m._teamSlotLabel || '';

        const data = side === 'away'
            ? {
                id: awayId,
                name: awayName,
                img: awayImg,
                slotIndex: awaySlotIndex,
                slotLabel: awaySlotLabel
            }
            : {
                id: n(m.teamId || 0),
                name: m.teamName,
                img: m.teamImg,
                slotIndex: n(m.teamSlotIndex || 0),
                slotLabel: m.teamSlotLabel || ''
            };

        const fallbackLabel = compactFixtureSlotLabel(data.slotLabel, data.slotIndex, side);
        const displayName = data.id > 0 ? (data.name || fallbackLabel) : fallbackLabel;

        return {
            id: data.id,
            name: displayName,
            img: data.id > 0 ? (data.img || AVATAR_IMG) : AVATAR_IMG,
            slotIndex: data.slotIndex,
            slotLabel: fallbackLabel,
            isEmpty: data.id <= 0
        };
    }

    function slotBadgeHtml(side) {
        if (!side.slotLabel || sameFixtureText(side.name, side.slotLabel)) return '';
        return `<span class="tw-slot-badge fs-06 ${side.isEmpty ? 'is-empty' : ''}"><i class="fa-solid fa-hashtag me-1"></i>${h(side.slotLabel)}</span>`;
    }

    function renderGroupMatches(matches, groupMode) {
        if (!matches.length) return emptyCard('Grup maçı yok.');
        const grouped = {};
        $.each(matches, function (_, m) {
            const key = groupMode ? (m.fixtureGroupName || `Grup ${m.fixtureGroupIndex || m.matchIndex || 1}`) : `Hafta ${m.roundIndex || 1}`;
            grouped[key] = grouped[key] || [];
            grouped[key].push(m);
        });

        const keys = Object.keys(grouped).sort(function (a, b) {
            const first = grouped[a][0] || {};
            const second = grouped[b][0] || {};
            return n(first.fixtureGroupIndex || first.roundIndex) - n(second.fixtureGroupIndex || second.roundIndex);
        });

        function groupPanel(key) {
            const list = grouped[key].sort(function (a, b) { return a.fixturOrder - b.fixturOrder; });
            const rounds = {};
            $.each(list, function (_, match) {
                const roundKey = `Hafta ${n(match.roundIndex, 1) || 1}`;
                rounds[roundKey] = rounds[roundKey] || [];
                rounds[roundKey].push(match);
            });

            const roundStackHtml = `
                    <div class="tw-round-stack">
                        ${Object.keys(rounds).sort(function (a, b) { return n(a.replace(/\D/g, '')) - n(b.replace(/\D/g, '')); }).map(function (roundKey) {
                const roundList = rounds[roundKey].sort(function (a, b) { return a.fixturOrder - b.fixturOrder; });
                const firstDate = roundList.length ? (roundList[0].dateLabel || '') : '';
                return `<div class="tw-round-block is-collapsed">
                                <button type="button" class="tw-round-toggle fs-06" aria-expanded="false">
                                    <span class="tw-round-title"><i class="fa-solid fa-calendar-week me-1"></i>${h(roundKey)}</span>
                                    <span class="tw-round-meta">${roundList.length} maç${firstDate ? ' • ' + h(firstDate) : ''}</span>
                                    <i class="fa-solid fa-chevron-down tw-round-chevron"></i>
                                </button>
                                <div class="tw-round-content d-none">
                                    ${roundList.map(groupMatchRow).join('')}
                                </div>
                            </div>`;
            }).join('')}
                    </div>`;

            if (!groupMode) {
                return `
                <div class="tw-panel tw-group-tab-panel tw-fixture-league-panel">
                    <div class="tw-panel-head tw-group-pro-head">
                        <div><strong class="fs-08">${h(key)}</strong><span class="fs-07 ms-2">${list.length} maç • ${Object.keys(rounds).length} hafta</span></div>
                        <span class="tw-stage-chip fs-06"><i class="fa-solid fa-layer-group me-1"></i>${h('Lig')}</span>
                    </div>
                    ${roundStackHtml}
                </div>`;
            }

            return `
                <div class="tw-panel tw-group-tab-panel tw-fixture-league-panel tw-fixture-group-block is-collapsed">
                    <button type="button" class="tw-panel-head tw-group-pro-head tw-fixture-group-toggle" aria-expanded="false">
                        <div class="tw-fixture-group-title"><strong class="fs-08">${h(key)}</strong><span class="fs-07 ms-2">${list.length} maç • ${Object.keys(rounds).length} hafta</span></div>
                        <span class="tw-stage-chip fs-06"><i class="fa-solid fa-layer-group me-1"></i>${h('Grup')}</span>
                        <i class="fa-solid fa-chevron-down tw-fixture-group-chevron"></i>
                    </button>
                    <div class="tw-fixture-group-content d-none">
                        ${roundStackHtml}
                    </div>
                </div>`;
        }

        return `<div class="row m-0 tw-group-grid tw-group-grid-pro">
            ${keys.map(function (key) {
            return `<div class="col-12 col-xl-6 p-2">${groupPanel(key)}</div>`;
        }).join('')}
        </div>`;
    }

    function groupMatchRow(m) {
        const home = relationSide(m, 'home');
        const away = relationSide(m, 'away');
        const matchAction = m.matchId
            ? `<span class="tw-match-action-pill fs-06 OpenSheepPopup" data-url="/Mac-Olustur/${attr(m.matchId)}"><i class="fa-solid fa-futbol me-1"></i>Maç</span>`
            : `<span class="tw-match-action-pill fs-06"><i class="fa-solid fa-futbol me-1"></i>Maç</span>`;

        return `
            <button type="button" class="tw-group-match tw-group-match-pro fs-07 OpenTournamentDateForm ${home.isEmpty || away.isEmpty ? 'has-empty-slot' : ''}" data-id="${attr(m.tournamentDateRelationId)}">
                <span class="tw-match-topline">
                    <span class="tw-date-chip fs-06"><i class="fa-solid fa-clock me-1"></i>${h(m.dateLabel || 'Tarih yok')}</span>
                    ${matchAction}
                </span>

                <span class="tw-match-teams">
                    <span class="tw-match-team is-home ${home.isEmpty ? 'is-empty-slot' : ''}">
                        <img src="${attr(home.img)}" alt="${attr(home.name)}">
                        <span><strong class="fs-07">${h(home.name)}</strong>${slotBadgeHtml(home)}</span>
                    </span>

                    <span class="tw-match-versus fs-06">vs</span>

                    <span class="tw-match-team is-away ${away.isEmpty ? 'is-empty-slot' : ''}">
                        <span><strong class="fs-07">${h(away.name)}</strong>${slotBadgeHtml(away)}</span>
                        <img src="${attr(away.img)}" alt="${attr(away.name)}">
                    </span>
                </span>

                ${m.winnerTeamId ? `<span class="tw-match-result-pill fs-06">Kazanan: ${h(m.winnerTeamName)}</span>` : ''}
            </button>`;
    }

    function renderBracket(matches, rootId) {
        if (!matches.length) return emptyCard('Eleme maçı yok.');
        const groups = groupByRound(matches);
        const html = [];
        $.each(groups, function (colIndex, group) {
            $.each(group, function (localIndex, m) {
                let advance = '';
                if (colIndex < groups.length - 1) {
                    const next = groups[colIndex + 1][Math.floor(localIndex / 2)];
                    if (next) advance = `${next.tournamentDateRelationId}:${localIndex % 2 === 0 ? 'top' : 'bottom'}`;
                }
                html.push(matchCard(m, advance));
            });
        });
        return `
            <div class="tw-bracket-card">
                <div class="bracket-root tw-fixture-viewer" id="${attr(rootId)}">
                    ${html.join('')}
                </div>
            </div>`;
    }

    function groupByRound(matches) {
        const map = new Map();
        const ordered = matches.slice().sort(function (a, b) { return n(a.fixturOrder) - n(b.fixturOrder); });

        $.each(ordered, function (_, m) {
            const label = String(m.matchTypeLabel || '').trim().toLocaleLowerCase('tr-TR');
            const semanticKey = label.indexOf('yarı final') >= 0
                ? 'round:semi-final'
                : (label.indexOf('çeyrek final') >= 0
                    ? 'round:quarter-final'
                    : (label.indexOf('son 16') >= 0
                        ? 'round:last-16'
                        : (label === 'final' ? 'round:final' : '')));
            const key = semanticKey || `schedule:${Math.max(1, Math.floor(n(m.fixturOrder) / 1000))}`;
            if (!map.has(key)) map.set(key, []);
            map.get(key).push(m);
        });

        return Array.from(map.values());
    }

    function matchCard(m, advanceTo) {
        const home = relationSide(m, 'home');
        const away = relationSide(m, 'away');
        const homeWon = Number(m.winnerTeamId) === Number(home.id) && home.id > 0;
        const awayWon = Number(m.winnerTeamId) === Number(away.id) && away.id > 0;
        return `
            <div class="match tw-bracket-match-pro OpenTournamentDateForm ${home.isEmpty || away.isEmpty ? 'has-empty-slot' : ''}"
                 data-id="${attr(m.tournamentDateRelationId)}"
                 data-match-id="${attr(m.tournamentDateRelationId)}"
                 data-fixtur-order="${attr(m.fixturOrder)}"
                 data-match-type="${attr(m.matchTypeLabel || '-')}"
                 data-left-id="${attr(home.id)}"
                 data-left-name="${attr(home.name)}"
                 data-left-img="${attr(home.img)}"
                 data-right-id="${attr(away.id)}"
                 data-right-name="${attr(away.name)}"
                 data-right-img="${attr(away.img)}"
                 ${advanceTo ? `data-advance-to="${attr(advanceTo)}"` : ''}>
                <div class="match-badge fs-06"><i class="fa-solid fa-calendar-day me-1"></i>${h(m.dateLabel || '-')}</div>
                <div class="team-row ${homeWon ? 'is-winner' : ''} ${home.isEmpty ? 'is-empty-slot' : ''}">
                    <div class="team-left"><img class="avatar br-calc" src="${attr(home.img)}"><span class="team-name fs-07">${h(home.name)}</span></div>
                    <span class="team-score fs-08">${homeWon ? '?' : ''}</span>
                </div>
                <div class="match-meta fs-06"><span>${h(m.matchTypeLabel || '-')}</span><strong>VS</strong></div>
                <div class="team-row ${awayWon ? 'is-winner' : ''} ${away.isEmpty ? 'is-empty-slot' : ''}">
                    <div class="team-left"><img class="avatar br-calc" src="${attr(away.img)}"><span class="team-name fs-07">${h(away.name)}</span></div>
                    <span class="team-score fs-08">${awayWon ? '?' : ''}</span>
                </div>
            </div>`;
    }

    function renderPublishStep() {
        const t = state.data.tournament || {};
        const services = state.data.selectedServiceIds || [];
        const teams = state.data.teamRelations || [];
        const matches = state.data.dateRelations || [];
        const errors = publishWarnings();
        return `
            <div class="tw-section-head m-2">
                <div>
                    <h3 class="fs-08">Yayınlama</h3>
                    <p class="fs-07">Son kontrolleri yap, taslağı yayına al veya yayındaki turnuvayı taslağa çek.</p>
                </div>
                ${stepActionsHtml('tw-save-publish', 'Kaydet', `<button type="button" class="btn ${boolValue(t.draft) ? 'btn-success' : 'btn-warning'} tw-publish" data-draft="${boolValue(t.draft) ? 'false' : 'true'}"><i class="fa-solid ${boolValue(t.draft) ? 'fa-bullhorn' : 'fa-box-archive'} me-1"></i>${boolValue(t.draft) ? 'Yayına Al' : 'Taslağa Çek'}</button>`)}
            </div>
            <div class="row m-0">
                <div class="col-12 col-xl-5 p-2">
                    <div class="tw-preview-card">
                        <img src="${attr(t.img || DEFAULT_IMG)}" alt="${attr(t.name)}">
                        <div>
                            <span class="tw-pill ${boolValue(t.draft) ? 'is-draft' : 'is-live'}">${boolValue(t.draft) ? 'Taslak' : 'Yayında'}</span>
                            <h4 class="fs-09">${h(t.name)}</h4>
                            <div class="tw-rich-text fs-07">${safeHtml(t.miniDescription || t.description || '-')}</div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-7 p-2">
                    <div class="tw-check-grid">
                        ${publishCheck('Temel Bilgiler', !!t.name && t.cityId > 0, 'Turnuva adı ve şehir seçimi')}
                        ${publishCheck('Hizmetler', services.length > 0, `${services.length} hizmet seçili`)}
                        ${publishCheck('Takımlar', teams.length > 0, `${teams.length}/${t.teamCount || '?'} takım`)}
                        ${publishCheck('Fikstür', matches.length > 0, `${matches.length} karşılaşma`)}
                    </div>
                    ${errors.length ? `<div class="tw-warning-box"><strong class="fs-08">Eksikler</strong>${errors.map(function (x) { return `<span class="fs-07">${h(x)}</span>`; }).join('')}</div>` : `<div class="tw-success-box"><span class="fs-07 text-primary"><i class="fa-solid fa-circle-check me-1"></i> Yayınlamaya hazır görünüyor.</span></div>`}
                </div>
            </div>`;
    }

    function publishCheck(title, ok, text) {
        return `
            <div class="tw-check-card ${ok ? 'ok' : 'warn'}">
                <i class="fa-solid ${ok ? 'fa-circle-check' : 'fa-triangle-exclamation'}"></i>
                <div><strong class="fs-07">${h(title)}</strong><span class="fs-06">${h(text)}</span></div>
            </div>`;
    }

    function publishWarnings() {
        const t = state.data.tournament || {};
        const warnings = [];
        if (!t.name) warnings.push('Turnuva adı boş.');
        if (!t.cityId) warnings.push('Şehir seçilmemiş.');
        if (!state.data.dateRelations.length) warnings.push('Fikstür oluşturulmamış.');
        if (n(t.tournamentGameTypeEnum) === 1 && !isPowerOfTwo(n(t.teamCount))) warnings.push('Eleme için takım sayısı 2, 4, 8, 16 gibi olmalı.');
        const fixtureGameType = normalizeFixtureGameType(t.tournamentGameTypeEnum);
        if ((fixtureGameType === 2 || fixtureGameType === 3) && !t.groupCount) warnings.push('Grup kullanılan fikstür modelleri için grup sayısı zorunlu.');
        if (fixtureGameType === 3 && !t.teamsAdvancingFromGroup) warnings.push('Grup + Eleme için gruptan çıkacak takım sayısı zorunlu.');
        return warnings;
    }

    function isPowerOfTwo(value) {
        return value > 0 && (value & (value - 1)) === 0;
    }

    function emptyCard(text) {
        return `<div class="tw-empty"><i class="fa-solid fa-circle-info"></i><span class="fs-07">${h(text)}</span></div>`;
    }

    function bindEvents() {
        $(document).off(NS);
        $(window).off(NS);

        $(document).on('click' + NS, '.tw-close', function () { close(false); });

        $(document).on('click' + NS, '.tw-step', function () {
            const nextStep = $(this).data('step');
            if (!nextStep || nextStep === state.activeStep) return;

            updateDirtyUi();
            if (state.dirty) {
                confirmDialog('Bu adımda kaydedilmeyen değişiklikler var. Sekme değiştirirsen bu değişiklikler geri alınacak. Devam edilsin mi?', 'Kaydedilmeyen değişiklik var')
                    .then(function (ok) {
                        if (!ok) return;
                        restoreStepSnapshot(false);
                        state.activeStep = nextStep;
                        state.awardFormOpen = false;
                        state.awardFormDefinitionId = 0;
                        state.awardEditRelationId = 0;
                        state.awardEditDefinitionId = 0;
                        state.awardEditAwardId = 0;
                        render();
                    });
                return;
            }

            state.activeStep = nextStep;
            resetAwardEditState();
            render();
        });

        $(document).on('click' + NS, '.tw-primary-save', function () { saveCurrentStep(); });
        $(document).on('click' + NS, '.tw-discard-changes', discardCurrentStepChanges);
        $(document).on('click' + NS, '.tw-save-base', saveBase);
        $(document).on('click' + NS, '.tw-save-fixture-settings', saveFixtureSettings);
        $(document).on('click' + NS, '.tw-save-rules', saveRules);
        $(document).on('click' + NS, '.tw-save-stat-preferences', function () { saveStatisticPreferences(state.activeStep === 'bests'); });
        $(document).on('click' + NS, '.tw-save-documents', saveTournamentDocuments);
        $(document).on('click' + NS, '.tw-add-document', addTournamentDocumentLocal);
        $(document).on('click' + NS, '.tw-edit-document', openTournamentDocumentEditorLocal);
        $(document).on('click' + NS, '.tw-close-document-editor', closeTournamentDocumentEditorLocal);
        $(document).on('click' + NS, '.tw-remove-document', removeTournamentDocumentLocal);
        $(document).on('click' + NS, '.tw-reset-documents', resetTournamentDocuments);
        $(document).on('click' + NS, '.tw-save-services', saveServices);
        $(document).on('click' + NS, '.tw-save-awards', saveAwards);
        $(document).on('click' + NS, '.tw-save-news', saveNewsStep);
        $(document).on('click' + NS, '.tw-save-media', saveMediaStep);
        $(document).on('click' + NS, '.tw-open-post-modal', function () { openPostModal(n($(this).data('id'))); });
        $(document).on('click' + NS, '.tw-delete-post', deletePost);
        $(document).on('click' + NS, '.tw-open-gallery-modal', function () { openGalleryModal(n($(this).data('id'))); });
        $(document).on('click' + NS, '.tw-delete-gallery', deleteGallery);
        $(document).on('click' + NS, '.tw-save-teams', saveTeams);
        $(document).on('click' + NS, '.tw-save-publish', savePublishStep);
        $(document).on('click' + NS, '.tw-open-award-form', function () {
            state.awardFormOpen = true;
            state.awardFormDefinitionId = 0;
            state.awardEditRelationId = 0;
            state.awardEditDefinitionId = 0;
            state.awardEditAwardId = 0;
            render();
        });
        $(document).on('click' + NS, '.tw-open-award-form-definition', function () {
            state.awardFormOpen = true;
            state.awardFormDefinitionId = n($(this).data('definition-id'));
            state.awardEditRelationId = 0;
            state.awardEditDefinitionId = 0;
            state.awardEditAwardId = 0;
            render();
        });
        $(document).on('click' + NS, '.tw-close-award-form', function () {
            state.awardFormOpen = false;
            state.awardFormDefinitionId = 0;
            state.awardEditRelationId = 0;
            state.awardEditDefinitionId = 0;
            state.awardEditAwardId = 0;
            render();
        });
        $(document).on('click' + NS, '.tw-add-award', addAwardLocal);
        $(document).on('click' + NS, '.tw-edit-award', editAwardLocal);
        $(document).on('click' + NS, '.tw-remove-award', removeAwardLocal);
        $(document).on('change' + NS, '#AwardTypeId', toggleAwardQuantity);
        $(document).on('change' + NS, '.tw-stat-definition-toggle', function () {
            updateStatisticPreferenceUi();
            markDirty();
        });
        $(document).on('change' + NS, '.tw-document-visibility-toggle', function () {
            updateTournamentDocumentVisibilityUi();
            markDirty();
        });
        $(document).on('click' + NS, '.tw-service-card', function (e) {
            if ($(e.target).closest('.tw-drag-handle').length) return;
            $(this).toggleClass('active');
            $(this).closest('.tw-service-sortable-item').toggleClass('is-selected', $(this).hasClass('active'));
            markDirty();
            updateServiceSelectionUi();
        });

        $(document).on('input' + NS + ' change' + NS, '.tw-form input, .tw-form select, .tw-form textarea', function () {
            if ($(this).closest('.tw-award-form-panel, .tw-local-modal, #TournamentPostForm, #TournamentGalleryForm').length) return;
            markDirty();
        });

        $(document).on('change' + NS, '#TournamentGameTypeEnum, #GroupCount', function () {
            syncFixtureFormToState();
            markDirty();
            render();
        });

        $(document).on('change' + NS, '.tw-fixture-group-team-select', function () {
            markDirty();
        });

        $(document).on('input' + NS + ' change' + NS, '#FixtureMatchesPerDay', function () {
            rebuildFixtureTimeInputsByMatchCount();
            markDirty();
        });

        $(document).on('input' + NS + ' change' + NS, '#FixtureMatchesPerWeek', function () {
            markDirty();
        });

        $(document).on('input' + NS + ' change' + NS, '.tw-fixture-time-input', function () {
            syncFixtureTimeInputs();
            markDirty();
        });

        $(document).on('click' + NS, '.tw-open-add-team', openTeamModal);
        $(document).on('click' + NS, '.tw-remove-team', removeTeam);
        $(document).on('click' + NS, '.tw-accept-request', function () { changeJoinRequest($(this).data('id'), true); });
        $(document).on('click' + NS, '.tw-reject-request', function () { changeJoinRequest($(this).data('id'), false); });
        $(document).on('click' + NS, '.tw-rebuild-fixture', rebuildFixture);
        $(document).on('click' + NS, '.OpenTournamentDateForm', function (e) {
            e.preventDefault();

            var element = $(this);

            if (element.hasClass('OpenSheepPopup') || $(e.target).closest('.OpenSheepPopup').length) {
                return;
            }

            openMatchModal(element.data('id'));
        });
        $(document).on('click' + NS, '.tw-mini-tab', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const target = String($(this).data('target') || '');
            const $scope = $(this).closest('.tw-tab-scope');
            if (!target || !$scope.length) return;
            $scope.children('.tw-mini-tabs').find('.tw-mini-tab').removeClass('active');
            $(this).addClass('active');
            $scope.children('.tw-mini-pane').addClass('d-none');
            $scope.children(`.tw-mini-pane[data-pane="${target}"]`).removeClass('d-none');
            renderBracketAfterDelay();
        });
        $(document).off('click' + NS, '.tw-round-toggle');
        $(document).on('click' + NS, '.tw-round-toggle', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            toggleRoundBlock($(this));
        });
        $(document).off('click' + NS, '.tw-fixture-group-toggle');
        $(document).on('click' + NS, '.tw-fixture-group-toggle', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            toggleFixtureGroupBlock($(this));
        });
        $(document).on('click' + NS, '.tw-publish', publish);
        $(document).on('change' + NS, '.tw-switch-input', function () {
            $(this).closest('.tw-switch-wrap').toggleClass('is-on', $(this).is(':checked')).find('.tw-switch-status').text($(this).is(':checked') ? 'Açık' : 'Kapalı');
        });
        $(document).on('change' + NS, '#AllowInternalTransfer', function () {
            syncInternalTransferRuleFields();
            markDirty();
        });
        $(document).on('change' + NS, '#CityId', syncCityLocation);
        $(document).on('click' + NS, '.tw-inc, .tw-dec', changeStepperValue);
        $(document).on('click' + NS, '.tw-image-action', openImageActionMenu);
        $(document).on('change' + NS, '.tw-hidden-file', uploadWizardImageFromInput);
        $(document).on('dragstart' + NS, '.tw-draggable', onDragStart);
        $(document).on('dragend' + NS, '.tw-draggable', onDragEnd);
        $(document).on('dragover' + NS, '[data-sort-container]', onSortDragOver);
        $(document).on('drop' + NS, '[data-sort-container]', onSortDrop);
        $(document).on('pointerdown' + NS, '.tw-drag-handle', onPointerSortStart);
        $(document).on('pointermove' + NS, onPointerSortMove);
        $(document).on('pointerup' + NS + ' pointercancel' + NS, onPointerSortEnd);

        $(window).on('beforeunload' + NS, function () {
            updateDirtyUi();
            if (state.dirty) return 'Kaydedilmeyen değişiklikler var.';
        });
    }


    function onDragStart(e) {
        const oe = e.originalEvent || e;
        if (!$(oe.target).closest('.tw-drag-handle').length) {
            e.preventDefault();
            return false;
        }

        const $item = $(this);
        state.dragging = {
            type: String($item.data('sort-type') || ''),
            element: this
        };
        $item.addClass('is-dragging');
        if (oe && oe.dataTransfer) {
            oe.dataTransfer.effectAllowed = 'move';
            oe.dataTransfer.setData('text/plain', state.dragging.type);
        }
    }

    function onDragEnd() {
        $('.tw-draggable.is-dragging').removeClass('is-dragging');
        $('[data-sort-container]').removeClass('is-drag-over');
        state.dragging = null;
    }

    function onSortDragOver(e) {
        if (!state.dragging) return;
        const $container = $(this);
        const containerType = String($container.data('sort-container') || '');
        const type = state.dragging.type;
        if (!isValidSortTarget(type, containerType, $container)) return;
        e.preventDefault();
        if (e.originalEvent && e.originalEvent.dataTransfer) e.originalEvent.dataTransfer.dropEffect = 'move';
        $container.addClass('is-drag-over');
    }

    function onSortDrop(e) {
        if (!state.dragging) return;
        const $container = $(this);
        const type = state.dragging.type;
        const containerType = String($container.data('sort-container') || '');
        if (!isValidSortTarget(type, containerType, $container)) return;
        e.preventDefault();
        e.stopPropagation();

        const $drag = $(state.dragging.element);
        moveDraggedElementInsideContainer($drag, $container, $(e.target), e.originalEvent.clientX || 0, e.originalEvent.clientY || 0);

        markDirty();
        updateDirtyUi();
        onDragEnd();
    }

    function onPointerSortStart(e) {
        const oe = e.originalEvent || e;
        if (oe.pointerType === 'mouse') return;

        const $item = $(this).closest('.tw-draggable');
        if (!$item.length) return;

        e.preventDefault();
        e.stopPropagation();

        const rect = $item[0].getBoundingClientRect();
        const $ghost = $item.clone(false, false)
            .addClass('tw-touch-drag-ghost')
            .css({
                width: rect.width,
                maxWidth: rect.width,
                height: rect.height,
                left: rect.left,
                top: rect.top
            });

        $ghost.find('.tw-drag-handle').css({ position: 'static', inset: 'auto', transform: 'none' });
        $('body').append($ghost);
        $item.addClass('is-dragging is-touch-dragging');

        state.dragging = {
            type: String($item.data('sort-type') || ''),
            element: $item[0]
        };

        state.pointerDragging = {
            pointerId: oe.pointerId,
            type: state.dragging.type,
            element: $item[0],
            ghost: $ghost[0],
            offsetX: oe.clientX - rect.left,
            offsetY: oe.clientY - rect.top,
            lastContainer: null
        };

        if (this.setPointerCapture && oe.pointerId != null) {
            try { this.setPointerCapture(oe.pointerId); } catch (_) { }
        }
    }

    function onPointerSortMove(e) {
        if (!state.pointerDragging) return;
        const oe = e.originalEvent || e;
        if (state.pointerDragging.pointerId !== oe.pointerId) return;

        e.preventDefault();

        const pd = state.pointerDragging;
        const $ghost = $(pd.ghost);
        $ghost.css({ left: oe.clientX - pd.offsetX, top: oe.clientY - pd.offsetY });

        const targetEl = document.elementFromPoint(oe.clientX, oe.clientY);
        const $container = $(targetEl).closest('[data-sort-container]');
        if (!$container.length || !isValidSortTarget(pd.type, String($container.data('sort-container') || ''), $container)) return;

        $('[data-sort-container]').removeClass('is-drag-over');
        $container.addClass('is-drag-over');
        moveDraggedElementInsideContainer($(pd.element), $container, $(targetEl), oe.clientX, oe.clientY);
        pd.lastContainer = $container[0];
    }

    function onPointerSortEnd(e) {
        if (!state.pointerDragging) return;
        const oe = e.originalEvent || e;
        if (state.pointerDragging.pointerId !== oe.pointerId) return;

        const type = state.pointerDragging.type;
        const $drag = $(state.pointerDragging.element);
        const $container = $drag.closest('[data-sort-container]');

        if (type === 'team') {
            const groupIndex = n($container.data('group-index'));
            $drag.attr('data-group-index', groupIndex).data('group-index', groupIndex);
            renumberTeamGroup($container);
        }

        if (type === 'document') {
            renumberTournamentDocumentCards($container);
        }

        $('.tw-touch-drag-ghost').remove();
        $('.tw-draggable.is-dragging, .tw-draggable.is-touch-dragging').removeClass('is-dragging is-touch-dragging');
        $('[data-sort-container]').removeClass('is-drag-over');
        state.pointerDragging = null;
        state.dragging = null;
        markDirty();
        updateDirtyUi();
    }

    function moveDraggedElementInsideContainer($drag, $container, $targetSource, clientX, clientY) {
        const type = String($drag.data('sort-type') || '');
        const $oldContainer = $drag.closest('[data-sort-container]');
        let $target = $targetSource.closest(`.tw-draggable[data-sort-type="${type}"]`);

        if (type === 'award-row' && $drag.closest('.tw-award-group')[0] !== $container.closest('.tw-award-group')[0]) return;

        if ($target.length && $target[0] !== $drag[0] && $.contains($container[0], $target[0])) {
            const rect = $target[0].getBoundingClientRect();
            const horizontal = rect.width > rect.height * 1.8;
            const before = horizontal
                ? clientX < rect.left + (rect.width / 2)
                : clientY < rect.top + (rect.height / 2);
            if (before) $drag.insertBefore($target);
            else $drag.insertAfter($target);
        } else if ($.contains($container[0], $drag[0]) === false || !$target.length) {
            const $emptySlots = $container.children('.tw-team-group-slot.is-empty');
            if ($emptySlots.length) $drag.insertBefore($emptySlots.first());
            else $container.append($drag);
        }

        if (type === 'team') {
            const groupIndex = n($container.data('group-index'));
            $drag.attr('data-group-index', groupIndex).data('group-index', groupIndex);
            refreshTeamGroupSlots($oldContainer);
            refreshTeamGroupSlots($container);
        }

        if (type === 'document') {
            renumberTournamentDocumentCards($container);
        }
    }

    function isValidSortTarget(type, containerType, $container) {
        if (type === 'service') return containerType === 'service';
        if (type === 'gallery') return containerType === 'gallery';
        if (type === 'award-group') return containerType === 'award-group';
        if (type === 'award-row') return containerType === 'award-row';
        if (type === 'team') return containerType === 'team';
        if (type === 'document') return containerType === 'document';
        return false;
    }

    function renumberTournamentDocumentCards($container) {
        if (!$container || !$container.length || String($container.data('sort-container') || '') !== 'document') return;

        $container.children('.tw-document-card').each(function (index) {
            const order = String(index + 1).padStart(2, '0');
            $(this).find('.tw-document-index').first().text(order);
            $(this).find('.tw-document-order-note').first().text('Sıra ' + order);
        });
    }

    function renumberTeamGroup($container) {
        $container.children('.tw-team-group-item.tw-draggable').each(function (index) {
            $(this).find('.tw-team-slot-index').text(String(index + 1).padStart(2, '0'));
        });
        $container.children('.tw-team-group-slot.is-empty').each(function (index) {
            const offset = $container.children('.tw-team-group-item.tw-draggable').length;
            $(this).find('.tw-team-slot-index').text(String(offset + index + 1).padStart(2, '0'));
        });
    }

    function refreshTeamGroupSlots($container) {
        if (!$container || !$container.length || String($container.data('sort-container') || '') !== 'team') return;
        const slotTarget = Math.max(n($container.data('slot-target')), $container.children('.tw-team-group-item.tw-draggable').length);
        $container.children('.tw-team-group-slot.is-empty').remove();
        const teamCount = $container.children('.tw-team-group-item.tw-draggable').length;
        for (let i = teamCount; i < slotTarget; i++) {
            $container.append(emptyTeamGroupSlotHtml(i + 1));
        }
        renumberTeamGroup($container);
    }

    function collectAwardRelationsFromDom() {
        const tournamentId = state.data && state.data.tournament ? n(state.data.tournament.tournamentId) : 0;
        const result = [];
        $('#TournamentAwardList .tw-award-group').each(function (groupIndex) {
            const definitionId = n($(this).data('definition-id'));
            $(this).find('.tw-award-row').each(function (rowIndex) {
                const $row = $(this);
                const existing = (state.data.awardRelations || []).find(function (x) {
                    const relationId = n($row.data('relation-id'));
                    if (relationId > 0) return n(x.tournamentAwardRelationId) === relationId;
                    return n(x.statisticDefinitionId) === definitionId && n(x.tournamentAwardTypeId) === n($row.data('award-id'));
                }) || {};
                result.push($.extend({}, existing, {
                    tournamentAwardRelationId: n($row.data('relation-id')),
                    tournamentId: tournamentId,
                    statisticDefinitionId: definitionId,
                    tournamentAwardTypeId: n($row.data('award-id')),
                    quantity: n($row.data('quantity')),
                    recipientSortOrder: groupIndex + 1,
                    sortOrder: rowIndex + 1
                }));
            });
        });
        if (result.length) return result;
        return (state.data.awardRelations || []).map(function (x, index) {
            return $.extend({}, x, { recipientSortOrder: n(x.recipientSortOrder) || index + 1, sortOrder: n(x.sortOrder) || index + 1 });
        });
    }

    function updateServiceSelectionUi() {
        const count = $('.tw-service-card.active').length;
        $('.tw-service-count').text(count);
        $('.tw-service-selection-warning').toggleClass('d-none', count > 0);
    }

    function afterRender() {
        state.trackingPaused = true;
        if (typeof window.s2Each === 'function') window.s2Each();
        if (typeof window.parentS2each === 'function') window.parentS2each();
        if (typeof window.dateInputLoad === 'function') window.dateInputLoad();
        loadCKeditor();
        syncFixtureTimeInputs();
        renderBracketAfterDelay();
        captureStepSnapshot(false);
        updateDirtyUi();

        setTimeout(function () {
            state.trackingPaused = false;
            updateDirtyUi();
        }, 450);
    }

    function renderBracketAfterDelay() {
        setTimeout(function () {
            if (window.TournamentBracketRenderer) window.TournamentBracketRenderer.render('#tw-bracket-root');
            else if (window.BracketRenderer) window.BracketRenderer.render('#tw-bracket-root');
        }, 30);
    }


    function toggleRoundBlock($button) {
        const $block = $button.closest('.tw-round-block');
        const $content = $block.children('.tw-round-content');

        if (!$block.length || !$content.length) return;

        const willOpen = $block.hasClass('is-collapsed');

        $block.toggleClass('is-collapsed', !willOpen);
        $button.attr('aria-expanded', willOpen ? 'true' : 'false');

        if (willOpen) {
            $content
                .stop(true, true)
                .removeClass('d-none')
                .prop('hidden', false)
                .css('display', 'none')
                .slideDown(160);
        } else {
            $content
                .stop(true, true)
                .slideUp(160, function () {
                    $(this)
                        .addClass('d-none')
                        .prop('hidden', true)
                        .css('display', '');
                });
        }
    }

    function toggleFixtureGroupBlock($button) {
        const $block = $button.closest('.tw-fixture-group-block');
        const $content = $block.children('.tw-fixture-group-content');

        if (!$block.length || !$content.length) return;

        const willOpen = $block.hasClass('is-collapsed');

        $block.toggleClass('is-collapsed', !willOpen);
        $button.attr('aria-expanded', willOpen ? 'true' : 'false');

        if (willOpen) {
            $content
                .stop(true, true)
                .removeClass('d-none')
                .prop('hidden', false)
                .css('display', 'none')
                .slideDown(160);
        } else {
            $content
                .stop(true, true)
                .slideUp(160, function () {
                    $(this)
                        .addClass('d-none')
                        .prop('hidden', true)
                        .css('display', '');
                });
        }
    }

    function toggleAwardQuantity() {
        const $selected = $('#AwardTypeId').find('option:selected');
        const isMoney = String($selected.data('money')) === 'true';
        const step = isMoney ? 250 : 1;
        const $input = $('#AwardQuantity');
        const $wrap = $input.closest('.tw-number-stepper');
        const current = n($input.val(), 0);

        $input
            .prop('disabled', false)
            .attr('required', 'required')
            .attr('min', 1)
            .attr('step', step)
            .val(current > 0 ? current : step);

        $wrap.removeClass('is-disabled').attr('data-step', step);
        $wrap.find('.tw-stepper-btn').prop('disabled', false);
    }

    function editAwardLocal() {
        const $row = $(this).closest('.tw-award-row');
        state.awardFormOpen = true;
        state.awardFormDefinitionId = n($row.data('definition-id'));
        state.awardEditRelationId = n($row.data('relation-id'));
        state.awardEditDefinitionId = n($row.data('definition-id'));
        state.awardEditAwardId = n($row.data('award-id'));
        render();
    }

    function addAwardLocal() {
        const definitionId = n($('#AwardStatisticDefinitionId').val());
        const awardTypeId = n($('#AwardTypeId').val());
        const awardType = findAwardType(awardTypeId);
        const definition = findAwardStatisticDefinition(definitionId);
        const quantity = n($('#AwardQuantity').val());
        const editRelationId = n($('#AwardEditRelationId').val());
        const editDefinitionId = n($('#awardEditDefinitionId').val());
        const editAwardId = n($('#AwardEditAwardId').val());

        if (definitionId <= 0 || awardTypeId <= 0) {
            notifyError('Ödül adayı ve ödül tipi seçilmelidir.');
            return;
        }

        if (quantity <= 0) {
            notifyError('Ödül miktarı girilmelidir.');
            return;
        }

        state.data.awardRelations = state.data.awardRelations || [];
        const duplicate = state.data.awardRelations.some(function (x) {
            const sameEditingRow = editRelationId > 0
                ? n(x.tournamentAwardRelationId) === editRelationId
                : n(x.statisticDefinitionId) === editDefinitionId && n(x.tournamentAwardTypeId) === editAwardId;
            if (sameEditingRow) return false;
            return n(x.statisticDefinitionId) === definitionId && n(x.tournamentAwardTypeId) === awardTypeId;
        });

        if (duplicate) {
            notifyError('Bu ödül bu aday için zaten eklenmiş.');
            return;
        }

        const tournamentId = state.data && state.data.tournament ? n(state.data.tournament.tournamentId) : 0;
        const currentIndex = state.data.awardRelations.findIndex(function (x) {
            if (editRelationId > 0) return n(x.tournamentAwardRelationId) === editRelationId;
            return editDefinitionId > 0 && editAwardId > 0 && n(x.statisticDefinitionId) === editDefinitionId && n(x.tournamentAwardTypeId) === editAwardId;
        });

        const current = currentIndex >= 0 ? state.data.awardRelations[currentIndex] : {};
        const next = $.extend({}, current, {
            tournamentAwardRelationId: n(current.tournamentAwardRelationId),
            tournamentId: tournamentId,
            statisticDefinitionId: definitionId,
            tournamentAwardTypeId: awardTypeId,
            quantity: quantity,
            statisticDefinitionName: definition ? definition.name : 'Turnuva Eni',
            statisticDefinitionIcon: definition ? definition.icon : 'fa-ranking-star',
            awardTypeName: awardType ? awardType.name : 'Ödül',
            awardTypeIcon: awardType ? awardType.icon : 'fa-award',
            isMoneyAward: awardType ? awardType.isMoneyAward : false
        });

        if (currentIndex >= 0) state.data.awardRelations[currentIndex] = next;
        else state.data.awardRelations.push(next);

        resetAwardEditState();
        markDirtyBeforeStateRender();
        render();
    }

    function removeAwardLocal() {
        const $row = $(this).closest('.tw-award-row');
        const relationId = n($row.data('relation-id'));
        const definitionId = n($row.data('definition-id'));
        const awardId = n($row.data('award-id'));

        state.data.awardRelations = (state.data.awardRelations || []).filter(function (x) {
            if (relationId > 0) return Number(x.tournamentAwardRelationId) !== relationId;
            return !(Number(x.statisticDefinitionId) === definitionId && Number(x.tournamentAwardTypeId) === awardId);
        });

        markDirtyBeforeStateRender();
        render();
    }

    function saveAwards() {
        const tournamentId = state.data && state.data.tournament ? n(state.data.tournament.tournamentId) : 0;
        if (tournamentId <= 0) {
            notifyError('Ödül eklemek için önce turnuva taslağını kaydetmelisin.');
            return $.Deferred().resolve().promise();
        }

        const relations = collectAwardRelationsFromDom().map(function (x) {
            return {
                tournamentAwardRelationId: n(x.tournamentAwardRelationId),
                tournamentId: tournamentId,
                statisticDefinitionId: n(x.statisticDefinitionId),
                tournamentAwardTypeId: n(x.tournamentAwardTypeId),
                quantity: n(x.quantity),
                sortOrder: n(x.sortOrder),
                recipientSortOrder: n(x.recipientSortOrder)
            };
        });

        if (relations.some(function (x) { return x.quantity <= 0; })) {
            notifyError('Tüm ödül tipleri için miktar girilmelidir.');
            return $.Deferred().resolve().promise();
        }

        setLoading(true, 'Ödüller kaydediliyor...');
        return request({
            url: API + '/SaveAwards',
            method: 'POST',
            data: JSON.stringify({ tournamentId: tournamentId, relations: relations }),
            contentType: 'application/json; charset=utf-8'
        }).then(function (response) {
            setRemoteState(response);
            setLoading(false);
            render();
            notifySuccess('Ödüller kaydedildi.');
        }).catch(function (xhr) { setLoading(false); notifyError(xhr); });
    }

    function openTournamentDocumentEditorLocal() {
        const rowKey = String($(this).closest('.tw-document-card').data('row-key') || '');
        if (!rowKey || !state.data) return;

        syncTournamentDocumentsFromDomToState();
        state.documentEditRowKey = rowKey;
        render();
    }

    function closeTournamentDocumentEditorLocal() {
        if (!state.data) return;

        syncTournamentDocumentsFromDomToState();
        state.documentEditRowKey = '';
        render();
    }

    function addTournamentDocumentLocal() {
        const tournamentId = state.data && state.data.tournament ? n(state.data.tournament.tournamentId) : 0;
        if (tournamentId <= 0) {
            notifyError('Sözleşme eklemek için önce turnuva taslağını kaydetmelisin.');
            return;
        }

        syncTournamentDocumentsFromDomToState();
        state.data.tournamentDocuments = state.data.tournamentDocuments || [];

        const rowKey = `tmp_${Date.now()}_${state.data.tournamentDocuments.length}`;
        state.data.tournamentDocuments.push({
            tournamentDocumentId: 0,
            tournamentId: tournamentId,
            name: 'Yeni Sözleşme',
            description: '',
            order: state.data.tournamentDocuments.length + 1,
            _rowKey: rowKey
        });

        state.documentEditRowKey = rowKey;
        markDirtyBeforeStateRender();
        render();
    }

    function removeTournamentDocumentLocal() {
        const rowKey = String($(this).closest('.tw-document-card').data('row-key') || '');
        if (!rowKey || !state.data) return;

        syncTournamentDocumentsFromDomToState();
        state.data.tournamentDocuments = (state.data.tournamentDocuments || []).filter(function (documentItem, index) {
            return String(documentRowKey(documentItem, index) || '') !== rowKey;
        });

        if (String(state.documentEditRowKey || '') === rowKey) state.documentEditRowKey = '';

        markDirtyBeforeStateRender();
        render();
    }

    function saveTournamentDocuments() {
        const tournamentId = state.data && state.data.tournament ? n(state.data.tournament.tournamentId) : 0;
        if (tournamentId <= 0) {
            notifyError('Sözleşme kaydetmek için önce turnuva taslağını kaydetmelisin.');
            return $.Deferred().resolve().promise();
        }

        const documents = collectTournamentDocumentsFromDom().map(function (documentItem, index) {
            return {
                tournamentDocumentId: n(documentItem.tournamentDocumentId),
                tournamentId: tournamentId,
                name: $.trim(documentItem.name || ''),
                description: documentItem.description || '',
                order: index + 1,
                isVisible: boolValue(documentItem.isVisible)
            };
        });

        setLoading(true, 'Sözleşmeler kaydediliyor...');
        return request({
            url: API + '/SaveTournamentDocuments',
            method: 'POST',
            data: JSON.stringify({ tournamentId: tournamentId, documents: documents }),
            contentType: 'application/json; charset=utf-8'
        }).then(function (response) {
            setRemoteState(response);
            state.activeStep = 'documents';
            state.documentEditRowKey = '';
            setLoading(false);
            render();
            notifySuccess('Sözleşmeler kaydedildi.');
        }).catch(function (xhr) { setLoading(false); notifyError(xhr); });
    }

    function resetTournamentDocuments() {
        const tournamentId = state.data && state.data.tournament ? n(state.data.tournament.tournamentId) : 0;
        if (tournamentId <= 0) {
            notifyError('Varsayılan sözleşmelere dönmek için önce turnuva taslağını kaydetmelisin.');
            return $.Deferred().resolve().promise();
        }

        return confirmDialog('Mevcut sözleşmeler silinip varsayılan sözleşmeler yeniden oluşturulacak. Devam etmek istiyor musunuz?', 'Varsayılana dönülsün mü?')
            .then(function (ok) {
                if (!ok) return;

                setLoading(true, 'Varsayılan sözleşmeler yükleniyor...');
                return request({
                    url: API + '/ResetTournamentDocuments',
                    method: 'POST',
                    data: JSON.stringify({ tournamentId: tournamentId }),
                    contentType: 'application/json; charset=utf-8'
                }).then(function (response) {
                    setRemoteState(response);
                    state.activeStep = 'documents';
                    state.documentEditRowKey = '';
                    setLoading(false);
                    render();
                    notifySuccess('Sözleşmeler varsayılana döndürüldü.');
                }).catch(function (xhr) { setLoading(false); notifyError(xhr); });
            });
    }

    function saveCurrentStep() {
        updateDirtyUi();
        if (!state.dirty) return $.Deferred().resolve().promise();
        if (state.activeStep === 'base') return saveBase();
        if (state.activeStep === 'services') return saveServices();
        if (state.activeStep === 'fixture') return saveFixtureSettings();
        if (state.activeStep === 'rules') return saveRules();
        if (state.activeStep === 'statistics') return saveStatisticPreferences(false);
        if (state.activeStep === 'bests') return saveStatisticPreferences(true);
        if (state.activeStep === 'documents') return saveTournamentDocuments();
        if (state.activeStep === 'awards') return saveAwards();
        if (state.activeStep === 'news') return saveNewsStep();
        if (state.activeStep === 'media') return saveMediaStep();
        if (state.activeStep === 'teams') return saveTeams();
        if (state.activeStep === 'publish') return savePublishStep();
        return $.Deferred().resolve().promise();
    }

    function createTournamentFormData($form) {
        const t = (state.data && state.data.tournament) || {};
        const map = {
            TournamentId: t.tournamentId || 0,
            Img: t.img || DEFAULT_IMG,
            ProfileCardImg: t.profileCardImg || DEFAULT_IMG,
            Name: t.name || '',
            CityId: t.cityId || 0,
            TeamCount: t.teamCount || 4,
            isOfficial: boolValue(t.isOfficial) ? 'true' : 'false',
            JoinRequestPermission: boolValue(t.joinRequestPermission) ? 'true' : 'false',
            TournamentGameTypeEnum: normalizeFixtureGameType(t.tournamentGameTypeEnum || 1),
            isPublic: boolValue(t.isPublic) ? 'true' : 'false',
            Rematch: boolValue(t.rematch) ? 'true' : 'false',
            GroupCount: t.groupCount || 0,
            TeamsAdvancingFromGroup: t.teamsAdvancingFromGroup || 0,
            PriceForPerTeam: t.priceForPerTeam || 0,
            PriceForPerMatch: t.priceForPerMatch || 0,
            JustOnlinePay: boolValue(t.justOnlinePay) ? 'true' : 'false',
            WinnerTeamId: t.winnerTeamId || 0,
            CommentPermission: boolValue(t.commentPermission) ? 'true' : 'false',
            GalleryPermission: boolValue(t.galleryPermission) ? 'true' : 'false',
            MiniDescription: t.miniDescription || '',
            Description: t.description || '',
            GenderTypeEnum: t.genderTypeEnum || t.tournamentGenderId || t.genderEnum || 0,
            TournamentGenderId: t.genderTypeEnum || t.tournamentGenderId || t.genderEnum || 0,
            GenderEnum: t.genderTypeEnum || t.tournamentGenderId || t.genderEnum || 0,
            TournamentMatchDayId: t.tournamentMatchDayId || (t.tournamentMatchDayIds && t.tournamentMatchDayIds[0]) || t.matchDaysEnum || 0,
            TournamentMatchTimeRangeId: t.tournamentMatchTimeRangeId || t.matchTimeRangeEnum || 0,
            TournamentDurationId: t.tournamentDurationId || t.tournamentDurationEnum || 0,
            TournamentAgeRangeId: t.tournamentAgeRangeId || t.ageRangeEnum || 0,
            AgeRangeEnum: t.tournamentAgeRangeId || t.ageRangeEnum || 0,
            TournamentLicenseStatusId: t.tournamentLicenseStatusId || t.licenseStatusEnum || 0,
            TournamentTeamCategoryId: t.tournamentTeamCategoryId || (t.tournamentTeamCategoryIds && t.tournamentTeamCategoryIds[0]) || t.teamCategoryEnum || 0,
            TeamPlayerCountTypeEnum: t.teamPlayerCountTypeEnum || t.tournamentGameFormatId || t.gameFormatEnum || 0,
            TournamentGameFormatId: t.teamPlayerCountTypeEnum || t.tournamentGameFormatId || t.gameFormatEnum || 0,
            TournamentGameRuleId: t.tournamentGameRuleId || t.gameRuleEnum || 0,
            TournamentMatchDurationId: t.tournamentMatchDurationId || t.matchDurationMinutes || 0,
            TournamentRefereeStatusId: t.tournamentRefereeStatusId || t.refereeStatusEnum || 0,
            ExtraAwards: boolValue(t.extraAwards) ? 'true' : 'false',
            TournamentPreviousEditionId: t.tournamentPreviousEditionId || t.previousEditionsEnum || 0,
            Latitude: t.latitude || 0,
            Longitude: t.longitude || 0,
            FixtureStartDate: dateInputValue(t.fixtureStartDate) || '',
            FixtureMatchStartTimes: t.fixtureMatchStartTimes || '19:00,21:00',
            FixtureMatchIntervalHours: t.fixtureMatchIntervalHours || 2,
            FixtureMatchesPerDay: t.fixtureMatchesPerDay || 0,
            FixtureMatchesPerWeek: t.fixtureMatchesPerWeek || 0,
            TransferDeadline: dateInputValue(t.transferDeadline) || '',
            AllowInternalTransfer: boolValue(t.allowInternalTransfer) ? 'true' : 'false',
            InternalTransferStartDate: dateInputValue(t.internalTransferStartDate) || '',
            InternalTransferEndDate: dateInputValue(t.internalTransferEndDate) || '',
            TransferPlayerLimit: t.transferPlayerLimit || 0,
            MatchSubstitutionLimit: t.matchSubstitutionLimit || 0,
            LicensedPlayerLimit: t.licensedPlayerLimit || 0
        };

        const formData = new FormData();
        Object.keys(map).forEach(function (key) { formData.set(key, map[key]); });

        if ($form && $form.length) {
            $.each($form.serializeArray(), function (_, item) { formData.set(item.name, item.value); });
            $form.find('input[type="checkbox"][name]').each(function () {
                formData.set(this.name, $(this).is(':checked') ? 'true' : 'false');
            });
        }

        appendMultiSelectValues(formData, '#TournamentMatchDayIds', 'TournamentMatchDayIds', 'TournamentMatchDayId');
        appendMultiSelectValues(formData, '#TournamentTeamCategoryIds', 'TournamentTeamCategoryIds', 'TournamentTeamCategoryId');
        const genderId = n($('#GenderTypeEnum').val() || map.GenderTypeEnum || map.TournamentGenderId || map.GenderEnum);
        formData.set('GenderTypeEnum', genderId);
        formData.set('TournamentGenderId', genderId);
        formData.set('GenderEnum', genderId);
        const ageRangeId = n($('#TournamentAgeRangeId').val() || map.TournamentAgeRangeId || map.AgeRangeEnum);
        formData.set('TournamentAgeRangeId', ageRangeId);
        formData.set('AgeRangeEnum', ageRangeId);
        const playerCountType = n($('#TeamPlayerCountTypeEnum').val() || map.TeamPlayerCountTypeEnum || map.TournamentGameFormatId);
        formData.set('TeamPlayerCountTypeEnum', playerCountType);
        formData.set('TournamentGameFormatId', playerCountType);
        syncFixtureTimeInputs();
        const matchesPerDay = getFixtureMatchesPerDayValue();
        const matchesPerWeek = getFixtureMatchesPerWeekValue();
        const clockList = normalizeClockList($('#FixtureMatchStartTimes').val() || map.FixtureMatchStartTimes);
        formData.set('FixtureMatchesPerDay', matchesPerDay);
        formData.set('FixtureMatchesPerWeek', matchesPerWeek);
        formData.set('FixtureMatchStartTimes', clockList.length ? clockList.slice(0, matchesPerDay).join(',') : '');

        return appendCKEditorsToFormData(formData);
    }

    function appendMultiSelectValues(formData, selector, key, legacyKey) {
        const values = $.map($(selector).val() || [], function (value) { return n(value); }).filter(function (value) { return value > 0; });
        formData.delete(key);
        $.each(values, function (_, value) { formData.append(key, value); });
        if (legacyKey) formData.set(legacyKey, values.length ? values[0] : 0);
    }

    function saveRules() {
        const $form = $('#TournamentRulesForm');
        if (!$form.length) return $.Deferred().resolve().promise();

        const formData = createTournamentFormData($form);
        formData.set('RebuildFixtureAfterSave', 'false');
        if (hasGroupLicensedPlayerRules()) {
            formData.set('FixtureGroupsJson', JSON.stringify(collectFixtureGroups()));
        }

        setLoading(true, 'Kurallar kaydediliyor...');
        return request({ url: API + '/SaveTournament', method: 'POST', data: formData, processData: false, contentType: false })
            .then(function (response) {
                setRemoteState(response);
                setLoading(false);
                state.activeStep = 'rules';
                render();
                notifySuccess('Kurallar kaydedildi.');
            })
            .catch(function (xhr) { setLoading(false); notifyError(xhr); });
    }

    function saveBase() {
        const $form = $('#TournamentBaseForm');
        if (!$form.length) return $.Deferred().resolve().promise();

        const formData = createTournamentFormData($form);

        setLoading(true, 'Turnuva kaydediliyor...');
        return request({ url: API + '/SaveTournament', method: 'POST', data: formData, processData: false, contentType: false })
            .then(function (response) {
                setRemoteState(response);
                setLoading(false);
                render();
                notifySuccess('Turnuva bilgileri kaydedildi.');

                if (window.__quickAccessTournamentResumeUrl) {
                    window.dispatchEvent(new CustomEvent('sahasenin:tournament-saved', {
                        detail: { tournamentId: n(response?.tournament?.tournamentId || response?.tournamentId) }
                    }));
                }

                if (response.fixtureAffectingChanged) {
                    confirmDialog('Fikstür modelini etkileyen bir alan değişti. Fikstürü şimdi yeniden oluşturmak ister misiniz?', 'Fikstür yeniden oluşturulsun mu?')
                        .then(function (ok) { if (ok) rebuildFixture(); });
                }
            })
            .catch(function (xhr) { setLoading(false); notifyError(xhr); });
    }

    function syncFixtureFormToState() {
        if (!state.data || !state.data.tournament) return;
        const t = state.data.tournament;
        t.tournamentGameTypeEnum = normalizeFixtureGameType($('#TournamentGameTypeEnum').val() || t.tournamentGameTypeEnum || 1);
        t.teamCount = n($('#TeamCount').val(), t.teamCount || 4);
        t.rematch = $('#Rematch').is(':checked');
        t.winnerTeamId = n($('#WinnerTeamId').val(), t.winnerTeamId || 0);
        t.groupCount = n($('#GroupCount').val(), t.groupCount || 0);
        t.teamsAdvancingFromGroup = n($('#TeamsAdvancingFromGroup').val(), t.teamsAdvancingFromGroup || 0);
        t.fixtureStartDate = $('#FixtureStartDate').val() || t.fixtureStartDate;
        syncFixtureTimeInputs();
        t.fixtureMatchesPerDay = getFixtureMatchesPerDayValue();
        t.fixtureMatchesPerWeek = getFixtureMatchesPerWeekValue();
        t.fixtureMatchStartTimes = normalizeClockList($('#FixtureMatchStartTimes').val()).slice(0, t.fixtureMatchesPerDay).join(',');
        t.fixtureMatchIntervalHours = n($('#FixtureMatchIntervalHours').val(), t.fixtureMatchIntervalHours || 2);
    }

    function saveFixtureSettings() {
        const $form = $('#TournamentFixtureForm');
        if (!$form.length) return $.Deferred().resolve().promise();
        syncFixtureTimeInputs();
        const matchesPerDay = getFixtureMatchesPerDayValue();
        const clockList = normalizeClockList($('#FixtureMatchStartTimes').val());
        if (matchesPerDay <= 0 || clockList.length !== matchesPerDay) {
            notifyError('Günlük maç sayısı ile maç başlama saati sayısı aynı olmalıdır.');
            return $.Deferred().resolve().promise();
        }

        const formData = createTournamentFormData($form);
        formData.set('RebuildFixtureAfterSave', 'true');
        formData.set('FixtureGroupsJson', JSON.stringify(collectFixtureGroups()));
        const fixtureTeamGroupElements = $('.tw-fixture-group-team-select, .tw-independent-team-group');
        if (fixtureTeamGroupElements.length) {
            formData.set('FixtureGroupTeamsJson', JSON.stringify(collectFixtureGroupTeams()));
        }

        setLoading(true, 'Fikstür ayarları kaydediliyor ve fikstür oluşturuluyor...');
        return request({ url: API + '/SaveTournament', method: 'POST', data: formData, processData: false, contentType: false })
            .then(function (response) {
                setRemoteState(response);
                setLoading(false);
                render();
                notifySuccess('Fikstür ayarları kaydedildi ve fikstür otomatik oluşturuldu.');
            })
            .catch(function (xhr) { setLoading(false); notifyError(xhr); });
    }

    function saveTeams() {
        const t = (state.data && state.data.tournament) || {};
        if (n(t.tournamentId) <= 0) {
            markClean();
            return $.Deferred().resolve().promise();
        }

        const formData = createTournamentFormData($());
        formData.set('RebuildFixtureAfterSave', 'true');
        formData.set('FixtureGroupsJson', JSON.stringify(getFixtureGroups(getFixtureGroupCount())));
        formData.set('FixtureGroupTeamsJson', JSON.stringify(collectFixtureGroupTeams()));

        setLoading(true, 'Takımlar ve grup dağılımı kaydediliyor, fikstür yeniden hesaplanıyor...');
        return request({ url: API + '/SaveTournament', method: 'POST', data: formData, processData: false, contentType: false })
            .then(function (response) {
                setRemoteState(response);
                state.activeStep = 'teams';
                setLoading(false);
                render();
                notifySuccess('Takımlar kaydedildi ve fikstür yeniden hesaplandı.');
            })
            .catch(function (xhr) { setLoading(false); notifyError(xhr); });
    }

    function savePublishStep() {
        markClean();
        notifySuccess('Yayın adımı kaydedildi.');
        return $.Deferred().resolve().promise();
    }

    function saveServices() {
        const ids = $('.tw-service-grid .tw-service-card.active').map(function () { return n($(this).data('service-id')); }).get();
        const tournamentId = state.data.tournament.tournamentId;
        setLoading(true, 'Hizmetler kaydediliyor...');
        return request({
            url: API + '/SaveServices',
            method: 'POST',
            data: JSON.stringify({ tournamentId: tournamentId, serviceIds: ids }),
            contentType: 'application/json; charset=utf-8'
        }).then(function (response) {
            setRemoteState(response);
            setLoading(false);
            render();
            notifySuccess('Hizmetler kaydedildi.');
        }).catch(function (xhr) { setLoading(false); notifyError(xhr); });
    }

    function rebuildFixtureAfterTeamChange(options) {
        options = options || {};
        const t = (state.data && state.data.tournament) || {};
        const tournamentId = n(options.tournamentId || t.tournamentId);
        if (tournamentId <= 0) return $.Deferred().resolve().promise();

        if (options.state) state.data = options.state.state ? options.state.state : options.state;

        setLoading(true, options.loadingText || 'Takım değişikliği sonrası fikstür yeniden hesaplanıyor...');
        return request({
            url: API + '/RebuildFixture',
            method: 'POST',
            data: { id: tournamentId, gameType: normalizeFixtureGameType((state.data && state.data.tournament && state.data.tournament.tournamentGameTypeEnum) || t.tournamentGameTypeEnum || 1) }
        }).then(function (response) {
            state.data = response && response.state ? response.state : response;
            state.activeStep = options.keepStep === false ? 'fixture' : (options.step || state.activeStep || 'teams');
            setLoading(false);
            render();
            notifySuccess('Fikstür yeniden hesaplandı.');
        }).catch(function (xhr) {
            setLoading(false);
            if (options.state) {
                state.data = options.state.state ? options.state.state : options.state;
                render();
            }
            notifyError(xhr);
        });
    }

    function openTeamModal() {

        if (state.data.tournament.tournamentId > 0) {

            var modal = createModal({
                title: 'Turnuvaya takım davet et'
            });

            Request({
                url: '/Rakip-Bul',
                type: 'GET',
                data: {
                    pageLink: true,
                    matchId: 0,
                    tournamentId: state.data.tournament.tournamentId
                },
                cacheable: false
            }).then((response) => {

                modal.updateContent(response);

                updateFindRivalTable();
            }).catch((error) => {
                console.error("openTeamModal():", error.responseText);
            });
        }
        else {
            ShowErrorAlert();
        }
    }

    function removeTeam() {
        const teamId = $(this).data('team');
        confirmDialog('Takımı turnuvadan çıkarmak istediğinize emin misiniz?').then(function (ok) {
            if (!ok) return;
            setLoading(true, 'Takım kaldırılıyor...');
            request({ url: API + '/RemoveTournamentTeamRelation', method: 'POST', data: { tournamentId: state.data.tournament.tournamentId, teamId: teamId } })
                .then(function (response) {
                    return rebuildFixtureAfterTeamChange({ state: response, step: 'teams' });
                })
                .catch(function (xhr) { setLoading(false); notifyError(xhr); });
        });
    }

    function changeJoinRequest(id, accept) {
        const url = accept ? '/AcceptJoinRequest' : '/RejectJoinRequest';
        setLoading(true, accept ? 'İstek onaylanıyor...' : 'İstek reddediliyor...');
        request({ url: API + url, method: 'POST', data: { id: id } })
            .then(function (response) {
                return rebuildFixtureAfterTeamChange({ state: response, step: 'teams', loadingText: accept ? 'İstek onaylandı, fikstür yeniden hesaplanıyor...' : 'İstek reddedildi, fikstür yeniden hesaplanıyor...' });
            })
            .catch(function (xhr) { setLoading(false); notifyError(xhr); });
    }

    function rebuildFixture() {
        const t = state.data.tournament || {};
        return confirmDialog('Fikstür yeniden oluşturulacak. Rezerve edilmemiş eski karşılaşmalar silinir. Devam edilsin mi?', 'Fikstür oluştur')
            .then(function (ok) {
                if (!ok) return;
                setLoading(true, 'Fikstür oluşturuluyor...');
                return request({ url: API + '/RebuildFixture', method: 'POST', data: { id: t.tournamentId, gameType: normalizeFixtureGameType(t.tournamentGameTypeEnum) } })
                    .then(function (response) {
                        state.data = response;
                        state.activeStep = 'fixture';
                        setLoading(false);
                        render();
                        notifySuccess('Fikstür oluşturuldu.');
                    })
                    .catch(function (xhr) { setLoading(false); notifyError(xhr); });
            });
    }

    function openMatchModal(id) {
        const match = (state.data.dateRelations || []).find(function (x) { return Number(x.tournamentDateRelationId) === Number(id); });
        if (!match) return;
        const html = `
            <form id="TournamentDateRelationForm" class="tw-modal-form">
                <input type="hidden" id="TournamentDateRelationId" name="TournamentDateRelationId" value="${attr(match.tournamentDateRelationId)}">
                <input type="hidden" id="TournamentId" name="TournamentId" value="${attr(match.tournamentId)}">
                <input type="hidden" id="ReservationId" name="ReservationId" value="${attr(match.reservationId || 0)}">
                <input type="hidden" id="Reservated" name="Reservated" value="${boolValue(match.reservated) ? 'true' : 'false'}">
                <input type="hidden" id="MatchId" name="MatchId" value="${attr(match.matchId || 0)}">
                <input type="hidden" id="MatchIndex" name="MatchIndex" value="${attr(match.matchIndex || 0)}">
                <input type="hidden" id="RoundIndex" name="RoundIndex" value="${attr(match.roundIndex || 0)}">
                <input type="hidden" id="TournamentFixtureGroupId" name="TournamentFixtureGroupId" value="${attr(match.tournamentFixtureGroupId || 0)}">
                <input type="hidden" id="FixtureGroupIndex" name="FixtureGroupIndex" value="${attr(match.fixtureGroupIndex || 0)}">
                <input type="hidden" id="TeamSlotIndex" name="TeamSlotIndex" value="${attr(match.teamSlotIndex || 0)}">
                <input type="hidden" id="_TeamSlotIndex" name="_TeamSlotIndex" value="${attr(match._TeamSlotIndex || match._teamSlotIndex || 0)}">
                <input type="hidden" id="TeamSlotLabel" name="TeamSlotLabel" value="${attr(match.teamSlotLabel || '')}">
                <input type="hidden" id="_TeamSlotLabel" name="_TeamSlotLabel" value="${attr(match._TeamSlotLabel || match._teamSlotLabel || '')}">
                <input type="hidden" id="FixturOrder" name="FixturOrder" value="${attr(match.fixturOrder || 0)}">
                <input type="hidden" id="FixtureTypeEnum" name="FixtureTypeEnum" value="${attr(match.fixtureTypeEnum || 0)}">
                <input type="hidden" id="MatchTypeEnum" name="MatchTypeEnum" value="${attr(match.matchTypeEnum || 0)}">
                <div class="row m-0">
                    ${renderField('Tarih', input('Date', match.date || '', 'datetime-local', 'required'), 'fa-calendar-day', 'col-6')}
                    ${renderField('Kazanan', select('WinnerTeamId', teamOptions(match.winnerTeamId, 'Belirlenmedi')), 'fa-medal', 'col-6')}
                    ${renderField('Takım 1', select('TeamId', teamOptions(match.teamId, 'Takım 1 seç')), 'fa-users', 'col-6')}
                    ${renderField('Takım 2', select('_TeamId', teamOptions(match._TeamId, 'Takım 2 seç')), 'fa-users', 'col-6')} 
                </div>
                <div class="row m-0">
                    <div class="col-10 p-2"><button type="submit" class="btn btn-primary w-100"><i class="fa-solid fa-floppy-disk me-1"></i>Kaydet</button></div>
                    <div class="col-2 p-2"><button type="button" class="btn btn-light fs-07 border w-100 tw-delete-match" data-id="${attr(match.tournamentDateRelationId)}"><i class="fa-solid fa-trash me-1"></i>Sil</button></div>
                </div>
            </form>`;

        openModal('Karşılaşma Düzenle', html, function ($modal) {
            $(document)
                .off('submit.tournamentDateRelation', '#TournamentDateRelationForm')
                .on('submit.tournamentDateRelation', '#TournamentDateRelationForm', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    const form = this;
                    const formData = new FormData(form);

                    setLoading(true, 'Karşılaşma kaydediliyor...');

                    request({
                        url: API + '/SaveMatch',
                        method: 'POST',
                        data: formData,
                        processData: false,
                        contentType: false
                    })
                        .then(function (response) {
                            state.data = response;

                            closeModal($(form).closest('.modal'));

                            setLoading(false);

                            state.activeStep = 'fixture';
                            render();

                            notifySuccess('Karşılaşma kaydedildi.');
                        })
                        .catch(function (xhr) {
                            setLoading(false);
                            notifyError(xhr);
                        });

                    return false;
                });

            $modal.find('.tw-delete-match').on('click', function () {
                const matchId = $(this).data('id');
                confirmDialog('Bu karşılaşma silinsin mi?').then(function (ok) {
                    if (!ok) return;
                    setLoading(true, 'Karşılaşma siliniyor...');
                    request({ url: API + '/DeleteMatch', method: 'POST', data: { id: matchId } })
                        .then(function (response) {
                            state.data = response;
                            closeModal($modal);
                            setLoading(false);
                            render();
                        })
                        .catch(function (xhr) { setLoading(false); notifyError(xhr); });
                });
            });
        });
    }

    function publish() {
        const $btn = $('.tw-publish');
        const draft = String($btn.data('draft')) === 'true';
        const message = draft ? 'Turnuva taslağa çekilsin mi?' : 'Turnuva yayına alınsın mı?';
        confirmDialog(message).then(function (ok) {
            if (!ok) return;
            setLoading(true, draft ? 'Taslağa çekiliyor...' : 'Yayına alınıyor...');
            request({ url: API + '/Publish', method: 'POST', data: { id: state.data.tournament.tournamentId, draft: draft } })
                .then(function (response) {
                    state.data = response;
                    setLoading(false);
                    render();
                    notifySuccess(draft ? 'Turnuva taslağa çekildi.' : 'Turnuva yayına alındı.');
                })
                .catch(function (xhr) { setLoading(false); notifyError(xhr); });
        });
    }

    const editorInstances = [];

    async function loadCKeditor(scope) {
        const $scope = scope ? $(scope) : $(document);
        const $editors = $scope.find('.ckEditor');
        if (!$editors.length) return;
        try { await window.sahaseninFeatureAssets.ckEditor(); }
        catch (error) { console.error('Turnuva metin editörü yüklenemedi:', error); return; }

        $editors.each(function () {
            const element = this;
            const $element = $(element);
            const name = $element.attr('name');
            if (!element.isConnected || !name || $element.data('tw-editor-ready') || $element.data('tw-editor-pending')) return;
            $element.data('tw-editor-pending', true);

            window.ClassicEditor
                .create(element, {
                    ckfinder: { uploadUrl: '/FileUpload' },
                    language: 'tr'
                })
                .then(function (editor) {
                    $element.data('tw-editor-pending', false);
                    if (!element.isConnected) return editor.destroy();
                    const existingIndex = editorInstances.findIndex(function (e) { return e.name === name; });
                    if (existingIndex !== -1) {
                        editorInstances[existingIndex].editor.destroy().catch(function (err) {
                            console.error('Eski turnuva editor destroy edilirken hata oluştu:', err);
                        });
                        editorInstances.splice(existingIndex, 1);
                    }

                    if (editor.model && editor.model.document) {
                        editor.model.document.on('change:data', function () { markDirty(); });
                    }

                    editorInstances.push({ editor: editor, name: name, element: element });
                    $element.data('tw-editor-ready', true);
                })
                .catch(function (error) {
                    $element.data('tw-editor-pending', false);
                    console.error('Turnuva CKEditor başlatılırken bir hata oluştu:', error);
                });
        });
    }

    function getCKeditorFormQuery() {
        let formData = '';
        const addedNames = new Set();

        if (editorInstances.length > 0) {
            editorInstances.forEach(function (editorData) {
                const content = editorData.editor.getData();
                const name = editorData.name;

                if (name && !addedNames.has(name)) {
                    formData += '&' + name + '=' + encodeURIComponent(content);
                    addedNames.add(name);
                }
            });
        }

        return formData;
    }

    function appendCKEditorsToFormData(formData) {
        editorInstances.forEach(function (editorData) {
            if (editorData.name) formData.set(editorData.name, editorData.editor.getData());
        });
        return formData;
    }

    async function uploadTournamentImage(imageFile) {
        if (typeof window.uploadImage !== 'function') {
            notifyError('Projede tanımlı uploadImage fonksiyonu bulunamadı.');
            throw new Error('uploadImage fonksiyonu bulunamadı.');
        }

        return window.uploadImage(imageFile);
    }

    async function uploadAndUpdateTournamentImage(imageFile, id) {
        return uploadTournamentImage(imageFile);
    }

    function syncCityLocation() {
        const $selected = $('#CityId').find('option:selected');
        const lat = $selected.data('lat');
        const lng = $selected.data('lng');
        if (lat != null) $('#Latitude').val(lat || 0);
        if (lng != null) $('#Longitude').val(lng || 0);
    }

    function changeStepperValue() {
        const $wrap = $(this).closest('.tw-number-stepper');
        const $input = $wrap.find('input[type="number"]');
        const step = n($wrap.data('step'), 1);
        const min = n($input.attr('min'), 0);
        const current = n($input.val(), 0);
        const next = $(this).hasClass('tw-inc') ? current + step : Math.max(min, current - step);
        $input.val(next).trigger('change');
    }

    function openImageActionMenu() {
        const $btn = $(this);
        const inputName = $btn.data('input');
        const entityName = $btn.data('entity') || 'Tournament';
        const imageUrl = $('#' + inputName).val() || DEFAULT_IMG;
        const title = $btn.data('title') || 'Turnuva Görseli';
        const group = $btn.data('group') || 'tournament-wizard-images';

        if (window.Swal) {
            Swal.fire({
                title: title,
                html: `<p class="fs-07 mb-2">Bu görsel için işlem seç.</p>`,
                showCancelButton: true,
                showDenyButton: true,
                confirmButtonText: 'İncele',
                denyButtonText: 'Düzenle',
                cancelButtonText: 'Sil',
                reverseButtons: true,
                allowOutsideClick: false
            }).then(function (r) {
                if (r.isConfirmed) previewWizardImage(imageUrl, title, group);
                else if (r.isDenied) chooseWizardImage(inputName, entityName);
                else if (r.dismiss === Swal.DismissReason.cancel) clearWizardImage(inputName);
            });
            return;
        }

        const action = window.prompt('İşlem seç: incele, düzenle, sil', 'incele');
        if (action === 'incele') previewWizardImage(imageUrl, title, group);
        if (action === 'düzenle') chooseWizardImage(inputName, entityName);
        if (action === 'sil') clearWizardImage(inputName);
    }

    function previewWizardImage(imageUrl, title, group) {
        const $a = $('<a/>', {
            class: 'openImage d-none',
            href: 'javascript:void(0)',
            'data-url': imageUrl || DEFAULT_IMG,
            'data-title': title || 'Turnuva Görseli',
            'data-group': group || 'tournament-wizard-images'
        });
        $('body').append($a);
        $a.trigger('click');
        setTimeout(function () { $a.remove(); }, 250);
    }

    function chooseWizardImage(inputName, entityName) {
        const $input = $(`<input type="file" accept="image/*" class="tw-hidden-file d-none" data-input="${attr(inputName)}" data-entity="${attr(entityName || 'Tournament')}">`);
        $('body').append($input);
        $input.trigger('click');
    }

    function uploadWizardImageFromInput(event) {
        const imageFile = event.target.files && event.target.files[0];
        const inputName = $(this).data('input');
        const $file = $(this);

        if (!imageFile || !inputName) { $file.remove(); return; }

        setLoading(true, 'Görsel yükleniyor...');
        uploadTournamentImage(imageFile)
            .then(function (imageUrl) {
                updateWizardImage(inputName, imageUrl || DEFAULT_IMG);
                setLoading(false);
                $file.remove();
            })
            .catch(function (error) {
                setLoading(false);
                notifyError(error || 'Görsel yüklenemedi.');
                $file.remove();
            });
    }

    function updateWizardImage(inputName, imageUrl) {
        $('#' + inputName).val(imageUrl || DEFAULT_IMG);
        const $card = $(`.tw-image-action[data-input="${inputName}"]`);
        $card.attr('data-url', imageUrl || DEFAULT_IMG);
        $card.find('img').attr('src', imageUrl || DEFAULT_IMG);
        markDirty();
    }

    function clearWizardImage(inputName) {
        updateWizardImage(inputName, DEFAULT_IMG);
    }

    function refresh(force) {
        updateDirtyUi();
        if (!force && state.dirty) {
            confirmDialog('Kaydedilmeyen değişiklikler geri alınacak ve güncel bilgiler yüklenecek. Devam edilsin mi?', 'Kaydedilmeyen değişiklik var')
                .then(function (ok) { if (ok) { restoreStepSnapshot(false); refresh(true); } });
            return $.Deferred().resolve().promise();
        }

        if (!state.data || !state.data.tournament) return;
        setLoading(true, 'Güncel bilgiler alınıyor...');
        return request({ url: API + '/State', method: 'GET', data: { id: state.data.tournament.tournamentId } })
            .then(function (response) {
                setRemoteState(response);
                setLoading(false);
                render();
            })
            .catch(function (xhr) { setLoading(false); notifyError(xhr); });
    }

    function openModal(title, html, onShown) {
        if (typeof window.createModal === 'function') {
            const modal = window.createModal({ title: title });
            modal.updateContent(html);
            const $modal = $('.sheet-modal, .modal, .bootbox').last();
            if (typeof onShown === 'function') onShown($modal.length ? $modal : $(document));
            return;
        }

        if (window.bootbox) {
            const dialog = bootbox.dialog({ title: title, message: html, size: 'large' });
            dialog.on('shown.bs.modal', function () { if (typeof onShown === 'function') onShown(dialog); });
            return;
        }

        const $modal = $(`
            <div class="tw-local-modal">
                <div class="tw-local-modal-box">
                    <div class="tw-local-modal-head"><strong class="fs-08">${h(title)}</strong><button type="button" class="tw-icon-btn fs-08 tw-local-close"><i class="fa-solid fa-xmark"></i></button></div>
                    <div class="tw-local-modal-body">${html}</div>
                </div>
            </div>`);
        $('body').append($modal);
        $modal.on('click', '.tw-local-close', function () { closeModal($modal); });
        if (typeof onShown === 'function') onShown($modal);
    }

    function closeModal($modal) {
        if ($modal && $modal.length && $modal.hasClass('bootbox')) {
            $modal.modal('hide');
            return;
        }
        if (typeof window.removeSheedModal === 'function') {
            window.removeSheedModal();
            return;
        }
        $('.tw-local-modal').remove();
        if (window.bootbox) bootbox.hideAll();
    }

    function open(id) {
        id = id == null ? '0' : String(id);
        state.activeStep = 'base';
        getRoot().html(`<div class="tw-initial-loader"><div class="spinner-border sahasenin-modern-spinner"></div><span class="fs-07">Turnuva hazırlanıyor...</span></div>`);
        return request({ url: API + '/Bootstrap', method: 'GET', data: { id: id } })
            .then(function (response) {
                state.data = response;
                markClean();
                render();
            })
            .catch(function (xhr) {
                close(true);
                notifyError(xhr);
            });
    }

    $(document).on('click', '.AddTournament', function (e) {
        e.preventDefault();
        const id = $(this).data('id') == null ? '0' : $(this).data('id');

        if (typeof window.getCurrentUserId === 'function') {
            window.getCurrentUserId().then(function (memberId) {
                if (Number(memberId) > 0) open(id);
                else notifyError('Turnuva oluşturmak için giriş yapılmalıdır.');
            }).catch(function () { open(id); });
            return;
        }

        open(id);
    });

    window.TournamentBuilder = {
        open: open,
        close: close,
        refresh: refresh,
        loadCKeditor: loadCKeditor,
        getCKeditorFormQuery: getCKeditorFormQuery,
        uploadImage: uploadTournamentImage,
        uploadAndUpdateImage: uploadAndUpdateTournamentImage,
        rebuildFixtureAfterTeamChange: rebuildFixtureAfterTeamChange,
        getState: function () { return state.data; }
    };

})(window, window.jQuery);

/* Lightweight bracket renderer. Eski .match[data-match-id] sözleşmesini korur. */
(function (window, $) {
    'use strict';
    if (!$) return;

    function appendLine($scale, left, top, width, height) {
        if (Math.abs(width) < 1 && Math.abs(height) < 1) return;
        let cls = Math.abs(height) > Math.abs(width) ? 'vertical' : 'horizontal';
        if (width < 0) { left += width; width = Math.abs(width); }
        if (height < 0) { top += height; height = Math.abs(height); }
        $('<div class="connector"></div>').addClass(cls).css({ left: Math.round(left), top: Math.round(top), width: Math.round(width), height: Math.round(height) }).appendTo($scale);
    }

    function roundKey(order, type) {
        const label = String(type || '').trim().toLocaleLowerCase('tr-TR');
        if (label.indexOf('yarı final') >= 0) return 'round:semi-final';
        if (label.indexOf('çeyrek final') >= 0) return 'round:quarter-final';
        if (label.indexOf('son 16') >= 0) return 'round:last-16';
        if (label === 'final') return 'round:final';
        return `schedule:${Math.max(1, Math.floor(parseInt(order || 0, 10) / 1000))}`;
    }

    function renderMobileBracket($root, groups) {
        const $shell = $('<div class="bracket-mobile-shell"></div>');
        const $hero = $(`
            <div class="bracket-mobile-hero">
                <span class="bracket-mobile-kicker fs-06"><i class="fa-solid fa-bolt me-1"></i>CANLI ELEME YOLU</span>
                <strong class="fs-09">Şampiyonluğa giden yol</strong>
                <small class="fs-07">Turları kaydır, eşleşmeye dokun ve maç detayını aç.</small>
            </div>`);
        const $nav = $('<div class="bracket-mobile-rounds" role="tablist"></div>');
        const $stages = $('<div class="bracket-mobile-stages"></div>');

        groups.forEach(function (group, groupIndex) {
            const label = group[0] ? group[0].type : ('Tur ' + (groupIndex + 1));
            const isFinal = groupIndex === groups.length - 1;
            $nav.append(`<button type="button" class="bracket-mobile-round ${groupIndex === 0 ? 'active' : ''}" data-mobile-round="${groupIndex}"><span>${groupIndex + 1}</span><strong class="fs-06">${$('<div/>').text(label).html()}</strong></button>`);

            const $stage = $(`<section class="bracket-mobile-stage ${groupIndex === 0 ? 'active' : ''}" data-mobile-stage="${groupIndex}"></section>`);
            $stage.append(`
                <div class="bracket-mobile-stage-head">
                    <div><span class="fs-06">${isFinal ? 'SON ADIM' : (groupIndex + 1) + '. TUR'}</span><strong class="fs-08">${$('<div/>').text(label).html()}</strong></div>
                    <span class="bracket-mobile-match-count fs-06">${group.length} maç</span>
                </div>`);

            group.forEach(function (match, matchIndex) {
                const $match = $(match.el).detach().removeAttr('style').css({ position: '', left: '', top: '', width: '', height: '', margin: '' });
                const $flow = $('<div class="bracket-mobile-flow"></div>');
                $flow.append(`<span class="bracket-mobile-seed fs-06">${String(matchIndex + 1).padStart(2, '0')}</span>`);
                $flow.append($match);
                if (matchIndex < group.length - 1) $flow.append('<span class="bracket-mobile-rail" aria-hidden="true"></span>');
                $stage.append($flow);
            });

            if (isFinal) {
                $stage.append('<div class="bracket-mobile-champion"><span><i class="fa-solid fa-crown"></i></span><div><small class="fs-06">ZİRVENİN SAHİBİ</small><strong class="fs-08">Şampiyon bu eşleşmeden doğar</strong></div></div>');
            }
            $stages.append($stage);
        });

        $shell.append($hero, $nav, $stages, `
            <div class="bracket-mobile-controls">
                <button type="button" class="bracket-mobile-control" data-mobile-direction="prev"><i class="fa-solid fa-arrow-left"></i><span class="fs-07">Önceki tur</span></button>
                <span class="bracket-mobile-progress fs-06">1 / ${groups.length}</span>
                <button type="button" class="bracket-mobile-control" data-mobile-direction="next"><span class="fs-07">Sonraki tur</span><i class="fa-solid fa-arrow-right"></i></button>
            </div>`);

        $root.empty().append($shell).addClass('is-mobile-bracket');

        const stageSelector = '.bracket-mobile-stage';

        function stageTransform(index, dragOffset) {
            const offset = Number.isFinite(dragOffset) ? dragOffset : 0;
            return `translate3d(calc(${-index * 100}% + ${offset}px), 0, 0)`;
        }

        function syncStageHeight(index) {
            const $stage = $stages.find(`[data-mobile-stage="${index}"]`);
            if ($stage.length) $stages.css('height', Math.ceil($stage.outerHeight()) + 'px');
        }

        function activateRound(index, options) {
            options = options || {};
            index = Math.max(0, Math.min(groups.length - 1, index));
            const previousIndex = parseInt($root.data('mobile-round'), 10);
            const changed = !Number.isFinite(previousIndex) || previousIndex !== index;

            if (options.animate === false) $stages.addClass('is-no-transition');
            $root.data('mobile-round', index);
            const $activeNav = $nav.find('.bracket-mobile-round').removeClass('active').filter(`[data-mobile-round="${index}"]`).addClass('active');
            if (changed && options.centerNav !== false) {
                $activeNav.get(0)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }

            $stages.find(stageSelector)
                .removeClass('active')
                .attr('aria-hidden', 'true')
                .filter(`[data-mobile-stage="${index}"]`)
                .addClass('active')
                .attr('aria-hidden', 'false');

            syncStageHeight(index);
            $stages.css('transform', stageTransform(index));
            $root.find('.bracket-mobile-progress').text((index + 1) + ' / ' + groups.length);
            $root.find('[data-mobile-direction="prev"]').prop('disabled', index === 0);
            $root.find('[data-mobile-direction="next"]').prop('disabled', index === groups.length - 1);

            if (options.animate === false) {
                window.requestAnimationFrame(function () { $stages.removeClass('is-no-transition'); });
            }
        }

        $root.off('click.tbracketmobile')
            .on('click.tbracketmobile', '.bracket-mobile-round', function () { activateRound(parseInt($(this).data('mobile-round'), 10) || 0); })
            .on('click.tbracketmobile', '.bracket-mobile-control', function () {
                const current = parseInt($root.data('mobile-round'), 10) || 0;
                const direction = $(this).data('mobile-direction') === 'next' ? 'next' : 'prev';
                activateRound(current + (direction === 'next' ? 1 : -1));
            });

        let swipe = null;
        let suppressClickUntil = 0;

        function finishSwipe(event, cancelled) {
            if (!swipe) return;
            const original = event.originalEvent || event;
            if (swipe.pointerId !== undefined && original.pointerId !== swipe.pointerId) return;

            const dx = swipe.lastX - swipe.startX;
            const elapsed = Math.max(1, Date.now() - swipe.startedAt);
            const shouldChangeRound = !cancelled && swipe.horizontal && (Math.abs(dx) >= 46 || Math.abs(dx) / elapsed > .45);
            let targetIndex = swipe.roundIndex;
            if (shouldChangeRound) targetIndex += dx < 0 ? 1 : -1;
            targetIndex = Math.max(0, Math.min(groups.length - 1, targetIndex));

            if (swipe.horizontal && Math.abs(dx) > 8) suppressClickUntil = Date.now() + 350;
            const pointerId = swipe.pointerId;
            swipe = null;

            $stages.removeClass('is-dragging');
            // Re-enable the transition before snapping to the selected round.
            void $stages.get(0)?.offsetWidth;
            activateRound(targetIndex);

            try {
                if (pointerId !== undefined && $stages.get(0)?.hasPointerCapture?.(pointerId)) {
                    $stages.get(0).releasePointerCapture(pointerId);
                }
            } catch (_) { }
        }

        $stages
            .off('.tbracketswipe')
            .on('pointerdown.tbracketswipe', function (event) {
                const original = event.originalEvent || event;
                if (original.button !== undefined && original.button !== 0) return;
                const current = parseInt($root.data('mobile-round'), 10) || 0;
                swipe = {
                    pointerId: original.pointerId,
                    startX: original.clientX,
                    startY: original.clientY,
                    lastX: original.clientX,
                    lastY: original.clientY,
                    startedAt: Date.now(),
                    horizontal: false,
                    roundIndex: current
                };
                try { this.setPointerCapture?.(original.pointerId); } catch (_) { }
            })
            .on('pointermove.tbracketswipe', function (event) {
                if (!swipe) return;
                const original = event.originalEvent || event;
                if (swipe.pointerId !== undefined && original.pointerId !== swipe.pointerId) return;
                swipe.lastX = original.clientX;
                swipe.lastY = original.clientY;
                const dx = original.clientX - swipe.startX;
                const dy = original.clientY - swipe.startY;
                if (!swipe.horizontal && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * 1.15) swipe.horizontal = true;
                if (swipe.horizontal) {
                    event.preventDefault();
                    let resistedDx = dx;
                    if ((swipe.roundIndex === 0 && dx > 0) || (swipe.roundIndex === groups.length - 1 && dx < 0)) resistedDx *= .22;
                    $stages.addClass('is-dragging').css('transform', stageTransform(swipe.roundIndex, resistedDx));
                }
            })
            .on('pointerup.tbracketswipe', function (event) { finishSwipe(event, false); })
            .on('pointercancel.tbracketswipe', function (event) { finishSwipe(event, true); });

        $stages.get(0)?.addEventListener('click', function (event) {
            if (Date.now() < suppressClickUntil) {
                event.preventDefault();
                event.stopPropagation();
            }
        }, true);

        const previousResizeObserver = $root.data('mobile-resize-observer');
        if (previousResizeObserver && typeof previousResizeObserver.disconnect === 'function') previousResizeObserver.disconnect();
        if (typeof window.ResizeObserver === 'function') {
            const resizeObserver = new window.ResizeObserver(function (entries) {
                const current = parseInt($root.data('mobile-round'), 10) || 0;
                if (entries.some(function (entry) { return parseInt($(entry.target).data('mobile-stage'), 10) === current; })) syncStageHeight(current);
            });
            $stages.find(stageSelector).each(function () { resizeObserver.observe(this); });
            $root.data('mobile-resize-observer', resizeObserver);
        }

        activateRound(0, { animate: false, centerNav: false });
    }

    function render(selector) {
        const $root = $(selector);
        if (!$root.length) return;

        const raw = $root.find('.match[data-match-id]').add($root.children('.match[data-match-id]')).toArray();
        if (!raw.length) return;

        $root.addClass('bracket-root');
        let $wrap = $root.children('.bracket-wrap');
        if (!$wrap.length) {
            $wrap = $('<div class="bracket-wrap"></div>').appendTo($root);
        }
        let $content = $wrap.children('.bracket-content');
        if (!$content.length) $content = $('<div class="bracket-content"></div>').appendTo($wrap);
        let $scale = $content.children('.bracket-scale');
        if (!$scale.length) $scale = $('<div class="bracket-scale"></div>').appendTo($content);

        const matches = raw.map(function (el) {
            const $el = $(el);
            return { el: el, order: parseInt($el.data('fixtur-order') || 0, 10), type: $el.data('match-type') || '' };
        });

        const map = {};
        matches.forEach(function (m) {
            const k = roundKey(m.order, m.type);
            map[k] = map[k] || [];
            map[k].push(m);
        });

        const groups = Object.keys(map).map(function (k) {
            return map[k].sort(function (a, b) { return a.order - b.order; });
        });

        if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
            renderMobileBracket($root, groups);
            return;
        }

        $root.removeClass('is-mobile-bracket');
        $root.children('.bracket-mobile-shell').remove();

        $scale.empty();

        const colW = 280, matchW = 220, matchH = 104, top = 76, gap = 34, left = 32;
        const maxRows = Math.max.apply(null, groups.map(function (g) { return g.length; }));
        const contentW = Math.max(360, left * 2 + groups.length * colW);
        const contentH = Math.max(260, top + maxRows * (matchH + gap) + 70);

        $content.css({ width: contentW, height: contentH });
        $scale.css({ width: contentW, height: contentH });

        const placed = [];
        groups.forEach(function (group, colIndex) {
            const x = left + colIndex * colW;
            placed[colIndex] = [];

            $('<div class="round-header fs-07"></div>').text(group[0] ? group[0].type : ('Tur ' + (colIndex + 1))).css({ left: x + matchW / 2 }).appendTo($scale);

            group.forEach(function (m, rowIndex) {
                const y = top + rowIndex * (matchH + gap);
                const $el = $(m.el).detach().css({ position: 'absolute', left: x, top: y, width: matchW, height: matchH, margin: 0 });
                $scale.append($el);
                placed[colIndex][rowIndex] = { x: x, y: y, cy: y + matchH / 2 };
            });
        });

        for (let col = 0; col < placed.length - 1; col++) {
            for (let row = 0; row < placed[col].length; row++) {
                const source = placed[col][row];
                const target = placed[col + 1][Math.floor(row / 2)];
                if (!source || !target) continue;
                const startX = source.x + matchW;
                const endX = target.x;
                const elbowX = Math.round((startX + endX) / 2);
                const sourcePairA = placed[col][Math.floor(row / 2) * 2];
                const sourcePairB = placed[col][Math.floor(row / 2) * 2 + 1];
                const pairY = sourcePairB ? Math.round((sourcePairA.cy + sourcePairB.cy) / 2) : source.cy;

                appendLine($scale, startX, source.cy, elbowX - startX, 2);
                appendLine($scale, elbowX, source.cy, 2, pairY - source.cy);
                appendLine($scale, elbowX, pairY, endX - elbowX, 2);
                if (Math.abs(pairY - target.cy) > 2) appendLine($scale, endX, Math.min(pairY, target.cy), 2, Math.abs(pairY - target.cy));
            }
        }

        ensureZoom($root, $wrap, $content, $scale);
        ensureRoundNavigator($root, $wrap, groups, colW, left, matchW);
    }

    function ensureRoundNavigator($root, $wrap, groups, colW, left, matchW) {
        $root.children('.bracket-round-navigator').remove();
        if (!groups.length) return;

        const buttons = groups.map(function (group, index) {
            const label = group[0] ? group[0].type : ('Tur ' + (index + 1));
            const icon = index === groups.length - 1 ? 'fa-trophy' : 'fa-chevron-right';
            return `<button type="button" class="bracket-round-nav-item ${index === 0 ? 'active' : ''}" data-bracket-round="${index}"><i class="fa-solid ${icon}"></i><span class="fs-06">${$('<div/>').text(label).html()}</span></button>`;
        }).join('');

        const $navigator = $(`
            <div class="bracket-round-navigator" aria-label="Eleme turları">
                <button type="button" class="bracket-round-nav-arrow" data-bracket-nav-direction="prev" aria-label="Önceki tur"><i class="fa-solid fa-arrow-left"></i></button>
                <div class="bracket-round-nav-track">${buttons}</div>
                <button type="button" class="bracket-round-nav-arrow" data-bracket-nav-direction="next" aria-label="Sonraki tur"><i class="fa-solid fa-arrow-right"></i></button>
            </div>`).appendTo($root);

        function focusRound(index, animate) {
            index = Math.max(0, Math.min(groups.length - 1, index));
            const zoom = parseFloat($root.data('zoom') || 1);
            const columnCenter = (left + index * colW + matchW / 2) * zoom;
            const target = Math.max(0, columnCenter - ($wrap.innerWidth() / 2));
            $root.data('active-bracket-round', index);
            $navigator.find('.bracket-round-nav-item').removeClass('active').filter(`[data-bracket-round="${index}"]`).addClass('active')[0]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            $navigator.find('[data-bracket-nav-direction="prev"]').prop('disabled', index === 0);
            $navigator.find('[data-bracket-nav-direction="next"]').prop('disabled', index === groups.length - 1);
            $wrap.stop(true).animate({ scrollLeft: target }, animate === false ? 0 : 320, 'swing');
        }

        $navigator
            .off('.tbracketround')
            .on('click.tbracketround', '.bracket-round-nav-item', function () {
                focusRound(parseInt($(this).data('bracket-round'), 10) || 0);
            })
            .on('click.tbracketround', '.bracket-round-nav-arrow', function () {
                const current = parseInt($root.data('active-bracket-round'), 10) || 0;
                focusRound(current + ($(this).data('bracket-nav-direction') === 'next' ? 1 : -1));
            });

        let scrollFrame = null;
        $wrap.off('scroll.tbracketround').on('scroll.tbracketround', function () {
            if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
            scrollFrame = window.requestAnimationFrame(function () {
                const zoom = parseFloat($root.data('zoom') || 1);
                const viewportCenter = $wrap.scrollLeft() + ($wrap.innerWidth() / 2);
                const rawIndex = Math.round(((viewportCenter / zoom) - left - (matchW / 2)) / colW);
                const index = Math.max(0, Math.min(groups.length - 1, rawIndex));
                $root.data('active-bracket-round', index);
                $navigator.find('.bracket-round-nav-item').removeClass('active').filter(`[data-bracket-round="${index}"]`).addClass('active');
                $navigator.find('[data-bracket-nav-direction="prev"]').prop('disabled', index === 0);
                $navigator.find('[data-bracket-nav-direction="next"]').prop('disabled', index === groups.length - 1);
            });
        });

        focusRound(0, false);
    }

    function ensureZoom($root, $wrap, $content, $scale) {
        if (!$root.children('.bracket-zoom-controls').length) {
            $root.append(`
                <div class="bracket-zoom-controls">
                    <button type="button" class="btn fs-08" data-z="out" title="Uzaklaştır"><i class="fa-solid fa-minus"></i></button>
                    <span class="zoom-label fs-07">100%</span>
                    <button type="button" class="btn fs-08" data-z="in" title="Yakınlaştır"><i class="fa-solid fa-plus"></i></button>
                    <button type="button" class="btn fs-08" data-z="fit" title="Ekrana sığdır"><i class="fa-solid fa-up-right-and-down-left-from-center"></i></button>
                    <button type="button" class="btn fs-08" data-z="reset" title="Sıfırla"><i class="fa-solid fa-rotate-left"></i></button>
                    <button type="button" class="btn fs-08" data-z="full" title="Tam ekran"><i class="fa-solid fa-expand"></i></button>
                </div>`);
        }
        let zoom = parseFloat($root.data('zoom') || 1);
        applyZoom($root, $content, $scale, zoom);

        $root.off('click.tbracket').on('click.tbracket', '.bracket-zoom-controls .btn', function () {
            const action = $(this).data('z');
            if (action === 'full') {
                const $card = $root.closest('.tw-bracket-card');
                $card.toggleClass('is-fullscreen');
                $('body').toggleClass('tw-body-lock', $card.hasClass('is-fullscreen'));
                $(this).find('i').toggleClass('fa-expand fa-compress');
                setTimeout(function () { applyZoom($root, $content, $scale, zoom); }, 80);
                return;
            }
            if (action === 'reset') zoom = 1;
            else if (action === 'fit') {
                const baseW = parseFloat($scale.css('width')) || 1;
                const baseH = parseFloat($scale.css('height')) || 1;
                const fitW = Math.max(0.45, ($root.width() - 56) / baseW);
                const fitH = Math.max(0.45, ($root.height() - 82) / baseH);
                zoom = Math.min(1.35, Math.max(0.45, Math.min(fitW, fitH)));
                $wrap.scrollLeft(0).scrollTop(0);
            }
            else zoom += action === 'in' ? 0.1 : -0.1;
            zoom = Math.max(0.45, Math.min(2, zoom));
            $root.data('zoom', zoom);
            applyZoom($root, $content, $scale, zoom);
        });

        $root.off('wheel.tbracket').on('wheel.tbracket', function (e) {
            if (!e.ctrlKey && !e.metaKey) return;
            e.preventDefault();
            zoom += e.originalEvent.deltaY < 0 ? 0.08 : -0.08;
            zoom = Math.max(0.45, Math.min(2, zoom));
            $root.data('zoom', zoom);
            applyZoom($root, $content, $scale, zoom);
        });

        let isDown = false, sx = 0, sy = 0, sl = 0, st = 0;
        $wrap.off('mousedown.tbracket touchstart.tbracket').on('mousedown.tbracket touchstart.tbracket', function (e) {
            if ($(e.target).closest('.match, button, a, input, select, textarea').length) return;
            const point = e.originalEvent.touches ? e.originalEvent.touches[0] : e;
            isDown = true; sx = point.pageX; sy = point.pageY; sl = $wrap.scrollLeft(); st = $wrap.scrollTop();
            e.preventDefault();
        });
        $(document).off('mousemove.tbracket mouseup.tbracket touchmove.tbracket touchend.tbracket')
            .on('mousemove.tbracket touchmove.tbracket', function (e) {
                if (!isDown) return;
                const point = e.originalEvent.touches ? e.originalEvent.touches[0] : e;
                $wrap.scrollLeft(sl - (point.pageX - sx));
                $wrap.scrollTop(st - (point.pageY - sy));
            })
            .on('mouseup.tbracket touchend.tbracket', function () { isDown = false; });
    }

    function applyZoom($root, $content, $scale, zoom) {
        $scale.css({ transform: `scale(${zoom})`, transformOrigin: '0 0' });
        const w = parseFloat($scale.css('width')) || 0;
        const h = parseFloat($scale.css('height')) || 0;
        $content.css({ width: w * zoom, height: h * zoom });
        $root.find('.zoom-label').text(Math.round(zoom * 100) + '%');
    }

    window.TournamentBracketRenderer = { render: render };
})(window, window.jQuery);


$(document).on("click", '.loadTournamentCommentsBtn', function () {

    updateTournamentComments();
});
$(document).on("click", '.loadAllTournamentMatchFinderAreas', function () {

    loadAllTournamentMatchFinderAreas();
});
$(document).on("click", '.loadFixtureDiv', function () {

    loadFixtureDiv();
});

async function loadFixtureDiv(editable = false) {
    const $fixtureArea = $('#FixtureArea');
    const tournamentId = Number($fixtureArea.data("tournament") || 0);

    InitLoadScreenElement($fixtureArea);

    if (!tournamentId) {
        $("#modalError").html("Turnuva bilgisi bulunamadı.");
        return;
    }

    InitLoadScreen('#FixtureArea');

    try {
        const response = await $.ajax({
            url: '/Tournament/State',
            type: 'GET',
            data: {
                id: tournamentId
            },
            cache: false
        });

        const state = normalizeTournamentWizardKeys(response && response.state ? response.state : response);

        if (!state || !state.tournament) {
            $("#modalError").html("Fikstür bilgisi alınamadı.");
            return;
        }

        $fixtureArea
            .attr('data-editable', editable ? 'true' : 'false')
            .data('fixture-state', state)
            .html(renderTournamentFixtureArea(state, editable));

        setTimeout(function () {
            if (window.TournamentBracketRenderer && typeof window.TournamentBracketRenderer.render === 'function') {
                window.TournamentBracketRenderer.render('#tw-bracket-root');
            }
            else if (window.BracketRenderer && typeof window.BracketRenderer.render === 'function') {
                window.BracketRenderer.render('#tw-bracket-root');
            }

            if (typeof draggableCardBuilder === 'function') {
                draggableCardBuilder();
            }
        }, 30);
    }
    catch (error) {
        $("#modalError").html(
            error?.responseText ||
            error?.responseJSON?.message ||
            "Bilinmeyen bir hata oluştu."
        );
    }
}

function normalizeTournamentWizardKeys(value) {
    if ($.isArray(value)) {
        return $.map(value, normalizeTournamentWizardKeys);
    }

    if (value && typeof value === 'object') {
        const result = {};

        Object.keys(value).forEach(function (key) {
            const normalizedKey = (!key || key[0] === '_' || key[0] === key[0].toLowerCase())
                ? key
                : key[0].toLowerCase() + key.slice(1);

            result[normalizedKey] = normalizeTournamentWizardKeys(value[key]);
        });

        return result;
    }

    return value;
}

function renderTournamentFixtureArea(state, editable) {
    const tournament = state.tournament || {};
    const matches = state.dateRelations || [];

    const groupMatches = matches.filter(function (m) {
        return Number(m.fixtureTypeEnum) === 2;
    });

    const knockoutMatches = matches.filter(function (m) {
        return Number(m.fixtureTypeEnum) === 1;
    });

    const gameType = Number(tournament.tournamentGameTypeEnum || 1);
    const gameTypeText = getTournamentFixtureGameTypeText(state, gameType);

    if (!matches.length) {
        return `
            <div class="tw-empty m-2">
                <i class="fa-solid fa-circle-info"></i>
                <span class="fs-07">Fikstür henüz oluşturulmadı.</span>
            </div>
        `;
    }

    return `
        <div class="tw-public-fixture-view" data-editable="${editable ? 'true' : 'false'}">
            <div class="tw-fixture-summary m-2">
                <div>
                    <strong class="fs-08">${matches.length}</strong>
                    <span class="fs-06">Toplam maç</span>
                </div>
                <div>
                    <strong class="fs-08">${groupMatches.length}</strong>
                    <span class="fs-06">Grup maçı</span>
                </div>
                <div>
                    <strong class="fs-08">${knockoutMatches.length}</strong>
                    <span class="fs-06">Eleme maçı</span>
                </div>
                <div>
                    <strong class="fs-08">${escapeTournamentFixtureHtml(gameTypeText)}</strong>
                    <span class="fs-06">Fikstür modeli</span>
                </div>
            </div>

            ${renderTournamentFixtureByType(gameType, groupMatches, knockoutMatches)}
        </div>
    `;
}

function renderTournamentFixtureByType(gameType, groupMatches, knockoutMatches) {
    if (gameType === 1) {
        return renderTournamentKnockoutBracket(knockoutMatches);
    }

    if (gameType === 2 || gameType === 4) {
        const hasFixtureGroups = groupMatches.some(function (match) {
            return Number(match.fixtureGroupIndex || match.matchIndex || 0) > 0 || !!match.fixtureGroupName;
        });
        return renderTournamentGroupMatches(groupMatches, gameType === 4 || hasFixtureGroups);
    }

    return `
        <div class="tw-tab-scope tw-fixture-type-tabs tw-fixture-stage-shell is-hybrid">
            <div class="tw-mini-tabs m-2">
                <button type="button" class="tw-mini-tab fs-07 active" data-target="groups">Gruplar</button>
                <button type="button" class="tw-mini-tab fs-07" data-target="knockout">Eleme</button>
            </div>

            <div class="tw-mini-pane" data-pane="groups">
                ${renderTournamentGroupMatches(groupMatches, true)}
            </div>

            <div class="tw-mini-pane d-none" data-pane="knockout">
                ${renderTournamentKnockoutBracket(knockoutMatches)}
            </div>
        </div>
    `;
}

function renderTournamentGroupMatches(matches, groupMode) {
    if (!matches.length) {
        return `
            <div class="tw-empty m-2">
                <i class="fa-solid fa-circle-info"></i>
                <span class="fs-07">Grup maçı yok.</span>
            </div>
        `;
    }

    const grouped = {};

    $.each(matches, function (_, match) {
        const key = groupMode
            ? (match.fixtureGroupName || `Grup ${match.fixtureGroupIndex || match.matchIndex || 1}`)
            : 'Fikstür';

        grouped[key] = grouped[key] || [];
        grouped[key].push(match);
    });

    function renderPublicRoundBlocks(list) {
        const rounds = {};

        $.each(list, function (_, match) {
            const roundKey = `Hafta ${Number(match.roundIndex || 1) || 1}`;
            rounds[roundKey] = rounds[roundKey] || [];
            rounds[roundKey].push(match);
        });

        return `
            <div class="tw-round-stack">
                ${Object.keys(rounds).sort(function (a, b) {
            return Number(a.replace(/\D/g, '') || 0) - Number(b.replace(/\D/g, '') || 0);
        }).map(function (roundKey) {
            const roundList = rounds[roundKey].sort(function (a, b) {
                return Number(a.fixturOrder || 0) - Number(b.fixturOrder || 0);
            });

            return `
                        <div class="tw-round-block is-collapsed">
                            <button type="button" class="tw-round-toggle fs-06" aria-expanded="false">
                                <span class="tw-round-title"><i class="fa-solid fa-calendar-week me-1"></i>${escapeTournamentFixtureHtml(roundKey)}</span>
                                <span class="tw-round-meta">${roundList.length} maç${roundList.length && roundList[0].dateLabel ? ' • ' + escapeTournamentFixtureHtml(roundList[0].dateLabel) : ''}</span>
                                <i class="fa-solid fa-chevron-down tw-round-chevron"></i>
                            </button>
                            <div class="tw-round-content d-none">
                                ${roundList.map(renderTournamentGroupMatchRow).join('')}
                            </div>
                        </div>
                    `;
        }).join('')}
            </div>
        `;
    }

    return `
        <div class="row m-0 tw-group-grid">
            ${Object.keys(grouped).sort(function (a, b) {
        const first = grouped[a][0] || {};
        const second = grouped[b][0] || {};
        return Number(first.fixtureGroupIndex || 0) - Number(second.fixtureGroupIndex || 0);
    }).map(function (key) {
        const list = grouped[key].sort(function (a, b) {
            return Number(a.fixturOrder || 0) - Number(b.fixturOrder || 0);
        });

        const roundCount = Object.keys(list.reduce(function (acc, match) {
            const roundKey = `Hafta ${Number(match.roundIndex || 1) || 1}`;
            acc[roundKey] = true;
            return acc;
        }, {})).length;

        if (groupMode) {
            return `
                    <div class="col-12 col-xl-6 p-2">
                        <div class="tw-panel tw-fixture-group-block is-collapsed">
                            <button type="button" class="tw-panel-head tw-group-pro-head tw-fixture-group-toggle" aria-expanded="false">
                                <div class="tw-fixture-group-title">
                                    <strong class="fs-08">${escapeTournamentFixtureHtml(key)}</strong>
                                    <span class="fs-07 ms-2">${list.length} maç • ${roundCount} hafta</span>
                                </div>
                                <span class="tw-stage-chip fs-06"><i class="fa-solid fa-layer-group me-1"></i>Grup</span>
                                <i class="fa-solid fa-chevron-down tw-fixture-group-chevron"></i>
                            </button>

                            <div class="tw-fixture-group-content d-none">
                                ${renderPublicRoundBlocks(list)}
                            </div>
                        </div>
                    </div>
                `;
        }

        return `
                    <div class="col-12 p-2">
                        <div class="tw-panel">
                            <div class="tw-panel-head">
                                <strong class="fs-08">${escapeTournamentFixtureHtml(key)}</strong>
                                <span class="fs-07 ms-2">${list.length} maç</span>
                            </div>

                            ${renderPublicRoundBlocks(list)}
                        </div>
                    </div>
                `;
    }).join('')}
        </div>
    `;
}

function compactTournamentSlotLabel(slotLabel, slotIndex, side) {
    const raw = String(slotLabel == null ? '' : slotLabel).trim();
    const index = Number.parseInt(slotIndex || 0, 10) || 0;
    const lower = raw.toLocaleLowerCase('tr-TR');

    if (raw && (lower.indexOf('bekleyen') >= 0 || lower.indexOf('kazanan') >= 0)) {
        return raw;
    }

    let number = index;
    if (number <= 0 && raw) {
        const matches = raw.match(/\d+/g);
        if (matches && matches.length) {
            number = Number.parseInt(matches[matches.length - 1], 10) || 0;
        }
    }

    if (number > 0) return `Takım ${String(number).padStart(2, '0')}`;
    if (raw) return raw.replace(/\bslot\b/ig, 'Takım');
    return side === 'away' ? 'Rakip Takım' : 'Ev Sahibi Takım';
}

function sameTournamentFixtureText(a, b) {
    return String(a || '').trim().toLocaleLowerCase('tr-TR') === String(b || '').trim().toLocaleLowerCase('tr-TR');
}

function tournamentSlotBadgeHtml(side) {
    if (!side || !side.slotLabel || sameTournamentFixtureText(side.name, side.slotLabel)) return '';

    return ``;
}

function getPublicFixtureSide(match, side) {
    const isAway = side === 'away';
    const id = Number(isAway ? (match._TeamId || match._teamId || 0) : (match.teamId || 0));
    const slotIndex = Number(isAway ? (match._TeamSlotIndex || match._teamSlotIndex || 0) : (match.teamSlotIndex || 0));
    const rawSlotLabel = isAway ? (match._TeamSlotLabel || match._teamSlotLabel) : match.teamSlotLabel;
    const slotLabel = compactTournamentSlotLabel(rawSlotLabel, slotIndex, side);
    return {
        id: id,
        name: id > 0 ? (isAway ? (match._TeamName || match._teamName || match.team2Name) : match.teamName) || slotLabel : slotLabel,
        img: id > 0 ? ((isAway ? (match._TeamImg || match._teamImg || match.team2Img) : match.teamImg) || 'https://sahasenin.com/avatar.webp') : 'https://sahasenin.com/avatar.webp',
        slotLabel: slotLabel,
        isEmpty: id <= 0
    };
}

function renderTournamentGroupMatchRow(match) {
    const home = getPublicFixtureSide(match, 'home');
    const away = getPublicFixtureSide(match, 'away');
    const hasEmptySlot = home.isEmpty || away.isEmpty;

    return `
        <button type="button"
                class="tw-group-match tw-group-match-pro fs-07 OpenTournamentDateForm ${hasEmptySlot ? 'has-empty-slot' : ''}"
                data-id="${escapeTournamentFixtureAttr(match.tournamentDateRelationId)}">

            <span class="tw-match-topline">
                <span class="tw-date-chip fs-06"><i class="fa-solid fa-clock me-1"></i>${escapeTournamentFixtureHtml(match.dateLabel || 'Tarih yok')}</span>
                <span class="tw-match-action-pill fs-06"><i class="fa-solid fa-futbol me-1"></i>Maç</span>
            </span>

            <span class="tw-match-teams">
                <span class="tw-match-team is-home ${home.isEmpty ? 'is-empty-slot' : ''}">
                    <img src="${escapeTournamentFixtureAttr(home.img)}" alt="${escapeTournamentFixtureAttr(home.name)}">
                    <span><strong class="fs-07">${escapeTournamentFixtureHtml(home.name)}</strong>${tournamentSlotBadgeHtml(home)}</span>
                </span>

                <span class="tw-match-versus fs-06">vs</span>

                <span class="tw-match-team is-away ${away.isEmpty ? 'is-empty-slot' : ''}">
                    <span><strong class="fs-07">${escapeTournamentFixtureHtml(away.name)}</strong>${tournamentSlotBadgeHtml(away)}</span>
                    <img src="${escapeTournamentFixtureAttr(away.img)}" alt="${escapeTournamentFixtureAttr(away.name)}">
                </span>
            </span>

            ${match.winnerTeamId ? `
                <span class="tw-match-result-pill fs-06">
                    Kazanan: ${escapeTournamentFixtureHtml(match.winnerTeamName || '')}
                </span>
            ` : ''}
        </button>
    `;
}

function renderTournamentKnockoutBracket(matches) {
    if (!matches.length) {
        return `
            <div class="tw-empty m-2">
                <i class="fa-solid fa-circle-info"></i>
                <span class="fs-07">Eleme maçı yok.</span>
            </div>
        `;
    }

    const orderedMatches = matches.slice().sort(function (a, b) {
        return Number(a.fixturOrder || 0) - Number(b.fixturOrder || 0);
    });

    return `
        <div class="tw-bracket-card m-2">
            <div id="tw-bracket-root" class="bracket-root">
                ${orderedMatches.map(renderTournamentBracketMatch).join('')}
            </div>
        </div>
    `;
}

function renderTournamentBracketMatch(match) {
    const home = getPublicFixtureSide(match, 'home');
    const away = getPublicFixtureSide(match, 'away');

    return `
        <button type="button"
                class="match OpenTournamentDateForm"
                data-match-id="${escapeTournamentFixtureAttr(match.tournamentDateRelationId)}"
                data-fixtur-order="${escapeTournamentFixtureAttr(match.fixturOrder || 0)}"
                data-match-type="${escapeTournamentFixtureAttr(match.matchTypeLabel || 'Tur')}"
                data-id="${escapeTournamentFixtureAttr(match.tournamentDateRelationId)}">

            <div class="team-row">
                <div class="team-left">
                    <img class="avatar br-calc" src="${escapeTournamentFixtureAttr(home.img)}" alt="">
                    <span class="team-name fs-07">${escapeTournamentFixtureHtml(home.name)}</span>
                </div>
                <span class="team-score fs-07">${Number(match.winnerTeamId || 0) === Number(home.id || 0) && home.id > 0 ? '?' : '-'}</span>
            </div>

            <div class="team-row">
                <div class="team-left">
                    <img class="avatar br-calc" src="${escapeTournamentFixtureAttr(away.img)}" alt="">
                    <span class="team-name fs-07">${escapeTournamentFixtureHtml(away.name)}</span>
                </div>
                <span class="team-score fs-07">${Number(match.winnerTeamId || 0) === Number(away.id || 0) && away.id > 0 ? '?' : '-'}</span>
            </div>

            <div class="match-meta">
                <strong class="fs-06">${escapeTournamentFixtureHtml(match.matchTypeLabel || 'Tur')}</strong>
                <span class="fs-06">${escapeTournamentFixtureHtml(match.dateLabel || '')}</span>
            </div>
        </button>
    `;
}

function getTournamentFixtureGameTypeText(state, value) {
    const enums = state.definitions || state.enums || {};
    const list = enums.tournamentGameTypes || [];

    const item = list.find(function (x) {
        return Number(x.value) === Number(value);
    });

    return item ? item.text : '-';
}

function escapeTournamentFixtureHtml(value) {
    return $('<div/>').text(value == null ? '' : String(value)).html();
}

function escapeTournamentFixtureAttr(value) {
    return escapeTournamentFixtureHtml(value).replace(/"/g, '&quot;');
}

$(document)
    .off('click.publicFixtureTabs')
    .on('click.publicFixtureTabs', '.tw-mini-tab', function (e) {
        const target = String($(this).data('target') || '');
        const $scope = $(this).closest('.tw-tab-scope');
        if (!target || !$scope.length) return;

        e.preventDefault();
        e.stopPropagation();

        $scope.children('.tw-mini-tabs').find('.tw-mini-tab').removeClass('active');
        $(this).addClass('active');

        $scope.children('.tw-mini-pane').addClass('d-none');
        $scope.children(`.tw-mini-pane[data-pane="${target}"]`).removeClass('d-none');

        setTimeout(function () {
            if (window.TournamentBracketRenderer && typeof window.TournamentBracketRenderer.render === 'function') {
                window.TournamentBracketRenderer.render('#tw-bracket-root');
            }
            else if (window.BracketRenderer && typeof window.BracketRenderer.render === 'function') {
                window.BracketRenderer.render('#tw-bracket-root');
            }
        }, 30);
    })
    .on('click.publicFixtureTabs', '.tw-round-toggle', function (e) {
        const $button = $(this);

        // Turnuva düzenleme modalı kendi handler'ını kullanır.
        // Aksi halde public handler aynı click'te ikinci kez tetiklenip collapse'ı geri kapatır.
        if ($button.closest('#TournamentBuilderOverlay, #TournamentBuilderRoot').length) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const $block = $button.closest('.tw-round-block');
        const $content = $block.children('.tw-round-content');

        if (!$block.length || !$content.length) return;

        const willOpen = $block.hasClass('is-collapsed');

        $block.toggleClass('is-collapsed', !willOpen);
        $button.attr('aria-expanded', willOpen ? 'true' : 'false');

        if (willOpen) {
            $content
                .stop(true, true)
                .removeClass('d-none')
                .prop('hidden', false)
                .css('display', 'none')
                .slideDown(160);
        } else {
            $content
                .stop(true, true)
                .slideUp(160, function () {
                    $(this)
                        .addClass('d-none')
                        .prop('hidden', true)
                        .css('display', '');
                });
        }
    })
    .on('click.publicFixtureTabs', '.tw-fixture-group-toggle', function (e) {
        const $button = $(this);

        // Turnuva düzenleme modalı kendi handler'ını kullanır.
        // Aksi halde public handler aynı click'te ikinci kez tetiklenip collapse'ı geri kapatır.
        if ($button.closest('#TournamentBuilderOverlay, #TournamentBuilderRoot').length) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const $block = $button.closest('.tw-fixture-group-block');
        const $content = $block.children('.tw-fixture-group-content');

        if (!$block.length || !$content.length) return;

        const willOpen = $block.hasClass('is-collapsed');

        $block.toggleClass('is-collapsed', !willOpen);
        $button.attr('aria-expanded', willOpen ? 'true' : 'false');

        if (willOpen) {
            $content
                .stop(true, true)
                .removeClass('d-none')
                .prop('hidden', false)
                .css('display', 'none')
                .slideDown(160);
        } else {
            $content
                .stop(true, true)
                .slideUp(160, function () {
                    $(this)
                        .addClass('d-none')
                        .prop('hidden', true)
                        .css('display', '');
                });
        }
    });


$(document).on("click", ".loadTournamentMediaArea", function () {

    loadTournamentMediaArea();
});
async function loadTournamentMediaArea() {

    var element = $('#div_Media');

    InitLoadScreenElement(element);

    if (element.length > 0) {

        var tournamentId = element.data('tournament');

        Request({
            url: '/_TournamentMediaArea',
            type: 'POST',
            data: {
                tournamentId: tournamentId
            }
        }).then((response) => {

            element.html(response);

        }).catch((error) => {
            element.html(error.responseText);
        });
    }
}

async function loadTournamentHighListArea() {

    var element = $('#_TournamentHighlightsArea');

    InitLoadScreenElement(element);

    if (element.length > 0) {

        var tournamentId = element.data('id');

        Request({
            url: '/Tournament/_TournamentHighlightsArea',
            type: 'POST',
            data: {
                id: tournamentId
            }
        }).then((response) => {

            element.html(response);

        }).catch((error) => {
            element.html(error.responseText);
        });
    }
}


function safeRefreshTournamentFixtureArea(tournamentId, rebuildFixture) {
    tournamentId = Number(tournamentId || 0);

    const refreshOnly = function () {
        if (typeof refresh === 'function') {
            refresh(false);
            return;
        }

        if (window.TournamentBuilder && typeof window.TournamentBuilder.refresh === 'function') {
            window.TournamentBuilder.refresh(false);
            return;
        }

        if (typeof loadFixtureDiv === 'function') {
            loadFixtureDiv(true);
        }
    };

    if (rebuildFixture && tournamentId > 0) {
        const currentState = window.TournamentBuilder && typeof window.TournamentBuilder.getState === 'function'
            ? window.TournamentBuilder.getState()
            : null;

        if (currentState && currentState.tournament && Number(currentState.tournament.tournamentId) === tournamentId && typeof window.TournamentBuilder.rebuildFixtureAfterTeamChange === 'function') {
            window.TournamentBuilder.rebuildFixtureAfterTeamChange({ tournamentId: tournamentId, step: 'teams' });
            return;
        }

        $.ajax({
            url: '/Tournament/RebuildFixture',
            type: 'POST',
            data: { id: tournamentId }
        }).always(function () {
            refreshOnly();
        });
        return;
    }

    refreshOnly();
}

$(document).on("click", ".AddTournamentTeamRelation", function () {

    var element = $(this);
    element.addClass('opacity-50');

    var tournamentId = element.data('tournament');
    var teamId = element.data('team');

    Request({
        url: '/Tournament/AddTournamentTeamRelation',
        type: 'POST',
        data: {
            tournamentId: tournamentId,
            teamId: teamId
        },
        success: function () {

            updateGlobalRequestCards();
            syncGlobalActionBtnAreas();

            safeRefreshTournamentFixtureArea(tournamentId, true);
        },
        error: function (xhr) {

            var message = xhr?.responseText || xhr?.statusText || "Turnuvaya katılım isteği gönderilirken bir hata oluştu.";

            ShowErrorAlert(message);
        }
    });
});


$(document).on("click", ".RemoveTournamentTeamRelation", function () {

    var element = $(this);
    element.addClass('opacity-50');

    var tournamentId = element.data('tournament');
    var teamId = element.data('team');

    Request({
        url: '/Tournament/RemoveTournamentTeamRelation',
        type: 'POST',
        data: {
            tournamentId: tournamentId,
            teamId: teamId
        },
        success: function () {

            updateGlobalRequestCards();
            syncGlobalActionBtnAreas();

            safeRefreshTournamentFixtureArea(tournamentId, true);
        },
        error: function (xhr) {

            var message = xhr?.responseText || xhr?.statusText || "Turnuvaya katılım isteği gönderilirken bir hata oluştu.";

            ShowErrorAlert(message);
        }
    });
});

$(document).on("click", ".CancelTournamentTeamRelation", function () {

    var element = $(this);
    element.addClass('opacity-50');

    var tournamentId = element.data('tournament');
    var teamId = element.data('team');

    Request({
        url: '/Tournament/CancelTournamentTeamRelation',
        type: 'POST',
        data: {
            tournamentId: tournamentId,
            teamId: teamId
        },
        success: function () {

            updateGlobalRequestCards();
            syncGlobalActionBtnAreas();

            safeRefreshTournamentFixtureArea(tournamentId, true);
        },
        error: function (xhr) {

            var message = xhr?.responseText || xhr?.statusText || "Turnuvaya katılım isteği gönderilirken bir hata oluştu.";

            ShowErrorAlert(message);
        }
    });
});

$(document).on("click", ".LeaveTournamentTeamRelation", function () {

    var element = $(this);
    element.addClass('opacity-50');

    var tournamentId = element.data('tournament');
    var teamId = element.data('team');

    Request({
        url: '/Tournament/LeaveTournamentTeamRelation',
        type: 'POST',
        data: {
            tournamentId: tournamentId,
            teamId: teamId
        },
        success: function () {

            updateGlobalRequestCards();
            syncGlobalActionBtnAreas();

            safeRefreshTournamentFixtureArea();
        },
        error: function (xhr) {

            var message = xhr?.responseText || xhr?.statusText || "Turnuvaya katılım isteği gönderilirken bir hata oluştu.";

            ShowErrorAlert(message);
        }
    });
});

$(document).on("click", ".AddTournamentTeamJoinRequest", function () {

    var element = $(this);
    element.addClass('opacity-50');

    var id = element.data('id');

    Request({
        url: '/Tournament/AddTournamentTeamJoinRequest',
        type: 'POST',
        data: {
            tournamentId: id
        },
        success: function () {

            updateGlobalRequestCards();
            syncGlobalActionBtnAreas();

            safeRefreshTournamentFixtureArea();
        },
        error: function (xhr) {

            var message = xhr?.responseText || xhr?.statusText || "Turnuvaya katılım isteği gönderilirken bir hata oluştu.";

            ShowErrorAlert(message);
        }
    });
});





$(document).on("change", "._TournamentMatchFinderElement", function () {

    var element = $(this);
    var val = element.val();
    var searchType = element.data('type');
    var tournamentId = element.data('tournament');

    var target = $(`._TournamentMatchFinderArea[data-id="${searchType}"]`);

    Request({
        url: '/Tournament/_TournamentMatchFinderArea',
        type: 'POST',
        data: {
            id: tournamentId,
            searchType: searchType,
            value: val,
            date: val
        },
        success: function (response) {

            target.html(response);

            draggableCardBuilder();
            syncMatchCountDown();
        },
        error: function (xhr, status, error) {
            target.html(`<span class="p-1 text-red">${xhr.responseText}</span>`);
        }
    });
});

function loadAllTournamentMatchFinderAreas() {
    $("._TournamentMatchFinderElement").each(function () {

        var element = $(this);
        var val = element.val();
        var searchType = element.data('type');
        var tournamentId = element.data('tournament');

        var target = $(`._TournamentMatchFinderArea[data-id="${searchType}"]`);

        InitLoadScreenElement(target);

        Request({
            url: '/Tournament/_TournamentMatchFinderArea',
            type: 'POST',
            data: {
                id: tournamentId,
                searchType: searchType,
                value: val,
                date: val
            },
            success: function (response) {
                target.html(response);
                draggableCardBuilder();
            },
            error: function (xhr, status, error) {
                target.html(`<span class="p-1 text-red">${xhr.responseText}</span>`);
            }
        });

    });
}
